/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports=function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";t.exports={doms:n(13),handler:n(80),helpers:n(85),views:n(189),baseView:n(10),init:n(180),animations:n(78)}},function(t,e,n){function r(t){return function e(n,r){switch(arguments.length){case 0:return e;case 1:return i(n)?e:o(function(e){return t(n,e)});default:return i(n)&&i(r)?e:i(n)?o(function(e){return t(e,r)}):i(r)?o(function(e){return t(n,e)}):t(n,r)}}}var o=n(2),i=n(41);t.exports=r},function(t,e,n){function r(t){return function e(n){return 0===arguments.length||o(n)?e:t.apply(this,arguments)}}var o=n(41);t.exports=r},function(t,e,n){function r(t){return function e(n,r,u){switch(arguments.length){case 0:return e;case 1:return a(n)?e:i(function(e,r){return t(n,e,r)});case 2:return a(n)&&a(r)?e:a(n)?i(function(e,n){return t(e,r,n)}):a(r)?i(function(e,r){return t(n,e,r)}):o(function(e){return t(n,r,e)});default:return a(n)&&a(r)&&a(u)?e:a(n)&&a(r)?i(function(e,n){return t(e,n,u)}):a(n)&&a(u)?i(function(e,n){return t(e,r,n)}):a(r)&&a(u)?i(function(e,r){return t(n,e,r)}):a(n)?o(function(e){return t(e,r,u)}):a(r)?o(function(e){return t(n,e,u)}):a(u)?o(function(e){return t(n,r,e)}):t(n,r,u)}}}var o=n(2),i=n(1),a=n(41);t.exports=r},function(t,e,n){function r(t,e,n){return function(){if(0===arguments.length)return n();var r=Array.prototype.slice.call(arguments,0),a=r.pop();if(!o(a)){for(var u=0;u<t.length;){if("function"==typeof a[t[u]])return a[t[u]].apply(a,r);u+=1}if(i(a)){var s=e.apply(null,r);return s(a)}}return n.apply(this,arguments)}}var o=n(19),i=n(65);t.exports=r},function(t,e){t.exports={init:function(){return this.xf["@@transducer/init"]()},result:function(t){return this.xf["@@transducer/result"](t)}}},function(t,e,n){var r=n(16),o=n(2),i=n(1),a=n(38),u=i(function(t,e){return 1===t?o(e):r(t,a(t,[],e))});t.exports=u},function(t,e){function n(t,e){return Object.prototype.hasOwnProperty.call(e,t)}t.exports=n},function(t,e,n){var r=n(1),o=n(4),i=n(42),a=n(12),u=n(281),s=n(6),c=n(17),f=r(o(["fantasy-land/map","map"],u,function(t,e){switch(Object.prototype.toString.call(e)){case"[object Function]":return s(e.length,function(){return t.call(this,e.apply(this,arguments))});case"[object Object]":return a(function(n,r){return n[r]=t(e[r]),n},{},c(e));default:return i(t,e)}}));t.exports=f},function(t,e,n){"use strict";function r(t){return"[object Array]"===b.call(t)}function o(t){return"[object ArrayBuffer]"===b.call(t)}function i(t){return"undefined"!=typeof FormData&&t instanceof FormData}function a(t){var e;return e="undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(t):t&&t.buffer&&t.buffer instanceof ArrayBuffer}function u(t){return"string"==typeof t}function s(t){return"number"==typeof t}function c(t){return"undefined"==typeof t}function f(t){return null!==t&&"object"==typeof t}function p(t){return"[object Date]"===b.call(t)}function l(t){return"[object File]"===b.call(t)}function d(t){return"[object Blob]"===b.call(t)}function h(t){return"[object Function]"===b.call(t)}function y(t){return f(t)&&h(t.pipe)}function v(t){return"undefined"!=typeof URLSearchParams&&t instanceof URLSearchParams}function w(t){return t.replace(/^\s*/,"").replace(/\s*$/,"")}function _(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function m(t,e){if(null!==t&&"undefined"!=typeof t)if("object"!=typeof t&&(t=[t]),r(t))for(var n=0,o=t.length;n<o;n++)e.call(null,t[n],n,t);else for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&e.call(null,t[i],i,t)}function x(){function t(t,n){"object"==typeof e[n]&&"object"==typeof t?e[n]=x(e[n],t):e[n]=t}for(var e={},n=0,r=arguments.length;n<r;n++)m(arguments[n],t);return e}function g(t,e,n){return m(e,function(e,r){n&&"function"==typeof e?t[r]=E(e,n):t[r]=e}),t}var E=n(77),I=n(190),b=Object.prototype.toString;t.exports={isArray:r,isArrayBuffer:o,isBuffer:I,isFormData:i,isArrayBufferView:a,isString:u,isNumber:s,isObject:f,isUndefined:c,isDate:p,isFile:l,isBlob:d,isFunction:h,isStream:y,isURLSearchParams:v,isStandardBrowserEnv:_,forEach:m,merge:x,extend:g,trim:w}},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(187),s=n(22).getOS;String.prototype.addCmd=function(t){return this.concat(t)},Array.prototype.addCmd=function(t){return this.push(t),this},window.__OS||(window.__OS=s());var c=void 0;c=n("ANDROID"==window.__OS?84:"WEB"==window.__OS?87:33);var f=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return window.__SETFN=function(t){Android.runInUI(this.set(t),null)}.bind(i),i.idSet={},i}return i(e,t),a(e,[{key:"findRecurse",value:function(t,e){for(var n=t.children,r=0;r<n.length;r++)n[r].displayName&&n[r].displayName==e&&this.foundChildren.push(n[r]),n[r].children&&n[r].children.length&&this.findRecurse(n[r],e)}},{key:"find",value:function(t,e){return this.foundChildren=[],e?this.findRecurse(e,t):this.findRecurse(this.layout,t),this.foundChildren}},{key:"id",value:function(t){return this.idSet[t]||(window.__ID++,this.idSet[t]=window.__ID),this.idSet[t]}},{key:"setIds",value:function(t){this.idSet||(this.idSet={});for(var e=0;e<t.length;e++)window.__ID++,this.idSet[t[e]]=window.__ID+""}},{key:"handleSpecialChars",value:function(t){return t=t.indexOf(",")>-1?t.replace(/\,/g,"\\\\,"):t,t=t.indexOf(":")>-1?t.replace(/\:/g,"\\\\:"):t,t=t.indexOf("=")>-1?t.replace(/\=/g,"\\\\="):t,t=t.indexOf(";")>-1?t.replace(/\;/g,"\\\\;"):t}},{key:"cmdForAndroid",value:function(t){var e,n="set_view=ctx->findViewById:i_"+t.id+";";return t.toast?n="set_TOAST=android.widget.Toast->makeText:ctx_ctx,cs_"+this.handleSpecialChars(t.text)+",i_"+("short"==t.duration?0:1)+";get_TOAST->show":t&&Object.keys(t).length&&(delete t.id,t.root="true",e=c("linearLayout",t,"get").runInUI,n+=e+";"),n}},{key:"cmdContainer",value:function(){return"ANDROID"==window.__OS?"":[]}},{key:"cmdForWeb",value:function(t){if(Object.keys(t).length)return c("linearLayout",t,"set")}},{key:"cmd",value:function(t){return"ANDROID"==window.__OS?this.cmdForAndroid(t):"WEB"==window.__OS?this.cmdForWeb(t):t}},{key:"appendChild",value:function(t,e,n,r,o){var i;o||(o=!1),r&&(i="F"+window.__FN_INDEX,window.__PROXY_FN[i]=r,window.__FN_INDEX++),e="ANDROID"!=window.__OS?e:JSON.stringify(e),i?Android.addViewToParent(t,e,n,i,o):Android.addViewToParent(t,e,n,null,o)}},{key:"getView",value:function(t){return"ANDROID"!=window.__OS?t:JSON.stringify(t)}},{key:"delete",value:function(t){return"set_VIEW=ctx->findViewById:i_"+t+";set_PARENT=get_VIEW->getParent;get_PARENT->removeView:get_VIEW;"}},{key:"removeAllChildren",value:function(t){return"set_VIEW=ctx->findViewById:i_"+t+";get_VIEW->removeAllViews;"}},{key:"replaceChild",value:function(t,e,n,r){this.appendChild(t,e,n,r,!0)}}]),e}(u);t.exports=f},function(t,e,n){var r=n(1),o=n(256),i=r(function(t,e){return o(t,e,[],[])});t.exports=i},function(t,e,n){function r(t,e,n){for(var r=0,o=n.length;r<o;){if(e=t["@@transducer/step"](e,n[r]),e&&e["@@transducer/reduced"]){e=e["@@transducer/value"];break}r+=1}return t["@@transducer/result"](e)}function o(t,e,n){for(var r=n.next();!r.done;){if(e=t["@@transducer/step"](e,r.value),e&&e["@@transducer/reduced"]){e=e["@@transducer/value"];break}r=n.next()}return t["@@transducer/result"](e)}function i(t,e,n,r){return t["@@transducer/result"](n[r](c(t["@@transducer/step"],t),e))}function a(t,e,n){if("function"==typeof t&&(t=s(t)),u(n))return r(t,e,n);if("function"==typeof n["fantasy-land/reduce"])return i(t,e,n,"fantasy-land/reduce");if(null!=n[f])return o(t,e,n[f]());if("function"==typeof n.next)return o(t,e,n);if("function"==typeof n.reduce)return i(t,e,n,"reduce");throw new TypeError("reduce: list must be array or iterable")}var u=n(39),s=n(118),c=n(96),f="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator";t.exports=a},function(t,e,n){"use strict";function r(){var t=o(),e=void 0;switch(t){case"IOS":e=n(172);break;case"WEB":e=n(173);break;default:e=n(171)}return e}var o=n(22).getOS;t.exports=r()},function(t,e){function n(t,e){t=t||[],e=e||[];var n,r=t.length,o=e.length,i=[];for(n=0;n<r;)i[i.length]=t[n],n+=1;for(n=0;n<o;)i[i.length]=e[n],n+=1;return i}t.exports=n},function(t,e,n){var r=n(27),o=n(3),i=o(r("slice",function(t,e,n){return Array.prototype.slice.call(n,t,e)}));t.exports=i},function(t,e){function n(t,e){switch(t){case 0:return function(){return e.apply(this,arguments)};case 1:return function(t){return e.apply(this,arguments)};case 2:return function(t,n){return e.apply(this,arguments)};case 3:return function(t,n,r){return e.apply(this,arguments)};case 4:return function(t,n,r,o){return e.apply(this,arguments)};case 5:return function(t,n,r,o,i){return e.apply(this,arguments)};case 6:return function(t,n,r,o,i,a){return e.apply(this,arguments)};case 7:return function(t,n,r,o,i,a,u){return e.apply(this,arguments)};case 8:return function(t,n,r,o,i,a,u,s){return e.apply(this,arguments)};case 9:return function(t,n,r,o,i,a,u,s,c){return e.apply(this,arguments)};case 10:return function(t,n,r,o,i,a,u,s,c,f){return e.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}t.exports=n},function(t,e,n){var r=n(2),o=n(7),i=n(113),a=!{toString:null}.propertyIsEnumerable("toString"),u=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],s=function(){"use strict";return arguments.propertyIsEnumerable("length")}(),c=function(t,e){for(var n=0;n<t.length;){if(t[n]===e)return!0;n+=1}return!1},f="function"!=typeof Object.keys||s?function(t){if(Object(t)!==t)return[];var e,n,r=[],f=s&&i(t);for(e in t)!o(e,t)||f&&"length"===e||(r[r.length]=e);if(a)for(n=u.length-1;n>=0;)e=u[n],o(e,t)&&!c(r,e)&&(r[r.length]=e),n-=1;return r}:function(t){return Object(t)!==t?[]:Object.keys(t)},p=r(f);t.exports=p},function(t,e,n){var r=n(3),o=n(12),i=r(o);t.exports=i},function(t,e){t.exports=Array.isArray||function(t){return null!=t&&t.length>=0&&"[object Array]"===Object.prototype.toString.call(t)}},function(t,e){function n(t){return t&&t["@@transducer/reduced"]?t:{"@@transducer/value":t,"@@transducer/reduced":!0}}t.exports=n},function(t,e,n){t.exports={},t.exports.F=n(191),t.exports.T=n(192),t.exports.__=n(193),t.exports.add=n(34),t.exports.addIndex=n(194),t.exports.adjust=n(91),t.exports.all=n(195),t.exports.allPass=n(196),t.exports.always=n(23),t.exports.and=n(92),t.exports.any=n(93),t.exports.anyPass=n(197),t.exports.ap=n(53),t.exports.aperture=n(198),t.exports.append=n(199),t.exports.apply=n(94),t.exports.applySpec=n(200),t.exports.applyTo=n(201),t.exports.ascend=n(202),t.exports.assoc=n(35),t.exports.assocPath=n(95),t.exports.binary=n(203),t.exports.bind=n(96),t.exports.both=n(204),t.exports.call=n(205),t.exports.chain=n(54),t.exports.clamp=n(206),t.exports.clone=n(207),t.exports.comparator=n(208),t.exports.complement=n(209),t.exports.compose=n(55),t.exports.composeK=n(97),t.exports.composeP=n(210),t.exports.concat=n(56),t.exports.cond=n(211),t.exports.construct=n(212),t.exports.constructN=n(98),t.exports.contains=n(213),t.exports.converge=n(99),t.exports.countBy=n(214),t.exports.curry=n(57),t.exports.curryN=n(6),t.exports.dec=n(215),t.exports.defaultTo=n(100),t.exports.descend=n(216),t.exports.difference=n(101),t.exports.differenceWith=n(102),t.exports.dissoc=n(103),t.exports.dissocPath=n(217),t.exports.divide=n(218),t.exports.drop=n(104),t.exports.dropLast=n(219),t.exports.dropLastWhile=n(220),t.exports.dropRepeats=n(221),t.exports.dropRepeatsWith=n(105),t.exports.dropWhile=n(222),t.exports.either=n(223),t.exports.empty=n(106),t.exports.endsWith=n(224),t.exports.eqBy=n(225),t.exports.eqProps=n(226),t.exports.equals=n(11),t.exports.evolve=n(227),t.exports.filter=n(58),t.exports.find=n(228),t.exports.findIndex=n(229),t.exports.findLast=n(230),t.exports.findLastIndex=n(231),t.exports.flatten=n(232),t.exports.flip=n(36),t.exports.forEach=n(233),t.exports.forEachObjIndexed=n(234),t.exports.fromPairs=n(235),t.exports.groupBy=n(236),t.exports.groupWith=n(237),t.exports.gt=n(238),t.exports.gte=n(239),t.exports.has=n(240),t.exports.hasIn=n(241),t.exports.head=n(242),t.exports.identical=n(107),t.exports.identity=n(59),t.exports.ifElse=n(243),t.exports.inc=n(244),t.exports.indexBy=n(245),t.exports.indexOf=n(246),t.exports.init=n(247),t.exports.innerJoin=n(248),t.exports.insert=n(249),t.exports.insertAll=n(250),t.exports.intersection=n(286),t.exports.intersperse=n(287),t.exports.into=n(288),t.exports.invert=n(289),t.exports.invertObj=n(290),t.exports.invoker=n(29),t.exports.is=n(119),t.exports.isEmpty=n(291),t.exports.isNil=n(120),t.exports.join=n(292),t.exports.juxt=n(121),t.exports.keys=n(17),t.exports.keysIn=n(293),t.exports.last=n(122),t.exports.lastIndexOf=n(294),t.exports.length=n(123),t.exports.lens=n(43),t.exports.lensIndex=n(295),t.exports.lensPath=n(296),t.exports.lensProp=n(297),t.exports.lift=n(44),t.exports.liftN=n(124),t.exports.lt=n(298),t.exports.lte=n(299),t.exports.map=n(8),t.exports.mapAccum=n(300),t.exports.mapAccumRight=n(301),t.exports.mapObjIndexed=n(302),t.exports.match=n(303),t.exports.mathMod=n(304),t.exports.max=n(25),t.exports.maxBy=n(305),t.exports.mean=n(125),t.exports.median=n(306),t.exports.memoize=n(307),t.exports.memoizeWith=n(126),t.exports.merge=n(308),t.exports.mergeAll=n(309),t.exports.mergeDeepLeft=n(310),t.exports.mergeDeepRight=n(311),t.exports.mergeDeepWith=n(312),t.exports.mergeDeepWithKey=n(45),t.exports.mergeWith=n(313),t.exports.mergeWithKey=n(66),t.exports.min=n(314),t.exports.minBy=n(315),t.exports.modulo=n(316),t.exports.multiply=n(127),t.exports.nAry=n(46),t.exports.negate=n(317),t.exports.none=n(318),t.exports.not=n(128),t.exports.nth=n(30),t.exports.nthArg=n(319),t.exports.o=n(320),t.exports.objOf=n(129),t.exports.of=n(321),t.exports.omit=n(322),t.exports.once=n(323),t.exports.or=n(130),t.exports.over=n(131),t.exports.pair=n(324),t.exports.partial=n(325),t.exports.partialRight=n(326),t.exports.partition=n(327),t.exports.path=n(26),t.exports.pathEq=n(328),t.exports.pathOr=n(329),t.exports.pathSatisfies=n(330),t.exports.pick=n(331),t.exports.pickAll=n(132),t.exports.pickBy=n(332),t.exports.pipe=n(133),t.exports.pipeK=n(333),t.exports.pipeP=n(134),t.exports.pluck=n(31),t.exports.prepend=n(135),t.exports.product=n(334),t.exports.project=n(335),t.exports.prop=n(67),t.exports.propEq=n(336),t.exports.propIs=n(337),t.exports.propOr=n(338),t.exports.propSatisfies=n(339),t.exports.props=n(340),t.exports.range=n(341),t.exports.reduce=n(18),t.exports.reduceBy=n(47),t.exports.reduceRight=n(136),t.exports.reduceWhile=n(342),t.exports.reduced=n(343),t.exports.reject=n(48),t.exports.remove=n(137),t.exports.repeat=n(344),t.exports.replace=n(345),t.exports.reverse=n(49),t.exports.scan=n(346),t.exports.sequence=n(138),t.exports.set=n(347),t.exports.slice=n(15),t.exports.sort=n(348),t.exports.sortBy=n(349),t.exports.sortWith=n(350),t.exports.split=n(351),t.exports.splitAt=n(352),t.exports.splitEvery=n(353),t.exports.splitWhen=n(354),t.exports.startsWith=n(355),t.exports.subtract=n(356);t.exports.sum=n(139);t.exports.symmetricDifference=n(357),t.exports.symmetricDifferenceWith=n(358),t.exports.tail=n(68),t.exports.take=n(69),t.exports.takeLast=n(140),t.exports.takeLastWhile=n(359),t.exports.takeWhile=n(360),t.exports.tap=n(361),t.exports.test=n(362),t.exports.times=n(141),t.exports.toLower=n(363),t.exports.toPairs=n(364),t.exports.toPairsIn=n(365),t.exports.toString=n(32),t.exports.toUpper=n(366),t.exports.transduce=n(367),t.exports.transpose=n(368),t.exports.traverse=n(369),t.exports.trim=n(370),t.exports.tryCatch=n(371),t.exports.type=n(70),t.exports.unapply=n(372),t.exports.unary=n(373),t.exports.uncurryN=n(374),t.exports.unfold=n(375),t.exports.union=n(376),t.exports.unionWith=n(377),t.exports.uniq=n(71),t.exports.uniqBy=n(142),t.exports.uniqWith=n(143),t.exports.unless=n(378),t.exports.unnest=n(379),t.exports.until=n(380),t.exports.update=n(72),t.exports.useWith=n(144),t.exports.values=n(145),t.exports.valuesIn=n(381),t.exports.view=n(382),t.exports.when=n(383),t.exports.where=n(146),t.exports.whereEq=n(384),t.exports.without=n(385),t.exports.xprod=n(386),t.exports.zip=n(387),t.exports.zipObj=n(388),t.exports.zipWith=n(389)},function(t,e){"use strict";function n(t){var e=t.props,n={w:e.w,h:e.h,stroke:e.stroke?1*e.stroke.split(",")[0]:0,x:e.x,y:e.y};window.__VIEW_DIMENSIONS[e.id]=n}function r(t){var e=t.props,n={w:e.w,h:e.h,x:e.x,y:e.y},r=window.__VIEW_DIMENSIONS[e.id],o=!1;if(!r)return n;for(var i in n)r[i]!=n[i]&&(n.id=e.id,o=!0);return o?n:null}function o(t){var e=t.props;if("gone"==e.visibility)return null;var n={w:e.w,h:e.h,stroke:e.stroke?1*e.stroke.split(",")[0]:0},r=!1,o=window.__VIEW_DIMENSIONS[e.id];if(!o)return!0;for(var i in n)if(o[i]!=n[i]){r=!0;break}return r}function i(){var t=navigator.userAgent;return t?t.indexOf("Android")!=-1&&t.indexOf("Version")!=-1?"ANDROID":t.indexOf("iPhone")!=-1&&t.indexOf("Version")==-1?"IOS":"WEB":console.error(new Error("UserAgent is null"))}function a(t,e){if("object"!=("undefined"==typeof t?"undefined":u(t)))return e;if("object"!=("undefined"==typeof e?"undefined":u(e)))return t;for(var n in e)t[n]=e[n];return t}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports={shouldInfateChilds:o,shouldMove:r,cacheDimen:n,getOS:i,merge:a}},function(t,e,n){var r=n(2),o=r(function(t){return function(){return t}});t.exports=o},function(t,e,n){function r(t,e){return o(e,t,0)>=0}var o=n(112);t.exports=r},function(t,e,n){var r=n(1),o=r(function(t,e){return e>t?e:t});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=e,r=0;r<t.length;){if(null==n)return;n=n[t[r]],r+=1}return n});t.exports=o},function(t,e,n){function r(t,e){return function(){var n=arguments.length;if(0===n)return e();var r=arguments[n-1];return o(r)||"function"!=typeof r[t]?e.apply(this,arguments):r[t].apply(r,Array.prototype.slice.call(arguments,0,n-1))}}var o=n(19);t.exports=r},function(t,e){function n(t){return"[object String]"===Object.prototype.toString.call(t)}t.exports=n},function(t,e,n){var r=n(1),o=n(40),i=n(6),a=n(32),u=r(function(t,e){return i(t+1,function(){var n=arguments[t];if(null!=n&&o(n[e]))return n[e].apply(n,Array.prototype.slice.call(arguments,0,t));throw new TypeError(a(n)+' does not have a method named "'+e+'"')})});t.exports=u},function(t,e,n){var r=n(1),o=n(28),i=r(function(t,e){var n=t<0?e.length+t:t;return o(e)?e.charAt(n):e[n]});t.exports=i},function(t,e,n){var r=n(1),o=n(8),i=n(67),a=r(function(t,e){return o(i(t),e)});t.exports=a},function(t,e,n){var r=n(2),o=n(268),i=r(function(t){return o(t,[])});t.exports=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){var e=(parseInt(t.substring(0,2),16)/255).toFixed(2),n=(parseInt(t.substring(2,4),16)/255).toFixed(2),r=(parseInt(t.substring(4,6),16)/255).toFixed(2);return e+","+n+","+r}function i(t){return t?t+"":""}function a(t){return t.replace(/ /g,"")}function u(t,e){return window.__SIZE_INDEX++,{return:"size"+window.__SIZE_INDEX,invokeOn:"self",methodName:"sizeFromDictionary:",values:[{width:t,height:e}]}}function s(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setContentSize:",values:[{name:"size"+window.__SIZE_INDEX,computed:"true",type:"size"}]}}function c(t,e,n,r){return window.__COLOR_INDEX++,{return:"color"+window.__COLOR_INDEX,invokeOn:"UIColor",methodName:"colorWithRed:green:blue:alpha:",values:[{name:t,type:"f"},{name:e,type:"f"},{name:n,type:"f"},{name:r,type:"f"}]}}function f(t,e){return t.values[0].properties=[{key:"frame",values:{x:e.x,y:e.y,width:e.w,height:e.h}}],t}function p(t,e){return t.values[0].properties=[{key:"angle",values:{}}],t}function l(t){var e={return:"false",invokeOn:"self",methodName:"animate:",values:[{duration:t.duration,viewTag:t.id,type:t.type,delay:t.delay,option:t.option}]};return"translation"==t.type?f(e,t):"rotation"==t.type?p(e,t):void 0}function d(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setBackgroundColor:",values:[{name:"color"+window.__COLOR_INDEX,computed:"true"}]}}function h(){var t=window.__VIEW_INDEX;return window.__VIEW_INDEX++,{return:"view"+window.__VIEW_INDEX,fromStore:ut?"false":"true",storeKey:"view"+t,invokeOn:ut?"this":"UIView",methodName:"superview"}}function y(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"scrollToIndex:",values:[{name:t,type:"i"}]}}function v(){return window.__RECT_INDEX++,{return:"rect"+window.__RECT_INDEX,fromStore:"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:"UIView",methodName:"bounds"}}function w(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setEnabled:",values:[{name:t,type:"i"}]}}function _(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setAutocorrectionType:",values:[{name:t,type:"i"}]}}function m(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setKeyboardType:",values:[{name:t,type:"i"}]}}function x(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setAutocapitalizationTypes:",values:[{name:t,type:"i"}]}}function g(t){return{return:"false",invokeOn:"self",methodName:"setStatusBarStyle:",values:[{name:t,type:"s"}]}}function E(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"becomeFirstResponder",values:[]}}function I(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setOn:animated:",values:[{name:t,type:"i"},{name:"1",type:"i"}]}}function b(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setShowsVerticalScrollIndicator:",values:[{name:t,type:"i"}]}}function S(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setSecureTextEntry:",values:[{name:t,type:"i"}]}}function N(t){return window.__IMAGE_INDEX++,{return:"image"+window.__IMAGE_INDEX,invokeOn:"self",methodName:"imageNamed:",values:[{name:t,type:"s"}]}}function O(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setImage:",values:[{name:"image"+window.__IMAGE_INDEX,computed:"true"}]}}function C(t,e,n,r){return window.__RECT_INDEX++,{return:"rect"+window.__RECT_INDEX,invokeOn:"self",methodName:"rectFromDictionary:",values:[{x:t,y:e,width:n,height:r}]}}function A(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setFrame:",values:[{name:"rect"+window.__RECT_INDEX,computed:"true",type:"rect"}]}}function V(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setText:",values:[{name:encodeURI(t),type:"s"}]}}function k(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setRegularExpression:",values:[{name:t,type:"s"}]}}function T(t){return{return:"false",invokeOn:"self",methodName:"setHtmlText:",values:[{text:t.text,viewTag:t.id}]}}function R(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setPlaceholder:",values:[{name:t,type:"s"}]}}function D(t,e){return window.__FONT_INDEX++,{return:"font"+window.__FONT_INDEX,invokeOn:"UIFont",methodName:"fontWithName:size:",values:[{name:t,type:"s"},{name:e,type:"f"}]}}function L(){return{return:"false",invokeOn:ut?"this":"UIView",methodName:"setFont:",values:[{name:"font"+window.__FONT_INDEX,computed:"true"}]}}function P(){return{return:"false",invokeOn:ut?"this":"UIView",methodName:"sizeToFit"}}function M(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setLineBreakMode:",values:[{name:t,type:"i"}]}}function W(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setNumberOfLines:",values:[{name:t,type:"i"}]}}function j(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setTextAlignment:",values:[{name:t,type:"i"}]}}function U(){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setTextColor:",values:[{name:"color"+window.__COLOR_INDEX,computed:"true"}]}}function X(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setTextLengthLimit:",values:[{name:t+"",type:"i"}]}}function B(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"removeObjectAtIndex:",values:[{name:t+"",type:"i"}]}}function F(){return window.__LAYER_INDEX++,{return:"layer"+window.__LAYER_INDEX,fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"layer"}}function H(t){return{return:"false",fromStore:"true",storeKey:"layer"+window.__LAYER_INDEX,invokeOn:"_UILabelLayer",methodName:"setCornerRadius:",values:[{name:t+"",type:"f"}]}}function K(t){return{return:"false",fromStore:"true",storeKey:"layer"+window.__LAYER_INDEX,invokeOn:"_UILabelLayer",methodName:"setBorderWidth:",values:[{name:t+"",type:"f"}]}}function z(){return{return:"false",fromStore:"true",storeKey:"layer"+window.__LAYER_INDEX,invokeOn:"_UILabelLayer",methodName:"setBorderColor:",values:[{name:"color"+window.__COLOR_INDEX,computed:"true",type:"cgcolor"}]}}function Y(){return{return:"false",fromStore:"true",storeKey:"layer"+window.__LAYER_INDEX,invokeOn:"_UILabelLayer",methodName:"setMasksToBounds:",values:[{name:"1",type:"i"}]}}function q(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setTag:",values:[{name:t,type:"i"}]}}function J(t){return window.__VIEW_INDEX++,{return:"view"+window.__VIEW_INDEX,invokeOn:"self",methodName:"getViewFromTag:",values:[{name:t,type:"s"}]}}function G(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setHidden:",values:[{name:t,type:"i"}]}}function v(){return window.__RECT_INDEX++,{return:"rect"+window.__RECT_INDEX,fromStore:"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:"UIView",methodName:"bounds"}}function $(t){return{return:"false",invokeOn:"self",methodName:"bringSubViewToFront:",values:[{name:t,type:"s"}]}}function Z(t){return{return:"false",fromStore:ut?"false":"true",storeKey:"view"+window.__VIEW_INDEX,invokeOn:ut?"this":"UIView",methodName:"setContentMode:",values:[{name:t,type:"i"}]}}function Q(t){var e=void 0,n="1.00";t.length>=8?(n=parseInt(t.substring(1,3),16),n=(n/255).toFixed(2),t=t.substring(3,9)):t=t.substring(1,t.length),t=o(a(t)),e=t.split(",");var r=a(e[0]),i=a(e[1]),u=a(e[2]),s=n;return c(r,i,u,s)}function tt(t){for(var e=Object.keys(t),n=0;n<e.length;n++)"undefined"==typeof t[e[n]]||null==t[e[n]]?delete t[e[n]]:"function"==typeof t[e[n]]?t[e[n]]=at.map(t[e[n]]):"id"!==e[n]&&"__filename"!==e[n]&&"currChildOffset"!==e[n]&&"methods"!==e[n]&&"collectionView"!==e[n]&&"tableView"!==e[n]&&delete t[e[n]];return t}function et(t){var e="uIView";return"customTextField"==t?"customTextField":e="editText"==t?"customTextField":"imageView"==t?"uIImageView":"textView"==t?"uILabel":"scrollView"==t||"horizontalScrollView"==t?"uIScrollView":"collectionView"==t||"tableView"==t?t:"uIView"}function nt(t,e){var n={imageUrl:"imageNamed",color:"textColor"},r=Object.keys(t);if(r.forEach(function(e){n[e]&&(t[n[e]]=t[e],delete t[e])}),t.stroke&&(t.borderWidth=t.stroke.split(",")[0],t.borderColor=t.stroke.split(",")[1]),t.alignParentBottom&&delete t.alignParentBottom,"textView"==e&&t.gravity){var o=t.gravity,i=0;i="left"==o?"0":"center"==o?"1":"2",t.textAlignment=i,delete t.gravity}return t}var rt=n(177),ot=(r(rt),n(178)),it=r(ot),at=(n(21),n(176)),ut=1;t.exports=function(t,e,n){if(e=nt((0,it.default)(e),t),t=et(t),ut="set"==n?1:0,e.methods=[],e.id){var r=a(i(e.id));ut?e.methods.push(q(r)):e.methods.push(J(r))}if(e.x||e.y||e.w||e.h){var o=a(i(e.x))||"0",c=a(i(e.y))||"0",f=a(i(e.w))||"100",p=a(i(e.h))||"100";e.methods.push(C(o,c,f,p)),e.methods.push(A())}if(e.background&&(e.methods.push(Q(e.background)),e.methods.push(d())),e.cornerRadius||e.borderWidth){if(e.methods.push(F()),e.cornerRadius){var rt=a(i(e.cornerRadius));e.methods.push(H(rt)),e.methods.push(Y())}if(e.borderWidth){var ot=a(i(e.borderWidth));e.methods.push(K(ot))}e.borderColor&&(e.methods.push(Q(e.borderColor)),e.methods.push(z()))}else e.debug&&(e.methods.push(F()),e.methods.push(K("1")));if(e.fillParent&&(e.methods.push(h()),e.methods.push(v()),e.methods.push(A())),e.imageNamed){var at=a(i(e.imageNamed)),st=a(i(e.x))||"0",ct=a(i(e.y))||"0",ft=a(i(e.w))||"100",pt=a(i(e.h))||"100";JSON.stringify({x:st,y:ct,width:ft,height:pt});e.methods.push(N(at)),e.methods.push(O())}if(e.text&&e.methods.push(V(i(e.text))),e.hint&&e.methods.push(R(i(e.hint))),e.textAlignment&&e.methods.push(j(a(i(e.textAlignment)))),e.textColor&&(e.methods.push(Q(e.textColor)),e.methods.push(U())),e.fontStyle&&(e.methods.push(D(e.fontStyle,e.textSize)),e.methods.push(L())),e.multipleLine&&(e.methods.push(M("0")),e.methods.push(W("0")),e.methods.push(P())),e.hidden){var lt=a(i(e.hidden));e.methods.push(G(lt))}if(e.translationX){var dt={x:""+e.translationX,id:e.id,type:"translation",delay:"0",duration:"0"};l(dt);e.methods.push(l(dt))}if(e.translationY){var ht={y:""+e.translationY,id:e.id,type:"translation",delay:"0",duration:"0"};e.methods.push(l(ht))}if(e.a_translationX){var yt={x:e.a_translationX,duration:e.a_duration||"0",id:e.id,delay:e.a_delay,option:e.a_option,type:"translation"};l(yt);e.methods.push(l(yt))}if(e.a_translationY){var vt={y:e.a_translationY,duration:e.a_duration||"0",id:e.id,delay:e.a_delay,option:e.a_option,type:"translation"};e.methods.push(l(vt))}if(e.a_rotate){var wt={duration:e.a_duration,id:e.id,delay:e.a_delay,option:e.a_option,type:"rotation"};e.methods.push(l(wt))}if(e.htmlText){var _t={text:e.htmlText,id:e.id};e.methods.push(T(_t))}if(e.bringSubViewToFront){var mt=i(e.viewTag);e.methods.push($(mt))}if("uIImageView"==t){var xt=i(e.contentMode||1);
e.methods.push(Z(xt))}if("uIScrollView"==t){var gt=i(e.contentWidth)||"0",Et=i(e.contentHeight)||"0";e.methods.push(u(gt,Et)),e.methods.push(s())}if(e.bringSubViewToFront){var It=i(e.enabled);e.methods.push(w(It))}if(e.statusBarStyle){var bt=i(e.statusBarStyle);e.methods.push(g(bt))}if(e.enabled){var St=i(e.enabled);e.methods.push(w(St))}if(e.keyboardType){var Nt=i(e.keyboardType);e.methods.push(m(Nt))}if(e.autocapitalizationType){var Ot=i(e.autocapitalizationType);e.methods.push(x(Ot))}if(e.autoCorrectionType){var Ct=i(e.autoCorrectionType);e.methods.push(_(Ct))}if(e.becomeFirstResponder&&e.methods.push(E()),e.setOn){var At=i(e.setOn);e.methods.push(I(At))}if(e.scrollToIndex){var Vt=i(e.scrollToIndex);e.methods.push(y(Vt))}if(e.showVerticalScrollBar){var kt=i(e.showVerticalScrollBar);e.methods.push(b(kt))}if(e.lengthLimit){var Tt=i(e.lengthLimit);e.methods.push(X(Tt))}if(e.regExp){var Rt=i(e.regExp);e.methods.push(k(Rt))}if(e.removeCell){var Dt=i(e.removeCell);e.methods.push(B(Dt))}if(e.secureTextEntry){var Lt=i(e.secureTextEntry);e.methods.push(S(Lt))}return e.currChildOffset=0,{config:tt(e),type:t}}},function(t,e,n){var r=n(1),o=r(function(t,e){return Number(t)+Number(e)});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){var r={};for(var o in n)r[o]=n[o];return r[t]=e,r});t.exports=o},function(t,e,n){var r=n(2),o=n(6),i=r(function(t){return o(t.length,function(e,n){var r=Array.prototype.slice.call(arguments,0);return r[0]=n,r[1]=e,t.apply(this,r)})});t.exports=i},function(t,e){function n(t,e,n){for(var r=0,o=n.length;r<o;){if(t(e,n[r]))return!0;r+=1}return!1}t.exports=n},function(t,e,n){function r(t,e,n){return function(){for(var a=[],u=0,s=t,c=0;c<e.length||u<arguments.length;){var f;c<e.length&&(!i(e[c])||u>=arguments.length)?f=e[c]:(f=arguments[u],u+=1),a[c]=f,i(f)||(s-=1),c+=1}return s<=0?n.apply(this,a):o(s,r(t,a,n))}}var o=n(16),i=n(41);t.exports=r},function(t,e,n){var r=n(2),o=n(19),i=n(28),a=r(function(t){return!!o(t)||!!t&&("object"==typeof t&&(!i(t)&&(1===t.nodeType?!!t.length:0===t.length||t.length>0&&(t.hasOwnProperty(0)&&t.hasOwnProperty(t.length-1)))))});t.exports=a},function(t,e){function n(t){return"[object Function]"===Object.prototype.toString.call(t)}t.exports=n},function(t,e){function n(t){return null!=t&&"object"==typeof t&&t["@@functional/placeholder"]===!0}t.exports=n},function(t,e){function n(t,e){for(var n=0,r=e.length,o=Array(r);n<r;)o[n]=t(e[n]),n+=1;return o}t.exports=n},function(t,e,n){var r=n(1),o=n(8),i=r(function(t,e){return function(n){return function(r){return o(function(t){return e(t,r)},n(t(r)))}}});t.exports=i},function(t,e,n){var r=n(2),o=n(124),i=r(function(t){return o(t.length,t)});t.exports=i},function(t,e,n){var r=n(3),o=n(64),i=n(66),a=r(function t(e,n,r){return i(function(n,r,i){return o(r)&&o(i)?t(e,r,i):e(n,r,i)},n,r)});t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){switch(t){case 0:return function(){return e.call(this)};case 1:return function(t){return e.call(this,t)};case 2:return function(t,n){return e.call(this,t,n)};case 3:return function(t,n,r){return e.call(this,t,n,r)};case 4:return function(t,n,r,o){return e.call(this,t,n,r,o)};case 5:return function(t,n,r,o,i){return e.call(this,t,n,r,o,i)};case 6:return function(t,n,r,o,i,a){return e.call(this,t,n,r,o,i,a)};case 7:return function(t,n,r,o,i,a,u){return e.call(this,t,n,r,o,i,a,u)};case 8:return function(t,n,r,o,i,a,u,s){return e.call(this,t,n,r,o,i,a,u,s)};case 9:return function(t,n,r,o,i,a,u,s,c){return e.call(this,t,n,r,o,i,a,u,s,c)};case 10:return function(t,n,r,o,i,a,u,s,c,f){return e.call(this,t,n,r,o,i,a,u,s,c,f)};default:throw new Error("First argument to nAry must be a non-negative integer no greater than ten")}});t.exports=o},function(t,e,n){var r=n(38),o=n(4),i=n(7),a=n(12),u=n(282),s=r(4,[],o([],u,function(t,e,n,r){return a(function(r,o){var a=n(o);return r[a]=t(i(a,r)?r[a]:e,o),r},{},r)}));t.exports=s},function(t,e,n){var r=n(110),o=n(1),i=n(58),a=o(function(t,e){return i(r(t),e)});t.exports=a},function(t,e,n){var r=n(2),o=n(28),i=r(function(t){return o(t)?t.split("").reverse().join(""):Array.prototype.slice.call(t,0).reverse()});t.exports=i},function(t,e,n){(function(e){"use strict";function r(t,e){!i.isUndefined(t)&&i.isUndefined(t["Content-Type"])&&(t["Content-Type"]=e)}function o(){var t;return"undefined"!=typeof XMLHttpRequest?t=n(73):"undefined"!=typeof e&&(t=n(73)),t}var i=n(9),a=n(162),u={"Content-Type":"application/x-www-form-urlencoded"},s={adapter:o(),transformRequest:[function(t,e){return a(e,"Content-Type"),i.isFormData(t)||i.isArrayBuffer(t)||i.isBuffer(t)||i.isStream(t)||i.isFile(t)||i.isBlob(t)?t:i.isArrayBufferView(t)?t.buffer:i.isURLSearchParams(t)?(r(e,"application/x-www-form-urlencoded;charset=utf-8"),t.toString()):i.isObject(t)?(r(e,"application/json;charset=utf-8"),JSON.stringify(t)):t}],transformResponse:[function(t){if("string"==typeof t)try{t=JSON.parse(t)}catch(t){}return t}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(t){return t>=200&&t<300}};s.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(t){s.headers[t]={}}),i.forEach(["post","put","patch"],function(t){s.headers[t]=i.merge(u)}),t.exports=s}).call(e,n(90))},function(t,e,n){"use strict";function r(t,e){var n=(t.childNodes,t.childNodes.length?t.childNodes[0]:document.createElement("span"));t.style.whiteSpace="initial",n.innerText=e.text,n.style.wordBreak="break-word",t.appendChild(n)}function o(t,e){var n=e.popupMenu.split(","),r=document.createElement("div");r.setAttribute("class","popupMenu"),r.style.cssText="display: none; position: absolute; right: 20px; top:20px; z-index: 5;box-shadow: 0px 5px 10px #888888;",document.body.appendChild(r);for(var o="onMenuItemClick",i=function(t){var i=document.createElement("div");i.setAttribute("class","menuItem"),i.textContent=n[t],r.appendChild(i);var a=t;e[o]&&"function"==typeof e[o]&&i.addEventListener("click",function(){e[o](a)})},a=0;a<n.length;a++)i(a);t.addEventListener("click",function(){"none"==r.style.display?r.style.display="":r.style.display="none"})}function i(t,e,n,i){"horizontalScrollView"!=t&&"scrollView"!=t||(e.style.overflow="auto");var a=function(t){var r=n.animation,o=e;r.transition&&(o.style.transition=r.transition,o.style.transform=r.transform,r.opacity&&(o.style.opacity=r.opacity))};e.style.transition=n.transition;for(var u in n)if("popupMenu"==u)o(e,n);else if("text"==u)"editText"==t?e.value=n[u]:r(e,n);else if("style"==u)for(var s in n.style)"className"==s?e.className+=n.style[s]:e.style[s]=n.style[s];else if("attributes"==u)for(var c in n.attributes)e.setAttribute(c,n.attributes[c]);else if(n[u]&&"function"==typeof n[u]){var f=function(){if(!i)return"continue";var t=u.substring(2,u.length).toLowerCase(),r=n[u];e.style.userSelect="none",e.addEventListener(t,function(e){return r("change"==t?e.target.value:e)})}();if("continue"===f)continue}(n.style.transform||n.style.opacity)&&n.animation.transition?setTimeout(a,100):n.animation.transition&&a(),e.setAttribute("class",t)}var a=n(79),u=a.computeChildDimens,s=n(22),c=n(21),f=function(t,e){t.style.display=p(e)?"none":"",t.style.left=e.x,t.style.top=e.y,t.style.width=e.w,t.style.height=e.h},p=function(t){return"gone"===t.visibility},l=function t(e,n){var r=document.getElementById(e.props.id),o=!1,a=function(){e.props.afterRender&&"function"==typeof e.props.afterRender&&e.props.afterRender(),e.props.feedback&&"function"==typeof e.props.feedback&&e.props.feedback()};r||("imageView"==e.type?r=document.createElement("img"):"checkBox"==e.type?r=document.createElement("checkBox"):"editText"==e.type?(r=document.createElement("input"),r.value=e.props.text||"",r.placeholder=e.props.hint||""):r=document.createElement("div"),"horizontalScrollView"==e.type?(r.style.overflowX="scroll",r.style.overflowY="hidden",r.style.whiteSpace="noWrap",r.style.position="absolute"):"scrollView"==e.type?(r.style.overflowY="scroll",r.style.overflowX="hidden",r.style.position="absolute"):"listView"==e.type?(r.style.overflowY="scroll",r.style.overflowX="hidden",r.style.position="absolute"):r.style.position="absolute",o=!0,n&&n.appendChild(r),i(e.type,r,e.props,!0));var c=s.shouldMove(e),p=s.shouldInfateChilds(e);if(!c&&!p)return o&&a(),r;if(s.cacheDimen(e),c&&f(r,e.props),!p)return o&&a(),r;u(e);for(var l=0;l<e.children.length;l++){var d=e.children[l];d&&t(d,r)}return o&&a(),r},d=function(t){t instanceof Array||(t=[t]),t.forEach(function(t){var e=document.getElementById(t.id);if(!e)return console.error("runInUI (Id NULL) CMD:",t);var n=e.parentNode,r=window.__VIEWS[e.id],o=window.__VIEWS[n.id];r.props=c.merge(r.props,t),i(r.type,e,r.props,!1),u(o),o.children.forEach(function(t){l(t,n)})})};t.exports={inflateView:l,runInUI:d,computeChildDimens:u}},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=(n(33),function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"setOrientation",value:function(t){this.props.orientation&&"horizontal"!=this.props.orientation?this.orientation="0":this.orientation="1"}},{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t,e=this.props;this.setOrientation(e),t=this.resolveChildren();var n=u("linearLayout",{id:this.props.id?this.props.id:this.idSet.id,params:e},t);return n}}]),e}(s));t.exports=c},function(t,e,n){var r=n(14),o=n(1),i=n(12),a=n(8),u=o(function(t,e){return"function"==typeof e["fantasy-land/ap"]?e["fantasy-land/ap"](t):"function"==typeof t.ap?t.ap(e):"function"==typeof t?function(n){return t(n)(e(n))}:i(function(t,n){return r(t,a(n,e))},[],t)});t.exports=u},function(t,e,n){var r=n(1),o=n(4),i=n(115),a=n(271),u=n(8),s=r(o(["fantasy-land/chain","chain"],a,function(t,e){return"function"==typeof e?function(n){return t(e(n))(n)}:i(!1)(u(t,e))}));t.exports=s},function(t,e,n){function r(){if(0===arguments.length)throw new Error("compose requires at least one argument");return o.apply(this,i(arguments))}var o=n(133),i=n(49);t.exports=r},function(t,e,n){var r=n(1),o=n(19),i=n(40),a=n(28),u=n(32),s=r(function(t,e){if(o(t)){if(o(e))return t.concat(e);throw new TypeError(u(e)+" is not an array")}if(a(t)){if(a(e))return t+e;throw new TypeError(u(e)+" is not a string")}if(null!=t&&i(t["fantasy-land/concat"]))return t["fantasy-land/concat"](e);if(null!=t&&i(t.concat))return t.concat(e);throw new TypeError(u(t)+' does not have a method named "concat" or "fantasy-land/concat"')});t.exports=s},function(t,e,n){var r=n(2),o=n(6),i=r(function(t){return o(t.length,t)});t.exports=i},function(t,e,n){var r=n(1),o=n(4),i=n(61),a=n(64),u=n(12),s=n(276),c=n(17),f=r(o(["filter"],s,function(t,e){return a(e)?u(function(n,r){return t(e[r])&&(n[r]=e[r]),n},{},c(e)):i(t,e)}));t.exports=f},function(t,e,n){var r=n(2),o=n(62),i=r(o);t.exports=i},function(t,e,n){var r=n(261);t.exports="function"==typeof Object.assign?Object.assign:r},function(t,e){function n(t,e){for(var n=0,r=e.length,o=[];n<r;)t(e[n])&&(o[o.length]=e[n]),n+=1;return o}t.exports=n},function(t,e){function n(t){return t}t.exports=n},function(t,e){t.exports=Number.isInteger||function(t){return t<<0===t}},function(t,e){function n(t){return"[object Object]"===Object.prototype.toString.call(t)}t.exports=n},function(t,e){function n(t){return"function"==typeof t["@@transducer/step"]}t.exports=n},function(t,e,n){var r=n(3),o=n(7),i=r(function(t,e,n){var r,i={};for(r in e)o(r,e)&&(i[r]=o(r,n)?t(r,e[r],n[r]):e[r]);for(r in n)o(r,n)&&!o(r,i)&&(i[r]=n[r]);return i});t.exports=i},function(t,e,n){var r=n(1),o=n(26),i=r(function(t,e){return o([t],e)});t.exports=i},function(t,e,n){var r=n(27),o=n(2),i=n(15),a=o(r("tail",i(1,1/0)));t.exports=a},function(t,e,n){var r=n(1),o=n(4),i=n(283),a=n(15),u=r(o(["take"],i,function(t,e){return a(0,t<0?1/0:t,e)}));t.exports=u},function(t,e,n){var r=n(2),o=r(function(t){return null===t?"Null":void 0===t?"Undefined":Object.prototype.toString.call(t).slice(8,-1)});t.exports=o},function(t,e,n){var r=n(59),o=n(142),i=o(r);t.exports=i},function(t,e,n){var r=n(3),o=n(91),i=n(23),a=r(function(t,e,n){return o(i(e),t,n)});t.exports=a},function(t,e,n){(function(e){"use strict";var r=n(9),o=n(154),i=n(157),a=n(163),u=n(161),s=n(76),c="undefined"!=typeof window&&window.btoa&&window.btoa.bind(window)||n(156);t.exports=function(t){return new Promise(function(f,p){var l=t.data,d=t.headers;r.isFormData(l)&&delete d["Content-Type"];var h=new XMLHttpRequest,y="onreadystatechange",v=!1;if("test"===e.env.NODE_ENV||"undefined"==typeof window||!window.XDomainRequest||"withCredentials"in h||u(t.url)||(h=new window.XDomainRequest,y="onload",v=!0,h.onprogress=function(){},h.ontimeout=function(){}),t.auth){var w=t.auth.username||"",_=t.auth.password||"";d.Authorization="Basic "+c(w+":"+_)}if(h.open(t.method.toUpperCase(),i(t.url,t.params,t.paramsSerializer),!0),h.timeout=t.timeout,h[y]=function(){if(h&&(4===h.readyState||v)&&(0!==h.status||h.responseURL&&0===h.responseURL.indexOf("file:"))){var e="getAllResponseHeaders"in h?a(h.getAllResponseHeaders()):null,n=t.responseType&&"text"!==t.responseType?h.response:h.responseText,r={data:n,status:1223===h.status?204:h.status,statusText:1223===h.status?"No Content":h.statusText,headers:e,config:t,request:h};o(f,p,r),h=null}},h.onerror=function(){p(s("Network Error",t,null,h)),h=null},h.ontimeout=function(){p(s("timeout of "+t.timeout+"ms exceeded",t,"ECONNABORTED",h)),h=null},r.isStandardBrowserEnv()){var m=n(159),x=(t.withCredentials||u(t.url))&&t.xsrfCookieName?m.read(t.xsrfCookieName):void 0;x&&(d[t.xsrfHeaderName]=x)}if("setRequestHeader"in h&&r.forEach(d,function(t,e){"undefined"==typeof l&&"content-type"===e.toLowerCase()?delete d[e]:h.setRequestHeader(e,t)}),t.withCredentials&&(h.withCredentials=!0),t.responseType)try{h.responseType=t.responseType}catch(e){if("json"!==t.responseType)throw e}"function"==typeof t.onDownloadProgress&&h.addEventListener("progress",t.onDownloadProgress),"function"==typeof t.onUploadProgress&&h.upload&&h.upload.addEventListener("progress",t.onUploadProgress),t.cancelToken&&t.cancelToken.promise.then(function(t){h&&(h.abort(),p(t),h=null)}),void 0===l&&(l=null),h.send(l)})}}).call(e,n(90))},function(t,e){"use strict";function n(t){this.message=t}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,t.exports=n},function(t,e){"use strict";t.exports=function(t){return!(!t||!t.__CANCEL__)}},function(t,e,n){"use strict";var r=n(153);t.exports=function(t,e,n,o,i){var a=new Error(t);return r(a,e,n,o,i)}},function(t,e){"use strict";t.exports=function(t,e){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return t.apply(e,n)}}},function(t,e,n){"use strict";function r(t,e,n){var r=c.cmd({id:e,translationZ:++window.ZIndex});return r}function o(t,e,n){var r=c.cmdContainer(),o=void 0;return 1==n?(o=c.cmd({id:e,translationY:window.__HEIGHT,a_duration:"300",a_translationY:"0",translationZ:++window.ZIndex}),r=r.addCmd(o),o=c.cmd({id:t,a_translationY:-.2*window.__HEIGHT,a_duration:"300"}),r=r.addCmd(o)):(window.ZIndex++,o=c.cmd({id:t,translationY:0,a_translationY:window.__HEIGHT,a_duration:"300",translationZ:++window.ZIndex}),r=r.addCmd(o),o=c.cmd({id:e,translationZ:window.ZIndex-1,a_translationY:"0",translationY:-.2*window.__HEIGHT,a_duration:"300"}),r=r.addCmd(o))}function i(t,e,n){var r=c.cmdContainer(),o=void 0;return 1==n&&(o=c.cmd({id:e,visibility:"visible",translationX:window.__WIDTH,a_duration:"300",a_translationX:"0",translationZ:++window.ZIndex}),r=r.addCmd(o),o=c.cmd({id:t,translationX:"0",visibility:"visible",a_duration:"300",a_translationX:-.2*window.__WIDTH+""}),r=r.addCmd(o)),n==-1&&(window.ZIndex++,o=c.cmd({id:t,translationX:"0",a_duration:"300",a_translationX:window.__WIDTH,translationZ:++window.ZIndex}),r=r.addCmd(o),o=c.cmd({id:e,visibility:"visible",translationX:-.2*window.__WIDTH+"",a_duration:"300",a_translationX:"0",translationZ:window.ZIndex-1}),r=r.addCmd(o)),r}function a(t,e,n,r){return r||(r=p),"object"===("undefined"==typeof r?"undefined":u(r))&&"function"==typeof r.handler?r.handler(t,e,n):void console.log(new Error("Animation handler is not a function, type: "+r))}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},s=n(10),c=new s(null,null,{}),f={SLIDE:{name:"slide",handler:i},SLIDE_VERTICAL:{name:"slide_down",handler:o},SIMPLE:{name:"simple",handler:r}},p=f.SLIDE;t.exports.types=f,t.exports.getAnimation=a},function(t,e,n){"use strict";function r(t){var e=t.props,n={w:1*e.w,h:1*e.h,x:0,y:0,width:1*e.w};if(t.children.forEach(function(t){t.props.w=t.props.width,t.props.h=t.props.height,t.props.x=0,t.props.y=0}),e.stroke){var r=e.stroke.split(",")[0];n.w-=2*r,n.h-=2*r,"IOS"==window.__OS&&(n.x+=1*r,n.y+=1*r)}if(!e.padding)return n;var o=e.padding.split(",").map(function(t){return 1*t});return n.w-=o[0]+o[2],n.h-=o[1]+o[3],n.x+=o[0],n.y+=o[1],n}function o(t){return"gone"===t.visibility}function i(t,e){for(var n=0;n<t.length;n++){var r=t[n].props;if(!o(r)&&r[e]&&"match_parent"==r[e])return!0}return!1}function a(t,e){if("linearLayout"!=t)return!1;for(var n=0;n<e.length;n++){var r=e[n].props;if(!o(r)&&r.weight&&parseInt(r.weight)>0)return!0}return!1}function u(t,e,n){var r=t.props,u="vertical"!==r.orientation,s=!0,c=!0,f=a(t.type,t.children),p=i(t.children,"w"),l=i(t.children,"h"),d=function(r,i){n&&(i=!1);var a="w"===r?[0,2]:[1,3],u="w"===r?"x":"y",s=0;t.children.forEach(function(t){var u=t.props;if(!o(u)){var c=1*u[r];if(n&&u.alignParentBottom&&"h"==r)return void(s=e[r]);if(u.margin&&(i||n)){var f=u.margin.split(",").map(function(t){return 1*t});c+=f[a[0]]+f[a[1]]}i?s+=c:s=s<c?c:s}}),s<=e[r]?e[u]+=Math.floor((e[r]-s)/2):console.error(new Error("Childs "+r+" + margins are greater than the parents "+r+", id: "+t.props.id))};"center_horizontal"===r.gravity?s=!1:"center_vertical"===r.gravity&&(c=!1),c&&!p&&(n||u&&!f)&&d("w",u),!s||l||!n&&(u||f)||d("h",!u)}function s(t,e){var n=r(t),i=t.children;!e&&t.props.gravity&&u(t,n,!0);var a=n.width;i.forEach(function(t){var e=t.props,r=[0,0,0,0];if(o(e))return e.h="0",void(e.w="0");e.margin&&(r=e.margin.split(",").map(function(t){return 1*t}));var i=n.w-r[0]-r[2],u=n.h-r[1]-r[3];if("match_parent"===e.w&&(e.w=i+""),"match_parent"===e.h&&(e.h=u+""),e.x+=n.x+r[0],e.y+=n.y+r[1],e.alignParentBottom)e.y+=n.h-e.h-r[1]-r[3];else if(e.centerInParent){var s=n.w-e.w-r[0]-r[2],c=n.h-e.h-r[1]-r[3];e.x+=Math.floor(s/2),e.y+=Math.floor(c/2)}window.RTL&&(e.x=a-e.x-e.w)})}function c(t){var e=r(t),n=e.width,s=t.props,c=t.children,f="vertical"!==s.orientation,p=f?"w":"h",l=f?"h":"w",d=f?[0,2]:[1,3],h=f?[1,3]:[0,2],y=f?"x":"y",v=f?"y":"x",w=a(t.type,c),_=i(c,p),m=0,x=!1,g=!1;if(s.gravity){var E=s.gravity;"center"==E&&(x=!0,g=!0),("center_vertical"==E&&f||"center_horizontal"==E&&!f)&&(x=!0),("center_horizontal"==E&&f||"center_vertical"==E&&!f)&&(g=!0)}if(w&&_)throw new Error("Render: Layout cannot have children with ",p+":match_parent and weight prop, id:"+s.id);(_||w)&&c.forEach(function(t){var n=t.props;if(!o(n)){var r=1*n.weight;if(r>0&&(m+=r),n.margin){var i=n.margin.split(",").map(function(t){return 1*t});e[p]-=i[d[0]]+i[d[1]]}e[p]-=1*n[p]||0}}),g&&u(t,e),c.forEach(function(t){var r=t.props,i=e[y],a=[0,0,0,0],u=1*r.weight;if(o(r))return r.w="0",void(r.h="0");if(r.margin&&(a=r.margin.split(",").map(function(t){return 1*t})),"match_parent"===r[p]&&(r[p]=e[p],r[p]-=a[d[0]]+a[d[1]],r[p]+="",e[p]=0),u>0){var c=1*r[p]||0;r[p]=c+Math.floor(e[p]*u/m),r[p]+=""}r[y]+=i+a[d[0]],r[y]+="",e[y]+=1*r[p]+a[d[0]]+a[d[1]],i=e[v];var f=a[h[0]];if("match_parent"===r[l])r[l]=e[l],r[l]-=a[h[0]]+a[h[1]],r[l]+="";else if(x){var w=e[l]-r[l];w<0?console.error(new Error("Child "+l+" larger than the parent, id:"+s.id)):i+=w/2,f=a[h[0]]-a[h[1]]}r[v]+=i+f,r[v]+="",window.RTL&&(r.x=n-r.x-r.w)})}function f(t){return"linearLayout"==t.type?c(t):"relativeLayout"===t.type?s(t,!1):t.type.toLocaleLowerCase().indexOf("scroll")!=-1?s(t,!0):"listView"==t.type?(t.orientation="vertical",c(t)):s(t,!1),t}n(21);t.exports={computeLinearlayout:c,computeRelativeLayout:function(t){return s(t,!1)},computeScrollView:function(t){return s(t,!0)},computeChildDimens:f}},function(t,e){"use strict";t.exports={handle:function(t,e){if(t.render){if("undefined"==typeof Android)throw new Error("Android is undefined");return"ANDROID"!=window.__OS?Android.Render(t.render,null):Android.Render(JSON.stringify(t.render),null)}t.runInUI&&Android.runInUI(t.runInUI,null),t.addViewToParent&&Android.addViewToParent(t.addViewToParent.parentId,JSON.stringify(t.addViewToParent.jsx),t.addViewToParent.index,null)}}},function(t,e){"use strict";function n(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}t.exports.map=function(t){if("undefined"!=typeof window.__FN_INDEX&&null!==window.__FN_INDEX){var e="F"+window.__FN_INDEX;return window.__PROXY_FN[e]=t,window.__FN_INDEX++,e}throw new Error("Please initialise window.__FN_INDEX = 0 in index.js of your project.")},t.exports.callJSCallback=function(){for(var t,e=arguments.length,r=Array(e),o=0;o<e;o++)r[o]=arguments[o];var i=r[0],a=r.slice(1);(t=window.__PROXY_FN[i]).call.apply(t,[null].concat(n(a)))}},function(t,e,n){"use strict";t.exports={parseParams:n(84),mapPrams:n(83),callbackMapper:n(81)}},function(t,e){"use strict";function n(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var r,o=(r={textFromHtml:{values:[{type:"s"}],dontMap:"true",fnName:"setText",inVokedIn:"VIEW"},showDividers:{values:[{type:"i"}],dontMap:"true",fnName:"setShowDividers",inVokedIn:"VIEW"},dividerDrawable:{values:[{type:"s"}],dontMap:!0,fnName:"setDividerDrawable",inVokedIn:"VIEW"},tabTextColors:{values:[{type:"s"},{type:"s"}],dontMap:!0,inVokedIn:"VIEW",fnName:"setTabTextColors"},selectedTabIndicatorHeight:{values:[{type:"i"}],dontMap:!0,fnName:"setSelectedTabIndicatorHeight",inVokedIn:"VIEW"},foreground:{values:[{type:"b"}],dontMap:"true",fnName:"setColor",inVokedIn:"FOREGROUND"},selectedTabIndicatorColor:{values:[{type:"s"}],dontMap:!0,fnName:"setSelectedTabIndicatorColor",inVokedIn:"VIEW"},layoutTransition:{values:[{type:"b"}],dontMap:"true",fnName:"setLayoutTransition",inVokedIn:"LAYOUT_TRANSITION"},focusOut:{dontMap:"true",fnName:"clearFocus",inVokedIn:"VIEW"},focus:{dontMap:"true",fnName:"requestFocus",inVokedIn:"VIEW"},fillViewport:{values:[{type:"b"}],dontMap:!0,inVokedIn:"VIEW",fnName:"setFillViewport"},setDate:{values:[{type:"l"}],dontMap:"true",fnName:"setDate",inVokedIn:"VIEW"},minDate:{values:[{type:"l"}],dontMap:"true",fnName:"setMinDate",inVokedIn:"VIEW"},maxDate:{values:[{type:"l"}],dontMap:"true",fnName:"setMaxDate",inVokedIn:"VIEW"},clipChildren:{values:[{type:"b"}],dontMap:"true",fnName:"setClipChildren",inVokedIn:"VIEW"},adjustViewBounds:{values:[{type:"b"}],dontMap:"true",fnName:"setAdjustViewBounds",inVokedIn:"VIEW"},maxLines:{values:[{type:"i"}],dontMap:"true",fnName:"setMaxLines",inVokedIn:"VIEW"},singleLine:{values:[{type:"b"}],dontMap:"true",fnName:"setSingleLine",inVokedIn:"VIEW"},hardware:{values:[{type:"i"},{type:"i"}],dontMap:!0,fnName:"setLayerType",inVokedIn:"VIEW"},selected:{values:[{type:"b"}],dontMap:!0,fnName:"setSelected",inVokedIn:"VIEW"},curve:{values:[{type:"s",linear:"0"}],fnName:"setInterpolator",inVokedIn:"VIEW"},fontFamily:{values:[{type:"s",dontMap:!0},{type:"i",normal:0,bold:1,italic:2,bold_italic:3}],fnName:"setFontFamily",inVokedIn:"VIEW"},x:{values:[{type:"f"}],dontMap:!0,fnName:"setX",inVokedIn:"VIEW"},bringToFront:{values:[],inVokedIn:"VIEW",fnName:"bringToFront"},above:{values:[{type:"i",dontMap:!0},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},checked:{values:[{type:"b"}],dontMap:!0,fnName:"setChecked",inVokedIn:"VIEW"},y:{values:[{type:"f"}],dontMap:!0,fnName:"setY",inVokedIn:"VIEW"},backgroundDrawable:{values:[{type:"s"}],dontMap:!0,fnName:"setBackground",inVokedIn:"VIEW"},buttonTint:{value:[{type:"s"}],dontMap:!0,fnName:"setButtonTintList",inVokedIn:"VIEW"},visibility:{values:[{type:"i",visible:0,invisible:4,gone:8}],fnName:"setVisibility",inVokedIn:"VIEW"},scaleType:{values:[{type:"s"}],dontMap:!0,fnName:"setScaleType",inVokedIn:"VIEW"},progressColor:{values:[{type:"s"}],dontMap:!0,fnName:"setIndeterminateTintList",inVokedIn:"VIEW"},alpha:{values:[{type:"f"}],dontMap:!0,fnName:"setAlpha",inVokedIn:"VIEW"},imageUrl:{values:[{type:"s"}],dontMap:!0,fnName:"setImageDrawable",inVokedIn:"VIEW"},url:{values:[{type:"s"}],dontMap:!0,fnName:"loadUrl",inVokedIn:"VIEW"},translationY:{values:[{type:"f"}],dontMap:!0,fnName:"setTranslationY",inVokedIn:"VIEW"},translationX:{values:[{type:"f"}],dontMap:!0,fnName:"setTranslationX",inVokedIn:"VIEW"},translationZ:{values:[{type:"f"}],dontMap:!0,fnName:"setTranslationZ",inVokedIn:"VIEW"},delay:{values:[{type:"l"}],dontMap:!0,fnName:"setStartDelay"},duration:{values:[{type:"l"}],dontMap:!0,fnName:"setDuration"},pivotX:{values:[{type:"f"}],dontMap:!0,fnName:"setPivotX",inVokedIn:"VIEW"},pivotY:{values:[{type:"f"}],dontMap:!0,fnName:"setPivotY",inVokedIn:"VIEW"},minWidth:{values:[{type:"i"}],dontMap:!0,fnName:"setMinimumWidth",inVokedIn:"VIEW"},minHeight:{values:[{type:"i"}],dontMap:!0,fnName:"setMinimumHeight",inVokedIn:"VIEW"},maxWidth:{values:[{type:"i"}],dontMap:!0,fnName:"setMaxWidth",inVokedIn:"VIEW"},letterSpacing:{values:[{type:"f"}],dontMap:!0,fnName:"setLetterSpacing",inVokedIn:"VIEW"},hint:{values:[{type:"cs"}],dontMap:!0,fnName:"setHint",inVokedIn:"VIEW"},inputType:{values:[{type:"i",password:"129",numeric:"2",numericPassword:"12",disabled:"0",text:"1"}],fnName:"setInputType",inVokedIn:"VIEW"},inputTypeI:{values:[{type:"i"}],dontMap:!0,fnName:"setInputType",inVokedIn:"VIEW"},textSize:{values:[{type:"f"}],dontMap:!0,fnName:"setTextSize",inVokedIn:"VIEW"},fontSize:{values:[{type:"i"},{type:"f"}],dontMap:!0,fnName:"setTextSize",inVokedIn:"VIEW"},textIsSelectable:{values:[{type:"b"}],dontMap:!0,fnName:"setTextIsSelectable",inVokedIn:"VIEW"},fontStyle:{values:[{type:"s"}],dontMap:"true",fnName:"setTypeface",inVokedIn:"VIEW"},textAllCaps:{values:[{type:"b"}],dontMap:!0,fnName:"setAllCaps",inVokedIn:"VIEW"},toast:{values:[{type:"cs"}],dontMap:!0,fnName:"showToast",inVokedIn:"CONTEXT"},scaleX:{values:[{type:"f"}],dontMap:!0,fnName:"setScaleX",inVokedIn:"VIEW"},scaleY:{values:[{type:"f"}],dontMap:!0,fnName:"setScaleY",inVokedIn:"VIEW"},id:{values:[{type:"i"}],dontMap:!0,fnName:"setId",inVokedIn:"VIEW"},gravity:{values:[{type:"i",center_horizontal:1,center_vertical:16,left:8388611,right:8388613,center:17,top_vertical:48,start:8388611,end:8388613}],fnName:"setGravity",inVokedIn:"VIEW"},orientation:{values:[{type:"i",horizontal:0,vertical:1}],fnName:"setOrientation",inVokedIn:"VIEW"},text:{values:[{type:"cs"}],dontMap:!0,fnName:"setText",inVokedIn:"VIEW"},width:{values:[{type:"i",match_parent:-1,wrap_content:-2}],inVokedIn:"PARAMS",ctr:!0,varName:"var_width"},weight:{values:[{type:"f",match_parent:-1,wrap_content:-2}],dontMap:!0,inVokedIn:"PARAMS",varName:"var_weight"},height:{values:[{type:"i",match_parent:-1,wrap_content:-2}],inVokedIn:"PARAMS",ctr:!0,varName:"var_height"},layout_gravity:{values:[{type:"i",bottom_right:21,top:30,bottom:50,left:3,right:5,center:17,center_horizontal:1,center_vertical:16,start:8388611,end:8388613}],inVokedIn:"PARAMS",varName:"var_gravity"},margin:{values:[{type:"dp"},{type:"dp"},{type:"dp"},{type:"dp"}],dontMap:!0,inVokedIn:"PARAMS",fnName:"setMargins"},marginStart:{values:[{type:"dp"}],dontMap:!0,inVokedIn:"PARAMS",fnName:"setMarginStart"},marginEnd:{values:[{type:"dp"}],dontMap:!0,inVokedIn:"PARAMS",fnName:"setMarginEnd"},padding:{values:[{type:"dp"},{type:"dp"},{type:"dp"},{type:"dp"}],dontMap:!0,inVokedIn:"VIEW",fnName:"setPaddingRelative"},centerInParent:{values:[{type:"i",true:13,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},centerHorizontal:{values:[{type:"i",true:14,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},centerVertical:{values:[{type:"i",true:15,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},alignParentBottom:{values:[{type:"i",true:12,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},alignParentTop:{values:[{type:"i",true:10,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},alignParentLeft:{values:[{type:"i",true:9,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"},alignParentRight:{values:[{type:"i",true:11,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"}},n(r,"alignParentRight",{values:[{type:"i",true:11,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"}),n(r,"alignParentLeft",{values:[{type:"i",true:9,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"}),n(r,"leftOf",{values:[{type:"i",true:0,false:12121},{type:"i",dontMap:!0}],inVokedIn:"PARAMS",fnName:"addRule"}),n(r,"cornerRadius",{values:[{type:"dpf"}],dontMap:!0,inVokedIn:"DRAWABLE",fnName:"setCornerRadius"}),n(r,"stroke",{values:[{type:"dp"},{type:"s"}],dontMap:!0,inVokedIn:"DRAWABLE",fnName:"setStroke"}),n(r,"typeface",{values:[{type:"i",normal:0,bold:1,italic:2,bold_italic:3}],fnName:"setTypeface",inVokedIn:"VIEW"}),n(r,"background",{values:[{type:"s"}],dontMap:!0,inVokedIn:"DRAWABLE",fnName:"setColor"}),n(r,"backgroundDrawable",{values:[{type:"s"}],dontMap:!0,fnName:"setBackgroundDrawable",inVokedIn:"VIEW"}),n(r,"backgroundColor",{values:[{type:"s"}],dontMap:!0,inVokedIn:"VIEW",fnName:"setBackgroundColor"}),n(r,"color",{values:[{type:"s"}],dontMap:!0,fnName:"setTextColor",inVokedIn:"VIEW"}),n(r,"hintColor",{values:[{type:"s"}],dontMap:!0,fnName:"setHintTextColor",inVokedIn:"VIEW"}),n(r,"btnBackground",{values:[{type:"s"},{type:"i"}],dontMap:!0,inVokedIn:"MUTATEBG",fnName:"setColorFilter"}),n(r,"colorFilter",{values:[{type:"s"},{type:"i"}],dontMap:!0,inVokedIn:"VIEW",fnName:"setColorFilter"}),n(r,"btnColor",{values:[{type:"s"}],dontMap:!0,fnName:"setTextColor",inVokedIn:"VIEW"}),n(r,"shadowLayer",{values:[{type:"f"},{type:"f"},{type:"f"},{type:"i"}],dontMap:!0,fnName:"setShadowLayer",inVokedIn:"VIEW"}),n(r,"elevation",{values:[{type:"i"}],dontMap:!0,fnName:"setElevation",inVokedIn:"VIEW"}),n(r,"rotationX",{values:[{type:"f"}],dontMap:!0,fnName:"setRotationX",inVokedIn:"VIEW"}),n(r,"rotationY",{values:[{type:"f"}],dontMap:!0,fnName:"setRotationY",inVokedIn:"VIEW"}),n(r,"rotation",{values:[{type:"f"}],dontMap:!0,fnName:"setRotation",inVokedIn:"VIEW"}),n(r,"backgroundTint",{values:[{type:"s"}],dontMap:!0,fnName:"setBackgroundTintList",inVokedIn:"VIEW"}),n(r,"scrollBarX",{values:[{type:"b"}],dontMap:!0,fnName:"setHorizontalScrollBarEnabled",inVokedIn:"VIEW"}),n(r,"scrollBarY",{values:[{type:"b"}],dontMap:!0,fnName:"setVerticalScrollBarEnabled",inVokedIn:"VIEW"}),n(r,"clickable",{values:[{type:"b"}],dontMap:!0,fnName:"setClickable",inVokedIn:"VIEW"}),n(r,"focusable",{values:[{type:"b"}],dontMap:!0,
fnName:"setFocusable",inVokedIn:"VIEW"}),n(r,"selectable",{values:[{type:"b"}],dontMap:!0,fnName:"setBackgroundResource",inVokedIn:"VIEW"}),n(r,"selectableItem",{values:[{type:"b"}],dontMap:!0,fnName:"setBackgroundResource",inVokedIn:"VIEW"}),n(r,"values",{values:[{type:"s"}],dontMap:!0,fnName:"setAdapter",inVokedIn:"VIEW"}),n(r,"maxSeek",{values:[{type:"i"}],fnName:"setMax",inVokedIn:"VIEW",dontMap:!0}),n(r,"accessibilityHint",{values:[{type:"s"}],dontMap:"true",fnName:"setContentDescription",inVokedIn:"VIEW"}),r);t.exports=o},function(t,e,n){"use strict";function r(t,e,n){var r=function(){};return"undefined"!=typeof t.feedback?void("true"==t.feedback&&(t.feedback=_.map(r),window.__ALL_ONCLICKS.push(t.feedback))):void(t.onClick&&(t.feedback=_.map(r),window.__ALL_ONCLICKS.push(t.feedback)))}function o(t){var e,n,o={},i=0,a=0,u=t.padding;if(t.stroke&&delete t.padding,t.margin){var s=t.margin.split(",").map(function(t){return 1*t});t.marginStart=s[0]+"",t.marginEnd=s[2]+""}for(var c=Object.keys(t),f=0;f<c.length;f++)r(t,c,f),"undefined"==typeof t[c[f]]||null==t[c[f]]?delete t[c[f]]:"function"==typeof t[c[f]]?(t[c[f]]=_.map(t[c[f]]),"onClick"==c[f]&&(window.__FN_MAP[t[c[f]]]=t.text||t.id||"",t.allowMultipleClicks&&"false"!=t.allowMultipleClick||window.__THROTTELED_ACTIONS.push(t[c[f]]))):(c[f].indexOf("_")&&"a"==c[f].split("_")[0]?(e=v[c[f].split("_")[1]],n=!0):(e=v[c[f]],n=!1),"stroke"==c[f]&&!function(){var e=[0,0,0,0];u&&(e=u.split(",").map(function(t){return 1*t}));var n=1*t.stroke.split(",")[0];e=e.map(function(t){return t+n}),t.padding=e.join(","),c.push("padding")}(),e&&(n?(o.ANIMATION||(o.ANIMATION=[]),o.ANIMATION.push({key:c[f].split("_")[1],value:t[c[f]]})):(o[e.inVokedIn]||(o[e.inVokedIn]=[]),"width"==c[f]&&i++,"height"==c[f]&&a++,o[e.inVokedIn].push({key:c[f],value:t[c[f]]})),"pattern"!==c[f]&&"root"!==c[f]&&"id"!==c[f]&&"__filename"!==c[f]&&delete t[c[f]]));return"set"==h&&(o.PARAMS||(o.PARAMS=[]),i||o.PARAMS.push({key:"width",value:"wrap_content"}),a||o.PARAMS.push({key:"height",value:"wrap_content"})),o}function i(t){var e={linearLayout:"android.widget.LinearLayout$LayoutParams->new",scrollView:"android.widget.LinearLayout$LayoutParams->new",relativeLayout:"android.widget.RelativeLayout$LayoutParams->new",frameLayout:"android.widget.FrameLayout$LayoutParams->new",toolbar:"android.support.v7.widget.Toolbar$LayoutParams->new",view:"android.widget.LinearLayout$LayoutParams->new",horizontalScrollView:"android.widget.LinearLayout$LayoutParams->new",listView:"android.widget.LinearLayout$LayoutParams->new",expandableListView:"android.widget.LinearLayout$LayoutParams->new"};if(!e[t])throw new Error("No such view group found : "+t);return e[t]}function a(t){return t=t.indexOf(",")>-1?t.replace(/\,/g,"\\\\,"):t,t=t.indexOf(":")>-1?t.replace(/\:/g,"\\\\:"):t,t=t.indexOf(":")>-1?t.replace(/\=/g,"\\\\="):t,t=t.indexOf(";")>-1?t.replace(/\;/g,"\\\\;"):t}function u(t,e){if(!e.values)return"";var n,r="",o="text"==t.key||"hint"==t.key?t.value:t.value.replace(/ /g,"");"text"==t.key||"hint"==t.key?(n=[],n.push(a(o))):n=o.split(",");for(var i=0;i<e.values.length;i++)r+=e.values[i].type+"_",e.dontMap?r+=n[i]+",":e.values[i].dontMap?r+=n[i]+",":"width"==t.key||"height"==t.key?isNaN(1*n[i])?r+=e.values[i][n[i]]+",":r="dp_"+n[i]+",":r+=e.values[i][n[i]]+",";return r.substring(0,r.length-1)}function s(t,e){var n,r=w[e],o=m[e].ctr;if("get"==h&&("ANIMATION"==e||"DRAWABLE"==e||"PARAMS"==e))return o;if(!r||!r.required)return o;n=r.required.split(","),o+=":";for(var i=0;i<n.length;i++)for(var a=0;a<t.length;a++)n[i].trim()==t[a].key&&(o+=u(t[a],v[n[i].trim()])+",");return o.substring(0,o.length-1)}function c(t){return"set_html=android.text.Html->fromHtml:s_"+t+";"}function f(t,e){return e||(e="set_colorInt"),e+"=android.graphics.Color->parseColor:s_"+t+";"}function p(t,e,n,r){if("width"==t.key||"height"==t.key)return"";var o,i,s,p,l,d,h,y="",v="",w="",_=[];if(t.value+="","foreground"!=t.key&&"tabTextColors"!=t.key&&"selectedTabIndicatorColor"!=t.key&&"color"!=t.key&&"background"!=t.key&&"stroke"!=t.key&&"btnColor"!=t.key||("stroke"==t.key?(i=t.value.split(",")[1],o=u(t,e).split(",")[0]+",get_colorInt"):"tabTextColors"==t.key?(i=t.value.split(",")[0],h=t.value.split(",")[1],o="get_colorInt1,get_colorInt"):(i=t.value,o="get_colorInt"),w="tabTextColors"==t.key?f(i,"set_colorInt1")+","+f(h):f(i)),"fontStyle"==t.key&&(w="set_ast=ctx->getAssets;set_type=android.graphics.Typeface->createFromAsset:get_ast,s_fonts/"+t.value+".ttf;",o="get_type"),"dividerDrawable"==t.key&&(w="set_342372=ctx->getPackageName;set_res=ctx->getResources;set_368248=get_res->getIdentifier:s_"+t.value+",s_drawable,get_342372;set_res=ctx->getResources;set_482380=get_res->getDrawable:get_368248;",o="get_482380"),"textFromHtml"==t.key&&(w=c(a(t.value)),o="get_html"),"backgroundTint"==t.key&&(i=t.value,w=f(i)+"set_colorstate=android.content.res.ColorStateList->valueOf:get_colorInt;",o="get_colorstate"),"typeface"==t.key&&(w="set_face=this->getTypeface;",o="get_face,"+u(t,e)),"buttonTint"==t.key&&(i=t.value,w=f(i)+"set_colorstate=android.content.res.ColorStateList->valueOf:get_colorInt;",o="get_colorstate"),"hintColor"==t.key&&(i=t.value,w=f(i)+"set_colorstate=android.content.res.ColorStateList->valueOf:get_colorInt;",o="get_colorstate"),"btnBackground"==t.key&&(i=t.value,w="set_mode=android.graphics.PorterDuff->intToMode:i_9;"+f(i),o="get_colorInt,get_mode"),"selectableItem"==t.key&&(i=t.value,w="set_outv=android.util.TypedValue->new;set_theme=ctx->getTheme;get_theme->resolveAttribute:i_16843534,get_outv,b_true;set_c=get_outv->getClass;set_f=get_c->getDeclaredField:s_resourceId;get_f->setAccessible:b_true;set_v=get_f->get:get_outv;",o="get_v"),"url"==t.key&&(w="set_Setting=this->getSettings;get_Setting->setJavaScriptEnabled:b_true;get_Setting->setDomStorageEnabled:b_true;",o=u(t,e)),"imageUrl"==t.key&&(w="set_342372=ctx->getPackageName;set_res=ctx->getResources;set_368248=get_res->getIdentifier:s_"+t.value+",s_drawable,get_342372;set_res=ctx->getResources;set_482380=get_res->getDrawable:get_368248;",o="get_482380"),"backgroundDrawable"==t.key&&(w="set_342372=ctx->getPackageName;set_res=ctx->getResources;set_368248=get_res->getIdentifier:s_"+t.value+",s_drawable,get_342372;set_res=ctx->getResources;set_482380=get_res->getDrawable:get_368248;",o="get_482380"),"fontFamily"==t.key)return t.value=u(t,e),s=t.value.split(","),"set_fontFace=android.graphics.Typeface->create:"+s[0]+","+s[1]+";this->setTypeface:get_fontFace,"+s[1]+";";if("fontSize"==t.key&&(o=u(t,e).split(",")[0]+",f_"+window.__WIDTH*t.value.split(",")[1]*1/100),"curve"==t.key&&(w="set_interp=android.view.animation.DecelerateInterpolator->new;",o="get_interp"),"focus"==t.key&&(v="set_win=ctx->getWindow;get_win->setSoftInputMode:5;"),"shadowLayer"==t.key&&(i=t.value.split(",")[3],_=u(t,e).split(","),_.splice(_.length1,1),w=f(i),o=_.join(",")+",get_colorInt"),"values"==t.key){var x,g=t.value.split(","),E="";for(x=0;x<g.length;x++){var I=g[x].split(":");E+="get_spinnerArray->add:s_"+I[0];for(var b=1;b<I.length;b++)E+="\n"+I[b];E+=";"}w="set_spinnerArray=java.util.ArrayList->new;"+E+"set_spinnerValues=get_spinnerArray->toArray;set_spinnerAdapter=android.widget.ArrayAdapter->new:ctx_ctx,i_17367043,get_spinnerValues;",o="get_spinnerAdapter"}return p="VIEW"==n?m[n].val:"get_"+m[n].val,l=r||"duration"==t.key||"delay"==t.key||"curve"==t.key?p+"->"+("undefined"==typeof e.fnName?e.varName:e.fnName):p+"->"+t.key,e.values&&e.values.length&&(l+=":"),l+=w||o?o+";":u(t,e)+";","undefined"!=typeof d?(console.log(y+w+l+v),d):y+w+l+v}function l(t,e,n){for(var r,o="",i=0;i<t.length;i++)r=v[t[i].key],r&&(o+=p(t[i],r,e,n));return"VIEW"==e?o:s(t,e)+";"+o}function d(t,e,n){for(var r,o=Object.keys(e),a=0;a<o.length;a++)"FOREGROUND"==o[a]?m[o[a]]||("set"==h?(m[o[a]]={ctr:"android.graphics.drawable.GradientDrawable->new",val:o[a]},x+="set_"+m[o[a]].val+"="+l(e[o[a]],o[a],!0)+"this->setForeground:get_"+m[o[a]].val+";"):(m[o[a]]={ctr:"get_view->getForeground",val:o[a]},x+="set_"+m[o[a]].val+"="+l(e[o[a]],o[a],!0))):"LAYOUT_TRANSITION"==o[a]?(m.LAYOUT_TRANSITION={ctr:"android.animation.LayoutTransition->new",val:"LAYOUT_TRANSITION"},x+="set_"+m.LAYOUT_TRANSITION.val+"="+l(e.PARAMS,"LAYOUT_TRANSITION",!0)+"this->setLayoutTransition:get_"+m.LAYOUT_TRANSITION.val+";"):"VIEW"==o[a]?(m.VIEW||("set"==h?m.VIEW={ctr:"this",val:"this"}:m.VIEW={ctr:"get_view",val:"get_view"}),x+=l(e.VIEW,"VIEW",!0)):"PARAMS"==o[a]?"set"==h?(m.PARAMS||(r=n.root?i(t):"PARAM_CTR_HOLDER",m.PARAMS={ctr:r,val:"PARAMS"}),x+="set_"+m.PARAMS.val+"="+l(e.PARAMS,"PARAMS",!0)+"this->"+w.PARAMS.viewMethod.split(",")[0]+":get_"+m.PARAMS.val+";"):(m.PARAMS||(r="get_view->getLayoutParams",m.PARAMS={ctr:r,val:"PARAMS"}),x+="set_"+m.PARAMS.val+"="+l(e[o[a]],o[a],!0)):"MUTATEBG"==o[a]?(m.MUTATEBG||(m.MUTATEBG={ctr:"this->getBackground",val:"MUTATEBG"}),x+="set_"+m.MUTATEBG.val+"="+l(e[o[a]],o[a],!0)):"ANIMATION"==o[a]?(m.ANIMATION||("set"==h?m.ANIMATION={ctr:"this->animate",val:"ANIMATION"}:m.ANIMATION={ctr:"get_view->animate",val:"ANIMATION"}),x+="set_"+m.ANIMATION.val+"="+l(e[o[a]],o[a],!1)):m[o[a]]||("set"==h?(m[o[a]]={ctr:w[o[a]].ctr,val:o[a]},x+="set_"+m[o[a]].val+"="+l(e[o[a]],o[a],!0)+"this->"+w[o[a]].viewMethod.split(",")[0]+":get_"+m[o[a]].val+";"):(m[o[a]]={ctr:"get_view->getBackground",val:o[a]},x+="set_"+m[o[a]].val+"="+l(e[o[a]],o[a],!0)));return x.substring(0,x.length-1)}var h,y="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},v=n(83),w=n(174),_=n(81),m=(n(21),{}),x="",g=function t(e){var n={};for(var r in e)if(e.hasOwnProperty(r))if("object"==y(e[r])){var o=t(e[r]);for(var i in o)o.hasOwnProperty(i)&&(n[i]=o[i])}else n[r]=e[r];return n};t.exports=function(t,e,n){e=g(e),h=n;var r=o(e);x="",m={};for(var i=0,a=Object.keys(e),u=0;u<a.length;u++)if("runInUI"==a[u]){i=1;break}return i||(e.runInUI=d(t,r,e)),e}},function(t,e,n){"use strict";t.exports={android:n(82),ios:n(179),web:n(86),common:n(175)}},function(t,e,n){"use strict";t.exports={parseParams:n(87)}},function(t,e){"use strict";function n(t){var e=parseInt(t.substring(0,2),16),n=parseInt(t.substring(2,4),16),r=parseInt(t.substring(4,6),16);return e+","+n+","+r}function r(t){var e={};for(var n in t)if(t.hasOwnProperty(n))if("object"==u(t[n])){var o=r(t[n]);for(var i in o)o.hasOwnProperty(i)&&"undefined"!=typeof o[i]&&(e[i]=o[i])}else e[n]=t[n];return e}function o(t){if(t.length<8)return t;var e=parseInt(t.substring(1,3),16);e=(e/255).toFixed(2);var r=t.substring(3,9),o="rgba("+n(r)+","+e+")";return o}function i(t,e,n){if("undefined"==typeof e[n]||null==e[n])return void delete e[n];if(e.style||(e.style={},e.style.transform="",e.animation={},e.animation.transform=""),e.attributes||(e.attributes={}),e.style.className||(e.style.className=""),"onClick"==n&&(e.style.cursor="pointer"),"textSize"==n&&(e.style.fontSize=e.textSize),"imageUrl"==n&&(e.attributes.src=e.imageUrl+".png"),"background"==n&&(e.style.background=o(e.background)),"color"==n&&(e.style.color=o(e.color)),"cornerRadius"==n&&(e.style.borderRadius=e.cornerRadius+"px"),"alpha"==n&&(e.style.opacity=e[n]),"a_alpha"==n&&(e.animation.opacity=e[n]),"fontStyle"==n){var r=e.fontStyle.match(/[\/-]/),i=r?e.fontStyle.slice(0,r.index):e.fontStyle;if(e.style.fontFamily=i,!r)return;var a=e.fontStyle.slice(r.index+1);a=a.replace(/[-\/]/g,""),a=a.toLowerCase(),a.indexOf("italic")!=-1&&(e.style.fontStyle="italic"),a.indexOf("extralight")!=-1?a="200":a.indexOf("light")!=-1?a="300":a.indexOf("regular")!=-1||a.indexOf("book")!=-1?a="400":a.indexOf("semibold")!=-1||a.indexOf("medium")!=-1?a="500":a.indexOf("bold")!=-1||a.indexOf("heavy")!=-1?a="700":a.indexOf("black")!=-1&&(a="900"),e.style.fontWeight=a}if("stroke"==n){var u=e.stroke.split(",");e.style.border=u[0]+"px solid"+u[1]}"translationY"==n&&(e.style.transform+="translateY("+e[n]+"px) "),"a_translationY"==n&&(e.animation.transform+="translateY("+e[n]+"px) "),"translationX"==n&&(e.style.transform+="translateX("+e[n]+"px) "),"a_translationX"==n&&(e.animation.transform+="translateX("+e[n]+"px) "),"scaleX"==n&&(e.style.transform+="scaleX("+e[n]+") "),"a_scaleX"==n&&(e.animation.transform+="scaleX("+e[n]+") "),"scaleY"==n&&(e.style.transform+="scaleY("+e[n]+") "),"a_scaleY"==n&&(e.animation.transform+="scaleY("+e[n]+") "),"rotation"==n&&(e.style.transform+="rotate("+e[n]+"deg) "),"a_rotation"==n&&(e.animation.transform+="rotate("+e[n]+"deg) "),"rotationX"==n&&(e.style.transform+="rotateX("+e[n]+"deg) "),"a_rotationX"==n&&(e.animation.transform+="rotateX("+e[n]+"deg) "),"rotationY"==n&&(e.style.transform+="rotateY("+e[n]+"deg) "),"a_rotationY"==n&&(e.animation.transform+="rotateY("+e[n]+"deg) "),"translationZ"==n&&(e.style["z-index"]=e[n]),"a_duration"==n&&(e.animation.transition=e[n]+"ms all"),"textView"==t&&"gravity"==n&&e.gravity&&(e.style.textAlign=e.gravity),"id"==n&&(e.attributes.id=e.id),"lineHeight"==n&&(e.style.lineHeight=e.lineHeight)}function a(t,e){"linearLayout"==t&&(e.orientation=e.orientation)}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};Array.prototype.rotate=function(){var t=Array.prototype.push,e=Array.prototype.splice;return function(n){var r=this.length>>>0,n=n>>0;return n=(n%r+r)%r,t.apply(this,e.call(this,0,n)),this}}(),t.exports=function(t,e,n){e=r(e),a(t,e);for(var o=Object.keys(e),u=0;u<o.length;u++)i(t,e,o[u]);return e.transition="0ms all",""==e.style.transform&&delete e.style.transform,e}},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"setOrientation",value:function(t){this.orientation=this.props.orientation?"0":"1"}},{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t=this.props,e=this.resolveChildren();return this.setOrientation(t),u("scrollView",{id:this.props.id?this.props.id:this.idSet.id,params:t},e)}}]),e}(s);t.exports=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"render",value:function(){var t=this.props;return u("textView",{id:this.props.id?this.props.id:this.idSet.id,params:t})}}]),e}(s);t.exports=c},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(t){if(f===setTimeout)return setTimeout(t,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(e){try{return f.call(null,t,0)}catch(e){return f.call(this,t,0)}}}function i(t){if(p===clearTimeout)return clearTimeout(t);if((p===r||!p)&&clearTimeout)return p=clearTimeout,clearTimeout(t);try{return p(t)}catch(e){try{return p.call(null,t)}catch(e){return p.call(this,t)}}}function a(){y&&d&&(y=!1,d.length?h=d.concat(h):v=-1,h.length&&u())}function u(){if(!y){var t=o(a);y=!0;for(var e=h.length;e;){for(d=h,h=[];++v<e;)d&&d[v].run();v=-1,e=h.length}d=null,y=!1,i(t)}}function s(t,e){this.fun=t,this.array=e}function c(){}var f,p,l=t.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(t){f=n}try{p="function"==typeof clearTimeout?clearTimeout:r}catch(t){p=r}}();var d,h=[],y=!1,v=-1;l.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];h.push(new s(t,e)),1!==h.length||y||o(u)},s.prototype.run=function(){this.fun.apply(null,this.array)},l.title="browser",l.browser=!0,l.env={},l.argv=[],l.version="",l.versions={},l.on=c,l.addListener=c,l.once=c,l.off=c,l.removeListener=c,l.removeAllListeners=c,l.emit=c,l.prependListener=c,l.prependOnceListener=c,l.listeners=function(t){return[]},l.binding=function(t){throw new Error("process.binding is not supported")},l.cwd=function(){return"/"},l.chdir=function(t){throw new Error("process.chdir is not supported")},l.umask=function(){return 0}},function(t,e,n){var r=n(14),o=n(3),i=o(function(t,e,n){if(e>=n.length||e<-n.length)return n;var o=e<0?n.length:0,i=o+e,a=r(n);return a[i]=t(n[i]),a});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){return t&&e});t.exports=o},function(t,e,n){var r=n(1),o=n(4),i=n(116),a=r(o(["any"],i,function(t,e){for(var n=0;n<e.length;){if(t(e[n]))return!0;n+=1}return!1}));t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){return t.apply(this,e)});t.exports=o},function(t,e,n){var r=n(3),o=n(7),i=n(19),a=n(63),u=n(35),s=n(120),c=r(function t(e,n,r){if(0===e.length)return n;var c=e[0];if(e.length>1){var f=!s(r)&&o(c,r)?r[c]:a(e[1])?[]:{};n=t(Array.prototype.slice.call(e,1),n,f)}if(a(c)&&i(r)){var p=[].concat(r);return p[c]=n,p}return u(c,n,r)});t.exports=c},function(t,e,n){var r=n(16),o=n(1),i=o(function(t,e){return r(t.length,function(){return t.apply(e,arguments)})});t.exports=i},function(t,e,n){function r(){if(0===arguments.length)throw new Error("composeK requires at least one argument");var t=Array.prototype.slice.call(arguments),e=t.pop();return i(i.apply(this,a(o,t)),e)}var o=n(54),i=n(55),a=n(8);t.exports=r},function(t,e,n){var r=n(1),o=n(57),i=n(46),a=r(function(t,e){if(t>10)throw new Error("Constructor with greater than ten arguments");return 0===t?function(){return new e}:o(i(t,function(t,n,r,o,i,a,u,s,c,f){switch(arguments.length){case 1:return new e(t);case 2:return new e(t,n);case 3:return new e(t,n,r);case 4:return new e(t,n,r,o);case 5:return new e(t,n,r,o,i);case 6:return new e(t,n,r,o,i,a);case 7:return new e(t,n,r,o,i,a,u);case 8:return new e(t,n,r,o,i,a,u,s);case 9:return new e(t,n,r,o,i,a,u,s,c);case 10:return new e(t,n,r,o,i,a,u,s,c,f)}}))});t.exports=a},function(t,e,n){var r=n(1),o=n(42),i=n(6),a=n(25),u=n(31),s=n(18),c=r(function(t,e){return i(s(a,0,u("length",e)),function(){var n=arguments,r=this;return t.apply(r,o(function(t){return t.apply(r,n)},e))})});t.exports=c},function(t,e,n){var r=n(1),o=r(function(t,e){return null==e||e!==e?t:e});t.exports=o},function(t,e,n){var r=n(24),o=n(1),i=o(function(t,e){for(var n=[],o=0,i=t.length;o<i;)r(t[o],e)||r(t[o],n)||(n[n.length]=t[o]),o+=1;return n});t.exports=i},function(t,e,n){var r=n(37),o=n(3),i=o(function(t,e,n){for(var o=[],i=0,a=e.length;i<a;)r(t,e[i],n)||r(t,e[i],o)||o.push(e[i]),i+=1;return o});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){var n={};for(var r in e)n[r]=e[r];return delete n[t],n});t.exports=o},function(t,e,n){var r=n(1),o=n(4),i=n(272),a=n(15),u=r(o(["drop"],i,function(t,e){return a(Math.max(0,t),1/0,e)}));t.exports=u},function(t,e,n){var r=n(1),o=n(4),i=n(117),a=n(122),u=r(o([],i,function(t,e){var n=[],r=1,o=e.length;if(0!==o)for(n[0]=e[0];r<o;)t(a(n),e[r])||(n[n.length]=e[r]),r+=1;return n}));t.exports=u},function(t,e,n){var r=n(2),o=n(113),i=n(19),a=n(64),u=n(28),s=r(function(t){return null!=t&&"function"==typeof t["fantasy-land/empty"]?t["fantasy-land/empty"]():null!=t&&null!=t.constructor&&"function"==typeof t.constructor["fantasy-land/empty"]?t.constructor["fantasy-land/empty"]():null!=t&&"function"==typeof t.empty?t.empty():null!=t&&null!=t.constructor&&"function"==typeof t.constructor.empty?t.constructor.empty():i(t)?[]:u(t)?"":a(t)?{}:o(t)?function(){return arguments}():void 0});t.exports=s},function(t,e,n){var r=n(1),o=r(function(t,e){return t===e?0!==t||1/t===1/e:t!==t&&e!==e});t.exports=o},function(t,e,n){function r(t,e,n,a){var u=function(o){for(var i=e.length,u=0;u<i;){if(t===e[u])return n[u];u+=1}e[u+1]=t,n[u+1]=o;for(var s in t)o[s]=a?r(t[s],e,n,!0):t[s];return o};switch(i(t)){case"Object":return u({});case"Array":return u([]);case"Date":return new Date(t.valueOf());case"RegExp":return o(t);default:return t}}var o=n(109),i=n(70);t.exports=r},function(t,e){function n(t){return new RegExp(t.source,(t.global?"g":"")+(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.sticky?"y":"")+(t.unicode?"u":""))}t.exports=n},function(t,e){function n(t){return function(){return!t.apply(this,arguments)}}t.exports=n},function(t,e,n){function r(t){return i(function(e,n){return o(Math.max(0,e.length-n.length),function(){return e.apply(this,t(n,arguments))})})}var o=n(16),i=n(1);t.exports=r},function(t,e,n){function r(t,e,n){var r,i;if("function"==typeof t.indexOf)switch(typeof e){case"number":if(0===e){for(r=1/e;n<t.length;){if(i=t[n],0===i&&1/i===r)return n;n+=1}return-1}if(e!==e){for(;n<t.length;){if(i=t[n],"number"==typeof i&&i!==i)return n;n+=1}return-1}return t.indexOf(e,n);case"string":case"boolean":case"function":case"undefined":return t.indexOf(e,n);case"object":if(null===e)return t.indexOf(e,n)}for(;n<t.length;){if(o(t[n],e))return n;n+=1}return-1}var o=n(11);t.exports=r},function(t,e,n){var r=n(7),o=Object.prototype.toString,i=function(){return"[object Arguments]"===o.call(arguments)?function(t){return"[object Arguments]"===o.call(t)}:function(t){return r("callee",t)}};t.exports=i},function(t,e){function n(t){return"[object Number]"===Object.prototype.toString.call(t)}t.exports=n},function(t,e,n){function r(t){return function e(n){for(var r,i,a,u=[],s=0,c=n.length;s<c;){if(o(n[s]))for(r=t?e(n[s]):n[s],a=0,i=r.length;a<i;)u[u.length]=r[a],a+=1;else u[u.length]=n[s];s+=1}return u}}var o=n(39);t.exports=r},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.f=t,this.any=!1}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.any||(t=this.xf["@@transducer/step"](t,!1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)&&(this.any=!0,t=o(this.xf["@@transducer/step"](t,!0))),t},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.pred=t,this.lastValue=void 0,this.seenFirstValue=!1}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){var n=!1;return this.seenFirstValue?this.pred(this.lastValue,e)&&(n=!0):this.seenFirstValue=!0,this.lastValue=e,n?t:this.xf["@@transducer/step"](t,e)},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e){function n(t){return new r(t)}var r=function(){function t(t){this.f=t}return t.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},t.prototype["@@transducer/result"]=function(t){return t},t.prototype["@@transducer/step"]=function(t,e){return this.f(t,e)},t}();t.exports=n},function(t,e,n){var r=n(1),o=r(function(t,e){return null!=e&&e.constructor===t||e instanceof t});t.exports=o},function(t,e,n){var r=n(2),o=r(function(t){return null==t});t.exports=o},function(t,e,n){var r=n(2),o=n(99),i=r(function(t){return o(function(){return Array.prototype.slice.call(arguments,0)},t)});t.exports=i},function(t,e,n){var r=n(30),o=r(-1);t.exports=o},function(t,e,n){var r=n(2),o=n(114),i=r(function(t){return null!=t&&o(t.length)?t.length:NaN});t.exports=i},function(t,e,n){var r=n(1),o=n(12),i=n(53),a=n(6),u=n(8),s=r(function(t,e){var n=a(t,e);return a(t,function(){return o(i,u(n,arguments[0]),Array.prototype.slice.call(arguments,1))})});t.exports=s},function(t,e,n){var r=n(2),o=n(139),i=r(function(t){return o(t)/t.length});t.exports=i},function(t,e,n){var r=n(16),o=n(1),i=n(7),a=o(function(t,e){var n={};return r(e.length,function(){var r=t.apply(this,arguments);return i(r,n)||(n[r]=e.apply(this,arguments)),n[r]})});t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){return t*e});t.exports=o},function(t,e,n){var r=n(2),o=r(function(t){return!t});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){var n={};return n[t]=e,n});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return t||e});t.exports=o},function(t,e,n){var r=n(3),o=function(t){return{value:t,map:function(e){return o(e(t))}}},i=r(function(t,e,n){return t(function(t){return o(e(t))})(n).value});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n={},r=0,o=t.length;r<o;){var i=t[r];n[i]=e[i],r+=1}return n});t.exports=o},function(t,e,n){function r(){if(0===arguments.length)throw new Error("pipe requires at least one argument");return o(arguments[0].length,a(i,arguments[0],u(arguments)))}var o=n(16),i=n(263),a=n(18),u=n(68);t.exports=r},function(t,e,n){function r(){if(0===arguments.length)throw new Error("pipeP requires at least one argument");return o(arguments[0].length,a(i,arguments[0],u(arguments)))}var o=n(16),i=n(264),a=n(18),u=n(68);t.exports=r},function(t,e,n){var r=n(14),o=n(1),i=o(function(t,e){return r([t],e)});t.exports=i},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=n.length-1;r>=0;)e=t(n[r],e),r-=1;return e});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){var r=Array.prototype.slice.call(n,0);return r.splice(t,e),r});t.exports=o},function(t,e,n){var r=n(1),o=n(53),i=n(8),a=n(135),u=n(136),s=r(function(t,e){return"function"==typeof e.sequence?e.sequence(t):u(function(t,e){return o(i(a,t),e)},t([]),e)});t.exports=s},function(t,e,n){var r=n(34),o=n(18),i=o(r,0);t.exports=i},function(t,e,n){var r=n(1),o=n(104),i=r(function(t,e){return o(t>=0?e.length-t:0,e)});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){var n,r=Number(e),o=0;if(r<0||isNaN(r))throw new RangeError("n must be a non-negative number");for(n=new Array(r);o<r;)n[o]=t(o),o+=1;return n});t.exports=o},function(t,e,n){var r=n(251),o=n(1),i=o(function(t,e){for(var n,o,i=new r,a=[],u=0;u<e.length;)o=e[u],n=t(o),i.add(n)&&a.push(o),u+=1;return a});t.exports=i},function(t,e,n){var r=n(37),o=n(1),i=o(function(t,e){for(var n,o=0,i=e.length,a=[];o<i;)n=e[o],r(t,n,a)||(a[a.length]=n),o+=1;return a});t.exports=i},function(t,e,n){var r=n(1),o=n(6),i=r(function(t,e){return o(e.length,function(){for(var n=[],r=0;r<e.length;)n.push(e[r].call(this,arguments[r])),r+=1;return t.apply(this,n.concat(Array.prototype.slice.call(arguments,e.length)))})});t.exports=i},function(t,e,n){var r=n(2),o=n(17),i=r(function(t){for(var e=o(t),n=e.length,r=[],i=0;i<n;)r[i]=t[e[i]],i+=1;return r});t.exports=i},function(t,e,n){var r=n(1),o=n(7),i=r(function(t,e){for(var n in t)if(o(n,t)&&!t[n](e[n]))return!1;return!0});t.exports=i},function(t,e,n){t.exports=n(148)},function(t,e,n){"use strict";function r(t){var e=new a(t),n=i(a.prototype.request,e);return o.extend(n,a.prototype,e),o.extend(n,e),n}var o=n(9),i=n(77),a=n(150),u=n(50),s=r(u);s.Axios=a,s.create=function(t){return r(o.merge(u,t))},s.Cancel=n(74),s.CancelToken=n(149),s.isCancel=n(75),s.all=function(t){return Promise.all(t)},s.spread=n(164),t.exports=s,t.exports.default=s},function(t,e,n){"use strict";function r(t){if("function"!=typeof t)throw new TypeError("executor must be a function.");var e;this.promise=new Promise(function(t){e=t});var n=this;t(function(t){n.reason||(n.reason=new o(t),e(n.reason))})}var o=n(74);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var t,e=new r(function(e){t=e});return{token:e,cancel:t}},t.exports=r},function(t,e,n){"use strict";function r(t){this.defaults=t,this.interceptors={request:new a,response:new a}}var o=n(50),i=n(9),a=n(151),u=n(152);r.prototype.request=function(t){"string"==typeof t&&(t=i.merge({url:arguments[0]},arguments[1])),t=i.merge(o,this.defaults,{method:"get"},t),t.method=t.method.toLowerCase();var e=[u,void 0],n=Promise.resolve(t);for(this.interceptors.request.forEach(function(t){e.unshift(t.fulfilled,t.rejected)}),this.interceptors.response.forEach(function(t){e.push(t.fulfilled,t.rejected)});e.length;)n=n.then(e.shift(),e.shift());return n},i.forEach(["delete","get","head","options"],function(t){r.prototype[t]=function(e,n){return this.request(i.merge(n||{},{method:t,url:e}))}}),i.forEach(["post","put","patch"],function(t){r.prototype[t]=function(e,n,r){return this.request(i.merge(r||{},{method:t,url:e,data:n}))}}),t.exports=r},function(t,e,n){"use strict";function r(){this.handlers=[]}var o=n(9);r.prototype.use=function(t,e){return this.handlers.push({fulfilled:t,rejected:e}),this.handlers.length-1},r.prototype.eject=function(t){this.handlers[t]&&(this.handlers[t]=null)},r.prototype.forEach=function(t){o.forEach(this.handlers,function(e){null!==e&&t(e)})},t.exports=r},function(t,e,n){"use strict";function r(t){t.cancelToken&&t.cancelToken.throwIfRequested()}var o=n(9),i=n(155),a=n(75),u=n(50),s=n(160),c=n(158);t.exports=function(t){r(t),t.baseURL&&!s(t.url)&&(t.url=c(t.baseURL,t.url)),t.headers=t.headers||{},t.data=i(t.data,t.headers,t.transformRequest),t.headers=o.merge(t.headers.common||{},t.headers[t.method]||{},t.headers||{}),o.forEach(["delete","get","head","post","put","patch","common"],function(e){delete t.headers[e]});var e=t.adapter||u.adapter;return e(t).then(function(e){return r(t),e.data=i(e.data,e.headers,t.transformResponse),e},function(e){return a(e)||(r(t),e&&e.response&&(e.response.data=i(e.response.data,e.response.headers,t.transformResponse))),Promise.reject(e)})}},function(t,e){"use strict";t.exports=function(t,e,n,r,o){return t.config=e,n&&(t.code=n),t.request=r,t.response=o,t}},function(t,e,n){"use strict";var r=n(76);t.exports=function(t,e,n){var o=n.config.validateStatus;n.status&&o&&!o(n.status)?e(r("Request failed with status code "+n.status,n.config,null,n.request,n)):t(n)}},function(t,e,n){"use strict";var r=n(9);t.exports=function(t,e,n){return r.forEach(n,function(n){t=n(t,e)}),t}},function(t,e){"use strict";function n(){this.message="String contains an invalid character"}function r(t){for(var e,r,i=String(t),a="",u=0,s=o;i.charAt(0|u)||(s="=",u%1);a+=s.charAt(63&e>>8-u%1*8)){if(r=i.charCodeAt(u+=.75),r>255)throw new n;e=e<<8|r}return a}var o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";n.prototype=new Error,n.prototype.code=5,n.prototype.name="InvalidCharacterError",t.exports=r},function(t,e,n){"use strict";function r(t){return encodeURIComponent(t).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var o=n(9);t.exports=function(t,e,n){if(!e)return t;var i;if(n)i=n(e);else if(o.isURLSearchParams(e))i=e.toString();else{
var a=[];o.forEach(e,function(t,e){null!==t&&"undefined"!=typeof t&&(o.isArray(t)&&(e+="[]"),o.isArray(t)||(t=[t]),o.forEach(t,function(t){o.isDate(t)?t=t.toISOString():o.isObject(t)&&(t=JSON.stringify(t)),a.push(r(e)+"="+r(t))}))}),i=a.join("&")}return i&&(t+=(t.indexOf("?")===-1?"?":"&")+i),t}},function(t,e){"use strict";t.exports=function(t,e){return e?t.replace(/\/+$/,"")+"/"+e.replace(/^\/+/,""):t}},function(t,e,n){"use strict";var r=n(9);t.exports=r.isStandardBrowserEnv()?function(){return{write:function(t,e,n,o,i,a){var u=[];u.push(t+"="+encodeURIComponent(e)),r.isNumber(n)&&u.push("expires="+new Date(n).toGMTString()),r.isString(o)&&u.push("path="+o),r.isString(i)&&u.push("domain="+i),a===!0&&u.push("secure"),document.cookie=u.join("; ")},read:function(t){var e=document.cookie.match(new RegExp("(^|;\\s*)("+t+")=([^;]*)"));return e?decodeURIComponent(e[3]):null},remove:function(t){this.write(t,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(t,e){"use strict";t.exports=function(t){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t)}},function(t,e,n){"use strict";var r=n(9);t.exports=r.isStandardBrowserEnv()?function(){function t(t){var e=t;return n&&(o.setAttribute("href",e),e=o.href),o.setAttribute("href",e),{href:o.href,protocol:o.protocol?o.protocol.replace(/:$/,""):"",host:o.host,search:o.search?o.search.replace(/^\?/,""):"",hash:o.hash?o.hash.replace(/^#/,""):"",hostname:o.hostname,port:o.port,pathname:"/"===o.pathname.charAt(0)?o.pathname:"/"+o.pathname}}var e,n=/(msie|trident)/i.test(navigator.userAgent),o=document.createElement("a");return e=t(window.location.href),function(n){var o=r.isString(n)?t(n):n;return o.protocol===e.protocol&&o.host===e.host}}():function(){return function(){return!0}}()},function(t,e,n){"use strict";var r=n(9);t.exports=function(t,e){r.forEach(t,function(n,r){r!==e&&r.toUpperCase()===e.toUpperCase()&&(t[e]=n,delete t[r])})}},function(t,e,n){"use strict";var r=n(9),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];t.exports=function(t){var e,n,i,a={};return t?(r.forEach(t.split("\n"),function(t){if(i=t.indexOf(":"),e=r.trim(t.substr(0,i)).toLowerCase(),n=r.trim(t.substr(i+1)),e){if(a[e]&&o.indexOf(e)>=0)return;"set-cookie"===e?a[e]=(a[e]?a[e]:[]).concat([n]):a[e]=a[e]?a[e]+", "+n:n}}),a):a}},function(t,e){"use strict";t.exports=function(t){return function(e){return t.apply(null,e)}}},function(t,e,n){"use strict";var r=n(166);t.exports={getScreenDimensions:function(){return JSON.stringify({width:window.__DEVICE_DETAILS.screen_width,height:window.__DEVICE_DETAILS.screen_height})},runInUI:function(t){"string"!=typeof t&&r.runInUI(t)},Render:function(t,e){var n={type:"linearLayout",props:{h:window.__HEIGHT,w:window.__WIDTH},children:[t]};r.computeChildDimens(n),t=r.inflate(t),t&&window.webkit.messageHandlers.IOS.postMessage(JSON.stringify({methodName:"render",parameters:{view:t}})),"function"==typeof e&&e()},addViewToParent:function(t,e,n,o,i){if(!window.__VIEWS[t])return console.error(new Error("AddViewToParent: Invalid parent ID: "+t));var a=window.__VIEWS[t];a.children.splice(n,0,e),e.props.parentId=t,r.computeChildDimens(a),e=r.inflate(e),"linearLayout"==a.type&&(a.children.forEach(function(t){t.props.id!=e.props.id&&r.inflate(t)}),a.props.parentIsScroll&&r.inflate(window.__VIEWS[a.props.parentId])),e&&window.webkit.messageHandlers.IOS.postMessage(JSON.stringify({methodName:"addViewToParent",parameters:{index:n,parentId:t,view:e}})),"function"==typeof o&&o()}}},function(t,e,n){"use strict";function r(t){var e=t.type.toLocaleLowerCase().indexOf("scroll")!=-1&&t.type;return!!e&&(t.children.length>1&&console.error(new Error("(Horizontal)ScrollView must have only one child")),1==t.children.length&&(t.children[0].props.parentIsScroll=e,!0))}function o(t){var e="vertical"==t.props.orientation,n=e?"h":"w",r=e?"y":"x",o=e?2:3;if(0==t.children.length)return void(t.props[n]="0");for(var i=void 0,a=t.children.length-1;a>=0&&(i=t.children[a],"gone"==i.props.visibility);a--)i=null;if(!i)return void(t.props[n]="0");var u=i.props.margin?i.props.margin.split(",").map(function(t){return 1*t}):[0,0,0,0],s=t.props.padding?t.props.padding.split(",").map(function(t){return 1*t}):[0,0,0,0],c=1*i.props[r]+1*i.props[n]+u[o]+s[o];t.props[n]=c+""}function i(t,e){if(0!=e.length){var n=e[0],r="vertical"==n.props.orientation,o=n.props.margin?n.props.margin.split(",").map(function(t){return 1*t}):[0,0,0,0],i=t.props.padding?t.props.padding.split(",").map(function(t){return 1*t}):[0,0,0,0],a=1*n.props.h,u=1*n.props.w;r?a+=i[1]+i[3]+o[1]+o[3]:u+=i[0]+i[2]+o[0]+o[2],t.props.contentWidth=u+"",t.props.contentHeight=a+""}}function a(t){o(t.children[0]),i(t,t.children);var e=[];return e.push([t.type,{id:t.props.id,contentWidth:t.props.contentWidth,contentHeight:t.props.contentHeight}]),e.push([t.children[0].type,{id:t.children[0].props.id,w:t.children[0].props.w,h:t.children[0].props.h,x:t.children[0].props.x,y:t.children[0].props.y}]),e}function u(t){var e=t.props.id,n=!1,c=r(t),d="undefined"!=typeof t.props.parentIsScroll;if(!e)return console.error(new Error("A view should have a valid ID"));if(window.__VIEWS.hasOwnProperty(e)&&(n=!0),!n){f(t),d&&o(t),p.cacheDimen(t),window.__VIEWS[e]=t;var y=l.clone(t);t.children.forEach(function(t,e){y.children[e]=u(t)}),c&&i(y,t.children);var v=s(y.type,y.props,"set");return y.props=v.config,y.type=v.type[0].toUpperCase()+v.type.substr(1,v.type.length),y}var w=p.shouldMove(t),_=p.shouldInfateChilds(t);return p.cacheDimen(t),w&&h(t.type,w),c?a(t).forEach(function(t){return h(t[0],t[1])}):(_&&(f(t),t.children.forEach(u)),null)}var s=n(33),c=n(79),f=c.computeChildDimens,p=n(22),l=n(21),d=function(t){t instanceof Array||(t=[t]),t.forEach(function(t){var e=t.id;if(!window.__VIEWS.hasOwnProperty(e))return console.error(new Error("Invalid ID: "+e));var n=window.__VIEWS[e],r=window.__VIEWS[n.props.parentId];if(n.props=l.merge(n.props,t),f(r),h(n.type,t),r.children.forEach(function(t){return u(t)}),r.props.parentIsScroll){var o=window.__VIEWS[r.props.parentId];a(o).forEach(function(t){return h(t[0],t[1])})}})},h=function(t,e){var n=s(t,e,"get").config.methods;window.webkit.messageHandlers.IOS.postMessage(JSON.stringify({methodName:"runInUI",parameters:n}))};t.exports={inflate:u,computeChildDimens:f,runInUI:d}},function(t,e,n){"use strict";var r=n(51);n(21);t.exports={getScreenDimensions:function(){var t=document.getElementById("content");return JSON.stringify({width:t.offsetWidth,height:t.offsetHeight})},runInUI:function(t){"string"!=typeof t&&r.runInUI(t)},Render:function(t,e){var n=document.getElementById("content"),o={type:"linearLayout",props:{h:n.clientHeight,w:n.clientWidth},children:[t]};r.computeChildDimens(o),r.inflateView(t,n),e&&window.callUICallback(e)},addViewToParent:function(t,e,n,o,i){var a=document.getElementById(t),u=(window.__VIEWS[t].props,a.className,Array.prototype.slice.call(a.children));i&&u.forEach(function(t){t.remove()});var s=window.__VIEWS[t];s.children.splice(n,0,e),r.computeChildDimens(s),"linearLayout"===s.type?s.children.forEach(function(t){r.inflateView(t,a)}):r.inflateView(e,a),o&&window.callUICallback(o)}}},function(t,e,n){"use strict";var r=n(169),o=n(147),i=n(51);t.exports={getSymbol:function(t){switch(t){case"tick":return"✓";case"rupee":return"₹";default:return"symbol"}},listViewAdapter:function(t,e,n,r,o){var a=document.getElementById(t);if(!a)return void console.error(new Error("Listview parent null"));for(;a.firstElementChild;)a.removeChild(a.firstElementChild);var u=JSON.parse(e),s=window.__VIEWS[a.id];if(u.map(function(t,e){s.children.push(t.view),s.type="linearLayout",i.computeChildDimens(s),s.type="listView";var r=i.inflateView(t.view,a);r.addEventListener("click",function(){window.callJSCallback(n,[e])}),Android.runInUI(t.value)}),o){var c=document.createElement("div");c.style.width="100%",c.style.height="100px",c.style.borderBottom="1px solid #eee",a.appendChild(c);var f=JSON.parse(o);console.log(f,"more"),i.inflateView(JSON.parse(o),c)}},callAPI:function(t,e,n,r,i,a){o({method:t,url:e,data:JSON.parse(n),headers:JSON.parse(r)}).then(function(t){window.callJSCallback(a,"success",btoa(JSON.stringify(t.data)),t.status)}).catch(function(t){console.log(t)})},getFromSharedPrefs:function(t){return localStorage.getItem(t)||"__failed"},setInSharedPrefs:function(t,e){localStorage.setItem(t,e)},viewPagerAdapter:function(t,e,n,o){r.createTabs(t,e,n,o)},switchToViewPagerIndex:function(t){r.toggleView(t)},getKey:function(t,e){return localStorage.getItem(t)||e},setKey:function(t,e){return localStorage.setItem(t,e)}}},function(t,e,n){"use strict";function r(){var t=document.createElement("div");return t.className="tab",t}function o(){var t=document.createElement("div");return t.className="tab-titleWrapper",t}function i(){var t=document.createElement("div");return t.className="tab-contentWrapper",t}function a(t){var e=document.createElement("div");return e.innerHTML=t,e.className="tab-title",e}function u(t){var e=s.inflateView(t.view);return e.className+=" tab-content",e}var s=n(51),c=function(t,e,n,s,c){var f,p=r(),l=o(),d=i();p.appendChild(l),p.appendChild(d),s.forEach(function(t,e){f=a(t.value),0==e&&(f.className+=" tab-title-active"),l.appendChild(f)}),n.forEach(function(t,e){f=u(t),0==e&&(f.className+=" tab-content-active"),d.appendChild(f)}),document.getElementById(e).appendChild(p),window.callUICallback(c,"0")};t.exports={createTabs:c}},function(t,e,n){"use strict";function r(t,e){var n={action:t,state:e};setTimeout(function(){o.handle(y(n),null)},0)}var o=(n(21),n(80)),i=n(78),a=void 0,u=function(t,e){if(a.screens[t])return new a.screens[t](null,null,e);throw new Error("Current screen not handled. "+t)},s=function(t){window.__CACHED_SCREENS[t.action].screen=u(t.action,t.state),window.__CACHED_SCREENS[t.action].timeStamp=(new Date).getTime()},c=function(t,e){if("undefined"==typeof e.screen.shouldStackScreen||e.screen.shouldStackScreen){var n=window.__SCREEN_STACK.length;n?window.__SCREEN_STACK[n-1]!==t&&window.__SCREEN_STACK.push(t):window.__SCREEN_STACK.push(t)}},f=function(t){var e=void 0,n=!1,r=!0,o=window.__CACHED_SCREENS[t.action];return o?(n=!0,e=o.screen,"undefined"==typeof e.shouldCacheScreen||e.shouldCacheScreen||(s(t),r=!1)):(window.__ANIMATE_DIR=1,e=u(t.action,t.state),o={index:window.__SCREEN_COUNT,screen:e,timeStamp:(new Date).getTime()},window.__SCREEN_COUNT++,window.__CACHED_SCREENS[t.action]=o),c(t.action,window.__CACHED_SCREENS[t.action]),{screen:o.screen,isCached:n,takeFromCache:r}},p=function(t,e){window.__SCREEN_INDEX++;var n=t.render();window.__ROOTSCREEN.appendChild(window.__ROOTSCREEN.idSet.root,n,window.__SCREEN_INDEX,t.afterRender),e||"IOS"==window.__OS||l()},l=function(){var t=window.__CACHED_SCREENS[window.__PREV_SCREEN].screen.layout.idSet.id,e=window.__CACHED_SCREENS[window.__CURR_SCREEN].screen.layout.idSet.id,n=window.__ANIMATE_DIR,r=void 0;r=1==n?window.__CACHED_SCREENS[window.__CURR_SCREEN].screen.screenTransition:window.__CACHED_SCREENS[window.__PREV_SCREEN].screen.screenTransition;var o=i.getAnimation(t,e,n,r);setTimeout(function(){Android.runInUI(o,null)},0)},d=function(){return window.__CACHED_SCREENS[window.__CURR_SCREEN].timeStamp>=window.__CACHED_SCREENS[window.__PREV_SCREEN].timeStamp?1:-1},h=function(t){var e=window.__SCREEN_STACK.length;if(1==e)return void("function"==typeof window.__ROOTSCREEN.minimizeApp&&window.__ROOTSCREEN.minimizeApp());var n=window.__CACHED_SCREENS[window.__CURR_SCREEN];if("function"!=typeof n.screen.onBackPress||n.screen.onBackPress()){window.__PREV_SCREEN=window.__SCREEN_STACK[e-1],window.__CURR_SCREEN=window.__SCREEN_STACK[e-2],window.__SCREEN_STACK.pop();var r=window.__CACHED_SCREENS[window.__CURR_SCREEN].screen;t.action=window.__CURR_SCREEN,"undefined"==typeof r.shouldCacheScreen||r.shouldCacheScreen?(window.__ANIMATE_DIR=-1,l(),"function"==typeof r.onPop&&r.onPop(t.state,"backPress")):(s(t),window.__ANIMATE_DIR=d(),p(window.__CACHED_SCREENS[window.__CURR_SCREEN].screen))}},y=function(t){var e=void 0;return"GO_BACK"==t.action?(h(t),{}):"INIT_UI"==t.action?(window.__ROOTSCREEN=u("RootScreen",t.state),setTimeout(function(){r(a.INIT_UI,{})},0),{render:window.__ROOTSCREEN.render()}):window.__CURR_SCREEN==t.action?{}:window.__CURR_SCREEN||window.__PREV_SCREEN?(window.__PREV_SCREEN=window.__CURR_SCREEN,window.__CURR_SCREEN=t.action,e=f(t),e.isCached?(e.takeFromCache?(window.__ANIMATE_DIR=d(),l(),"function"==typeof e.screen.onPop&&e.screen.onPop(t.state)):(window.__ANIMATE_DIR=d(),p(e.screen)),{}):(p(e.screen),{})):(window.__CURR_SCREEN=t.action,p(f(t).screen,!0),{})};t.exports={init:function(){var t={},e=JBridge.getIntentData();if(e&&null!=e&&"{}"!=e&&(e=JSON.parse(e),e.type&&"GCM"==e.type)){var n=JSON.parse(e.data);t.gcmData=n,window.__GCM_INTENT=!0}r("INIT_UI",t)},changeScreen:function(t,e){r(t,e)},registerScreenMeta:function(t){a=t}}},function(t,e,n){"use strict";function r(t){var e={linearLayout:"android.widget.LinearLayout$LayoutParams->new",coordinatorLayout:"android.widget.CoordinatorLayout$LayoutParams->new",scrollView:"android.widget.LinearLayout$LayoutParams->new",horizontalScrollView:"android.widget.LinearLayout$LayoutParams->new",relativeLayout:"android.widget.RelativeLayout$LayoutParams->new",frameLayout:"android.widget.FrameLayout$LayoutParams->new",toolbar:"android.support.v7.widget.Toolbar$LayoutParams->new",collapsingToolbarLayout:"android.support.design.widget.CoordinatorLayout$LayoutParams->new",appBarLayout:"android.support.design.widget.AppBarLayout$LayoutParams->new",view:"android.widget.LinearLayout$LayoutParams->new",tabLayout:"android.widget.LinearLayout$LayoutParams->new",viewPager:"android.support.v4.view.ViewPager$LayoutParams->new",listView:"android.widget.LinearLayout$LayoutParams->new",expandableListView:"android.widget.LinearLayout$LayoutParams->new",recyclerView:"android.support.v7.widget.RecyclerView$LayoutParams->new",ratingBar:"android.widget.LinearLayout$LayoutParams->new"};return e[t]}var o={CoordinatorLayout:"android.support.design.widget.",FloatingActionButton:"android.support.design.widget.",Toolbar:"android.support.v7.widget.",AppBarLayout:"android.support.design.widget.",CollapsingToolbarLayout:"android.support.design.widget.",View:"android.view.",WebView:"android.webkit.",ViewPager:"android.support.v4.view.",RotateAnimation:"android.view.animation.",LinearInterpolator:"android.view.animation.",Animation:"android.view.animation."};Array.prototype.flatten=function(){return this.reduce(function(t,e){var n=[].concat(e).some(Array.isArray);return t.concat(n?e.flatten():e)},[])};var i=n(82).parseParams;t.exports=function(t,e){for(var n=arguments.length,a=Array(n>2?n-2:0),u=2;u<n;u++)a[u-2]=arguments[u];var s;if(a=a.flatten(),e||(e={}),"string"==typeof t){s=r(t),e=i(t,e,"set"),e.node_id=window.__NODE_ID+"",window.__NODE_ID++,e.__filename||(e.__filename="filename not added");for(var c=0;c<a.length;c++)a[c].props.runInUI&&(a[c].props.runInUI=a[c].props.runInUI.replace("PARAM_CTR_HOLDER",s));t=t[0].toUpperCase()+t.substr(1,t.length);for(var f in o)if(f===t)return{type:o[f]+t,props:e,children:a};return{type:"android.widget."+t,props:e,children:a}}return new t(e,a)}},function(t,e){"use strict";function n(t){var e={};for(var o in t)if(t.hasOwnProperty(o))if("object"==r(t[o])){var i=n(t[o]);for(var a in i)i.hasOwnProperty(a)&&"undefined"!=typeof i[a]&&(e[a]=i[a])}else e[o]=t[o];return e}var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};Array.prototype.flatten=function(){return this.reduce(function(t,e){var n=[].concat(e).some(Array.isArray);return t.concat(n?e.flatten():e)},[])},t.exports=function(t,e){for(var r=arguments.length,o=Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];return o=o.flatten(),e||(e={}),"string"==typeof t?(e.node_id=window.__NODE_ID+"",e=n(e),window.__NODE_ID++,o.forEach(function(t){t.props.parentId=e.id}),e.__filename||(e.__filename="filename not added"),{type:t,props:e,children:o}):new t(e,o)}},function(t,e,n){"use strict";var r=n(86).parseParams;Array.prototype.flatten=function(){return this.reduce(function(t,e){var n=[].concat(e).some(Array.isArray);return t.concat(n?e.flatten():e)},[])},t.exports=function(t,e){for(var n=arguments.length,o=Array(n>2?n-2:0),i=2;i<n;i++)o[i-2]=arguments[i];if(o=o.flatten(),e||(e={}),"string"==typeof t){e=r(t,e);var a={props:e,type:t,children:o};return window.__VIEWS[e.id]=a,a}return new t(e,o)}},function(t,e){"use strict";var n={PARAMS:{required:"width, height",viewMethod:"setLayoutParams,getLayoutParams"},DRAWABLE:{ctr:"android.graphics.drawable.GradientDrawable->new",required:"",viewMethod:"setBackground,getBackground"}};t.exports=n},function(t,e){"use strict";t.exports={}},function(t,e){"use strict";t.exports.map=function(t){if("undefined"!=typeof window.__FN_INDEX&&null!==window.__FN_INDEX){var e="F"+window.__FN_INDEX;return window.__PROXY_FN[e]=t,window.__FN_INDEX++,e}throw new Error("Please initialise window.__FN_INDEX = 0 in index.js of your project.")},t.exports.callJSCallback=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];var r=e[0],o=e.slice(1);window.__PROXY_FN[r].call(null,o)}},function(t,e){"use strict";t.exports=["#83FCE8","#89F6E4","#8FEFDF","#96E9DB","#9CE3D7","#FEE9E6","#FEF7E7","#FFFAE5","#F5FAEB","#E5FFF5"]},function(t,e){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function t(e){var r={};for(var o in e)if(e.hasOwnProperty(o))if("object"==n(e[o])){var i=t(e[o]);for(var a in i)i.hasOwnProperty(a)&&(r[a]=i[a])}else r[o]=e[o];return r}},function(t,e,n){"use strict";t.exports={parseParams:n(33)}},function(t,e,n){"use strict";function r(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function o(){for(var t=document.getElementsByClassName("popupMenu"),e=0;e<t.length;e++)t[e].style.display="none"}var i=n(170),a=n(22).getOS,u=n(22).merge,s=function(){return(new Date).getTime()};window.__OS=a(),"WEB"==window.__OS?(window.Android=n(167),window.JBridge=n(168)):"IOS"==window.__OS&&(window.Android=n(165),window.JBridge=u(window.JBridge,{})),window.__ENV=0;var c=function(){try{var t=JSON.parse(Android.getScreenDimensions());return{screen_width:t.width+"",screen_height:t.height+""}}catch(t){return console.error("error in gettting screen dimensions, setting default values",t),{screen_width:"720",screen_height:"1920"}}};window.__ENV||(window.__DEVICE_DETAILS=c()),window.callJSCallback=n(85).android.callbackMapper.callJSCallback,window.__WIDTH=window.__DEVICE_DETAILS.screen_width,window.__HEIGHT=window.__DEVICE_DETAILS.screen_height,window.__ID=1,window.__NODE_ID=1,window.__SCREEN_INDEX=-1,window.__IOS_VIEWS={},window.__COLOR_INDEX=window.__COLOR_INDEX||1,window.__FONT_INDEX=window.__FONT_INDEX||1,window.__RECT_INDEX=window.RECT_INDEX||1,window.__VIEW_INDEX=window.__VIEW_INDEX||1,window.__IMAGE_INDEX=window.__IMAGE_INDEX||1,window.__POINT_INDEX=window.__POINT_INDEX||1,window.__LAYER_INDEX=window.__LAYER_INDEX||1,window.__SIZE_INDEX=window.__SIZE_INDEX||1,window.__PROXY_FN={},window.__FN_INDEX=0,window.__FN_MAP={},window.__ROOTSCREEN=null,window.__CACHED_SCREENS={},window.__SCREEN_COUNT=0,window.__CURR_SCREEN=null,window.__PREV_SCREEN=null,window.__ANIMATE_DIR=null,window.__SCREEN_STACK=[],window.__LAST_FN_CALLED=null,window.__THROTTELED_ACTIONS=[],window.__ALL_ONCLICKS=[],window.__VIEWS={},window.__VIEW_DIMENSIONS={},window.LANGUAGE="en_US",window.ZIndex=0,JBridge.hasOwnProperty("getKey")&&(window.LANGUAGE=JBridge.getKey("languagePref","en_US")),window.updateLanguage=function(t){window.LANGUAGE=t,JBridge.setKey("languagePref",t)},window.onresize=function(t){var e=window.__ROOTSCREEN&&window.__ROOTSCREEN.idSet.root;if(!e)return console.error(new Error("Window Resize: id `root` of rootscreen not available"));if("IOS"==window.__OS){var n=t.tag;"keyboardWillHide"==n?window.__OLD_HEIGHT&&(window.__HEIGHT=window.__OLD_HEIGHT):(window.__OLD_HEIGHT=window.__HEIGHT,window.__HEIGHT=1*window.__HEIGHT-1*t.data.height+"")}else window.__DEVICE_DETAILS=c(),window.__WIDTH=window.__DEVICE_DETAILS.screen_width,window.__HEIGHT=window.__DEVICE_DETAILS.screen_height;Android.Render(window.__VIEWS[e],null)},window.callUICallback=function(){var t,e,n=1===arguments.length?[arguments[0]]:Array.apply(null,arguments),o=n[0],i=n.slice(1);if(window.__ALL_ONCLICKS.indexOf(o)!=-1&&"feedback"==n[2])return JBridge.setClickFeedback(n[1]);if(window.__THROTTELED_ACTIONS.indexOf(o)==-1){var a;(a=window.__PROXY_FN[o]).call.apply(a,[null].concat(r(i)))}else if(window.__LAST_FN_CALLED&&o==window.__LAST_FN_CALLED.fName)if(t=s(),e=t-window.__LAST_FN_CALLED.timeStamp,e>=2e3){var u;console.log("BUTTON_CLICKED_"+window.__CURR_SCREEN),JBridge.trackEvent("BUTTON_CLICKED","BUTTON_CLICKED_"+window.__CURR_SCREEN),(u=window.__PROXY_FN[o]).call.apply(u,[null].concat(r(i))),window.__LAST_FN_CALLED.timeStamp=t}else console.warn("function throtteled",o),console.warn("time diff",e);else{var c;JBridge.trackEvent("BUTTON_CLICKED","BUTTON_CLICKED_"+window.__CURR_SCREEN),(c=window.__PROXY_FN[o]).call.apply(c,[null].concat(r(i))),window.__LAST_FN_CALLED={timeStamp:(new Date).getTime(),fName:o}}},window.onBackPressed=function(){JBridge.trackEvent("INFO","BACKPRESSED_"+window.__CURR_SCREEN),window.__CACHED_SCREENS[window.__CURR_SCREEN].screen.onBackPressed()},window.onActivityLifeCycleEvent=function(t){var e=window.__CACHED_SCREENS[window.__CURR_SCREEN].screen.onActivityLifeCycleEvent;e&&e(t)};var f=function(t,e){var n=window.__SCREEN_STACK.length;if(window.__duiCb=t,"WEB"==window.__OS&&o(),e.screen==window.__CURR_SCREEN){var r=window.__CACHED_SCREENS[__CURR_SCREEN].screen.handleStateChange(e);return void("function"==typeof r&&r(e))}return n>=2&&window.__SCREEN_STACK[n-2]==e.screen?i.changeScreen("GO_BACK",e):void i.changeScreen(e.screen,e)},p=function(t,e){window.__duiCb=t},l=function(t){var e=window.__duiCb;"function"==typeof e&&e(t)()};t.exports=function(t,e,n){if("function"==typeof n){var r=n();window.JBridge=u(window.JBridge,r)}i.registerScreenMeta(t),window.__duiShowScreen=f,window.__duiCb=null,window.__runDuiCallback=l,window.__setCallback=p,e()}},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));i.setIds(["id"]);return i}return i(e,t),a(e,[{key:"render",value:function(){var t=this.props;return u("editText",{id:this.props.id?this.props.id:this.idSet.id,params:t})}}]),e}(s);t.exports=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t=this.props,e=this.resolveChildren();return u("horizontalScrollView",{id:this.props.id?this.props.id:this.idSet.id,params:t},e)}}]),e}(s);t.exports=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"render",value:function(){var t=this.props,e=this.props.id?this.props.id:this.idSet.id;return u("imageView",{id:e,params:t})}}]),e}(s);t.exports=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=n(88),f=n(52),p=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.displayName="ListView",i.setIds(["id"]),i}return i(e,t),a(e,[{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t=this.props,e=this.resolveChildren();return"IOS"==window.__OS?u("tableView",{tableView:"true",id:this.props.id?this.props.id:this.idSet.id,params:t},e):"WEB"==window.__OS?u(c,{id:this.props.id?this.props.id:this.idSet.id,params:t},u(f,{width:"match_parent",height:"match_parent",orientation:"vertical"},this.children)).render():(t.listChildren=JSON.stringify(e),u("listView",{id:this.props.id?this.props.id:this.idSet.id,params:t}))}}]),e}(s);t.exports=p},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"render",value:function(){var t=this.props;return u("progressBar",{id:this.props.id?this.props.id:this.idSet.id,params:t})}}]),e}(s);t.exports=c},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t,e=this.props;return t=this.resolveChildren(),u("relativeLayout",{id:this.props.id?this.props.id:this.idSet.id,params:e},t)}}]),e}(s);t.exports=c},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var r=function t(e,r){n(this,t),this.props=e,this.children=r};t.exports=r},function(t,e,n){"use strict";function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(13),s=n(10),c=n(89),f=n(52),p=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return i.setIds(["id"]),i}return i(e,t),a(e,[{key:"resolveChildren",value:function(){return this.children.map(function(t){return t.render()})}},{key:"render",value:function(){var t=this.props,e=this.resolveChildren();return"IOS"==window.__OS?u("collectionView",{collectionView:"true",id:this.props.id?this.props.id:this.idSet.id,params:t},e):"WEB"==window.__OS?(t.background="#dddddd",t.gravity="center",u(f,{params:t
},u(c,{text:"ViewPager is not support on Web",color:"#e74c3c",gravity:"center",textSize:"24",width:"match_parent",height:"24"})).render()):(t.viewPagerChildren=JSON.stringify(e),u("viewPager",{id:this.props.id?this.props.id:this.idSet.id,params:t}))}}]),e}(s);t.exports=p},function(t,e,n){"use strict";t.exports={ImageView:n(183),LinearLayout:n(52),RelativeLayout:n(186),TextView:n(89),HorizontalScrollView:n(182),ScrollView:n(88),ProgressBar:n(185),EditText:n(181),ListView:n(184),ViewPager:n(188)}},function(t,e){function n(t){return!!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function r(t){return"function"==typeof t.readFloatLE&&"function"==typeof t.slice&&n(t.slice(0,0))}/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
t.exports=function(t){return null!=t&&(n(t)||r(t)||!!t._isBuffer)}},function(t,e,n){var r=n(23),o=r(!1);t.exports=o},function(t,e,n){var r=n(23),o=r(!0);t.exports=o},function(t,e){t.exports={"@@functional/placeholder":!0}},function(t,e,n){var r=n(14),o=n(2),i=n(6),a=o(function(t){return i(t.length,function(){var e=0,n=arguments[0],o=arguments[arguments.length-1],i=Array.prototype.slice.call(arguments,0);return i[0]=function(){var t=n.apply(this,r(arguments,[e,o]));return e+=1,t},t.apply(this,i)})});t.exports=a},function(t,e,n){var r=n(1),o=n(4),i=n(269),a=r(o(["all"],i,function(t,e){for(var n=0;n<e.length;){if(!t(e[n]))return!1;n+=1}return!0}));t.exports=a},function(t,e,n){var r=n(2),o=n(6),i=n(25),a=n(31),u=n(18),s=r(function(t){return o(u(i,0,a("length",t)),function(){for(var e=0,n=t.length;e<n;){if(!t[e].apply(this,arguments))return!1;e+=1}return!0})});t.exports=s},function(t,e,n){var r=n(2),o=n(6),i=n(25),a=n(31),u=n(18),s=r(function(t){return o(u(i,0,a("length",t)),function(){for(var e=0,n=t.length;e<n;){if(t[e].apply(this,arguments))return!0;e+=1}return!1})});t.exports=s},function(t,e,n){var r=n(252),o=n(1),i=n(4),a=n(270),u=o(i([],a,r));t.exports=u},function(t,e,n){var r=n(14),o=n(1),i=o(function(t,e){return r(e,[t])});t.exports=i},function(t,e,n){var r=n(2),o=n(94),i=n(6),a=n(8),u=n(25),s=n(31),c=n(18),f=n(145),p=r(function t(e){return e=a(function(e){return"function"==typeof e?e:t(e)},e),i(c(u,0,s("length",f(e))),function(){var t=arguments;return a(function(e){return o(e,t)},e)})});t.exports=p},function(t,e,n){var r=n(1),o=r(function(t,e){return e(t)});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){var r=t(e),o=t(n);return r<o?-1:r>o?1:0});t.exports=o},function(t,e,n){var r=n(2),o=n(46),i=r(function(t){return o(2,t)});t.exports=i},function(t,e,n){var r=n(1),o=n(40),i=n(92),a=n(44),u=r(function(t,e){return o(t)?function(){return t.apply(this,arguments)&&e.apply(this,arguments)}:a(i)(t,e)});t.exports=u},function(t,e,n){var r=n(57),o=r(function(t){return t.apply(this,Array.prototype.slice.call(arguments,1))});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){if(t>e)throw new Error("min must not be greater than max in clamp(min, max, value)");return n<t?t:n>e?e:n});t.exports=o},function(t,e,n){var r=n(108),o=n(2),i=o(function(t){return null!=t&&"function"==typeof t.clone?t.clone():r(t,[],[],!0)});t.exports=i},function(t,e,n){var r=n(2),o=r(function(t){return function(e,n){return t(e,n)?-1:t(n,e)?1:0}});t.exports=o},function(t,e,n){var r=n(44),o=n(128),i=r(o);t.exports=i},function(t,e,n){function r(){if(0===arguments.length)throw new Error("composeP requires at least one argument");return o.apply(this,i(arguments))}var o=n(134),i=n(49);t.exports=r},function(t,e,n){var r=n(16),o=n(2),i=n(8),a=n(25),u=n(18),s=o(function(t){var e=u(a,0,i(function(t){return t[0].length},t));return r(e,function(){for(var e=0;e<t.length;){if(t[e][0].apply(this,arguments))return t[e][1].apply(this,arguments);e+=1}})});t.exports=s},function(t,e,n){var r=n(2),o=n(98),i=r(function(t){return o(t.length,t)});t.exports=i},function(t,e,n){var r=n(24),o=n(1),i=o(r);t.exports=i},function(t,e,n){var r=n(47),o=r(function(t,e){return t+1},0);t.exports=o},function(t,e,n){var r=n(34),o=r(-1);t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){var r=t(e),o=t(n);return r>o?-1:r<o?1:0});t.exports=o},function(t,e,n){var r=n(1),o=n(63),i=n(35),a=n(103),u=n(137),s=n(72),c=r(function t(e,n){switch(e.length){case 0:return n;case 1:return o(e[0])?u(e[0],1,n):a(e[0],n);default:var r=e[0],c=Array.prototype.slice.call(e,1);return null==n[r]?n:o(e[0])?s(r,t(c,n[r]),n):i(r,t(c,n[r]),n)}});t.exports=c},function(t,e,n){var r=n(1),o=r(function(t,e){return t/e});t.exports=o},function(t,e,n){var r=n(1),o=n(4),i=n(254),a=n(273),u=r(o([],a,i));t.exports=u},function(t,e,n){var r=n(1),o=n(4),i=n(255),a=n(274),u=r(o([],a,i));t.exports=u},function(t,e,n){var r=n(2),o=n(4),i=n(117),a=n(105),u=n(11),s=r(o([],i(u),a(u)));t.exports=s},function(t,e,n){var r=n(1),o=n(4),i=n(275),a=n(15),u=r(o(["dropWhile"],i,function(t,e){for(var n=0,r=e.length;n<r&&t(e[n]);)n+=1;return a(n,1/0,e)}));t.exports=u},function(t,e,n){var r=n(1),o=n(40),i=n(44),a=n(130),u=r(function(t,e){return o(t)?function(){return t.apply(this,arguments)||e.apply(this,arguments)}:i(a)(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(11),i=n(140),a=r(function(t,e){return o(i(t.length,e),t)});t.exports=a},function(t,e,n){var r=n(3),o=n(11),i=r(function(t,e,n){return o(t(e),t(n))});t.exports=i},function(t,e,n){var r=n(3),o=n(11),i=r(function(t,e,n){return o(e[t],n[t])});t.exports=i},function(t,e,n){var r=n(1),o=r(function t(e,n){var r,o,i,a={};for(o in n)r=e[o],i=typeof r,a[o]="function"===i?r(n[o]):r&&"object"===i?t(r,n[o]):n[o];return a});t.exports=o},function(t,e,n){var r=n(1),o=n(4),i=n(277),a=r(o(["find"],i,function(t,e){for(var n=0,r=e.length;n<r;){if(t(e[n]))return e[n];n+=1}}));t.exports=a},function(t,e,n){var r=n(1),o=n(4),i=n(278),a=r(o([],i,function(t,e){for(var n=0,r=e.length;n<r;){if(t(e[n]))return n;n+=1}return-1}));t.exports=a},function(t,e,n){var r=n(1),o=n(4),i=n(279),a=r(o([],i,function(t,e){for(var n=e.length-1;n>=0;){if(t(e[n]))return e[n];n-=1}}));t.exports=a},function(t,e,n){var r=n(1),o=n(4),i=n(280),a=r(o([],i,function(t,e){for(var n=e.length-1;n>=0;){if(t(e[n]))return n;n-=1}return-1}));t.exports=a},function(t,e,n){var r=n(2),o=n(115),i=r(o(!0));t.exports=i},function(t,e,n){var r=n(27),o=n(1),i=o(r("forEach",function(t,e){for(var n=e.length,r=0;r<n;)t(e[r]),r+=1;return e}));t.exports=i},function(t,e,n){var r=n(1),o=n(17),i=r(function(t,e){for(var n=o(e),r=0;r<n.length;){var i=n[r];t(e[i],i,e),r+=1}return e});t.exports=i},function(t,e,n){var r=n(2),o=r(function(t){for(var e={},n=0;n<t.length;)e[t[n][0]]=t[n][1],n+=1;return e});t.exports=o},function(t,e,n){var r=n(27),o=n(1),i=n(47),a=o(r("groupBy",i(function(t,e){return null==t&&(t=[]),t.push(e),t},null)));t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=[],r=0,o=e.length;r<o;){for(var i=r+1;i<o&&t(e[i-1],e[i]);)i+=1;n.push(e.slice(r,i)),r=i}return n});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return t>e});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return t>=e});t.exports=o},function(t,e,n){var r=n(1),o=n(7),i=r(o);t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){return t in e});t.exports=o},function(t,e,n){var r=n(30),o=r(0);t.exports=o},function(t,e,n){var r=n(3),o=n(6),i=r(function(t,e,n){return o(Math.max(t.length,e.length,n.length),function(){return t.apply(this,arguments)?e.apply(this,arguments):n.apply(this,arguments)})});t.exports=i},function(t,e,n){var r=n(34),o=r(1);t.exports=o},function(t,e,n){var r=n(47),o=r(function(t,e){return e},null);t.exports=o},function(t,e,n){var r=n(1),o=n(112),i=n(19),a=r(function(t,e){return"function"!=typeof e.indexOf||i(e)?o(e,t,0):e.indexOf(t)});t.exports=a},function(t,e,n){var r=n(15),o=r(0,-1);t.exports=o},function(t,e,n){var r=n(37),o=n(3),i=n(61),a=o(function(t,e,n){return i(function(e){return r(t,e,n)},e)});t.exports=a},function(t,e,n){var r=n(3),o=r(function(t,e,n){t=t<n.length&&t>=0?t:n.length;var r=Array.prototype.slice.call(n,0);return r.splice(t,0,e),r});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t=t<n.length&&t>=0?t:n.length,[].concat(Array.prototype.slice.call(n,0,t),e,Array.prototype.slice.call(n,t))});t.exports=o},function(t,e,n){function r(t,e,n){var r,i,a=typeof t;switch(a){case"string":case"number":return 0===t&&1/t===-(1/0)?!!n._items["-0"]||(e&&(n._items["-0"]=!0),!1):null!==n._nativeSet?e?(r=n._nativeSet.size,n._nativeSet.add(t),i=n._nativeSet.size,i===r):n._nativeSet.has(t):a in n._items?t in n._items[a]||(e&&(n._items[a][t]=!0),!1):(e&&(n._items[a]={},n._items[a][t]=!0),!1);case"boolean":if(a in n._items){var u=t?1:0;return!!n._items[a][u]||(e&&(n._items[a][u]=!0),!1)}return e&&(n._items[a]=t?[!1,!0]:[!0,!1]),!1;case"function":return null!==n._nativeSet?e?(r=n._nativeSet.size,n._nativeSet.add(t),i=n._nativeSet.size,i===r):n._nativeSet.has(t):a in n._items?!!o(t,n._items[a])||(e&&n._items[a].push(t),!1):(e&&(n._items[a]=[t]),!1);case"undefined":return!!n._items[a]||(e&&(n._items[a]=!0),!1);case"object":if(null===t)return!!n._items.null||(e&&(n._items.null=!0),!1);default:return a=Object.prototype.toString.call(t),a in n._items?!!o(t,n._items[a])||(e&&n._items[a].push(t),!1):(e&&(n._items[a]=[t]),!1)}}var o=n(24),i=function(){function t(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return t.prototype.add=function(t){return!r(t,!0,this)},t.prototype.has=function(t){return r(t,!1,this)},t}();t.exports=i},function(t,e){function n(t,e){for(var n=0,r=e.length-(t-1),o=new Array(r>=0?r:0);n<r;)o[n]=Array.prototype.slice.call(e,n,n+t),n+=1;return o}t.exports=n},function(t,e){function n(t){for(var e,n=[];!(e=t.next()).done;)n.push(e.value);return n}t.exports=n},function(t,e,n){function r(t,e){return o(t<e.length?e.length-t:0,e)}var o=n(69);t.exports=r},function(t,e,n){function r(t,e){for(var n=e.length-1;n>=0&&t(e[n]);)n-=1;return o(0,n+1,e)}var o=n(15);t.exports=r},function(t,e,n){function r(t,e,n,r){function u(t,e){return o(t,e,n.slice(),r.slice())}var s=i(t),c=i(e);return!a(function(t,e){return!a(u,e,t)},c,s)}function o(t,e,n,i){if(c(t,e))return!0;var a=p(t);if(a!==p(e))return!1;if(null==t||null==e)return!1;if("function"==typeof t["fantasy-land/equals"]||"function"==typeof e["fantasy-land/equals"])return"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](e)&&"function"==typeof e["fantasy-land/equals"]&&e["fantasy-land/equals"](t);if("function"==typeof t.equals||"function"==typeof e.equals)return"function"==typeof t.equals&&t.equals(e)&&"function"==typeof e.equals&&e.equals(t);switch(a){case"Arguments":case"Array":case"Object":if("function"==typeof t.constructor&&"Promise"===u(t.constructor))return t===e;break;case"Boolean":case"Number":case"String":if(typeof t!=typeof e||!c(t.valueOf(),e.valueOf()))return!1;break;case"Date":if(!c(t.valueOf(),e.valueOf()))return!1;break;case"Error":return t.name===e.name&&t.message===e.message;case"RegExp":if(t.source!==e.source||t.global!==e.global||t.ignoreCase!==e.ignoreCase||t.multiline!==e.multiline||t.sticky!==e.sticky||t.unicode!==e.unicode)return!1}for(var l=n.length-1;l>=0;){if(n[l]===t)return i[l]===e;l-=1}switch(a){case"Map":return t.size===e.size&&r(t.entries(),e.entries(),n.concat([t]),i.concat([e]));case"Set":return t.size===e.size&&r(t.values(),e.values(),n.concat([t]),i.concat([e]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var d=f(t);if(d.length!==f(e).length)return!1;var h=n.concat([t]),y=i.concat([e]);for(l=d.length-1;l>=0;){var v=d[l];if(!s(v,e)||!o(e[v],t[v],h,y))return!1;l-=1}return!0}var i=n(253),a=n(37),u=n(259),s=n(7),c=n(107),f=n(17),p=n(70);t.exports=o},function(t,e,n){var r=n(258),o=n(39),i=n(12),a=n(5),u=function(t){return{"@@transducer/init":a.init,"@@transducer/result":function(e){return t["@@transducer/result"](e)},"@@transducer/step":function(e,n){var o=t["@@transducer/step"](e,n);return o["@@transducer/reduced"]?r(o):o}}},s=function(t){var e=u(t);return{"@@transducer/init":a.init,"@@transducer/result":function(t){return e["@@transducer/result"](t)},"@@transducer/step":function(t,n){return o(n)?i(e,t,n):i(e,t,[n])}}};t.exports=s},function(t,e){function n(t){return{"@@transducer/value":t,"@@transducer/reduced":!0}}t.exports=n},function(t,e){function n(t){var e=String(t).match(/^function (\w*)/);return null==e?"":e[1]}t.exports=n},function(t,e){function n(t){return"[object RegExp]"===Object.prototype.toString.call(t)}t.exports=n},function(t,e,n){function r(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),n=1,r=arguments.length;n<r;){var i=arguments[n];if(null!=i)for(var a in i)o(a,i)&&(e[a]=i[a]);n+=1}return e}var o=n(7);t.exports=r},function(t,e){function n(t){return[t]}t.exports=n},function(t,e){function n(t,e){return function(){return e.call(this,t.apply(this,arguments))}}t.exports=n},function(t,e){function n(t,e){return function(){var n=this;return t.apply(n,arguments).then(function(t){return e.call(n,t)})}}t.exports=n},function(t,e){function n(t){var e=t.replace(/\\/g,"\\\\").replace(/[\b]/g,"\\b").replace(/\f/g,"\\f").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t").replace(/\v/g,"\\v").replace(/\0/g,"\\0");return'"'+e.replace(/"/g,'\\"')+'"'}t.exports=n},function(t,e,n){function r(t){if(u(t))return t;if(a(t))return c;if("string"==typeof t)return f;if("object"==typeof t)return p;throw new Error("Cannot create transformer for "+t)}var o=n(60),i=n(62),a=n(39),u=n(65),s=n(129),c={"@@transducer/init":Array,"@@transducer/step":function(t,e){return t.push(e),t},"@@transducer/result":i},f={"@@transducer/init":String,"@@transducer/step":function(t,e){return t+e},"@@transducer/result":i},p={"@@transducer/init":Object,"@@transducer/step":function(t,e){return o(t,a(e)?s(e[0],e[1]):e)},"@@transducer/result":i};t.exports=r},function(t,e){var n=function(t){return(t<10?"0":"")+t},r="function"==typeof Date.prototype.toISOString?function(t){return t.toISOString()}:function(t){return t.getUTCFullYear()+"-"+n(t.getUTCMonth()+1)+"-"+n(t.getUTCDate())+"T"+n(t.getUTCHours())+":"+n(t.getUTCMinutes())+":"+n(t.getUTCSeconds())+"."+(t.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z"};t.exports=r},function(t,e,n){function r(t,e){var n=function(n){var i=e.concat([t]);return o(n,i)?"<Circular>":r(n,i)},f=function(t,e){return i(function(e){return a(e)+": "+n(t[e])},e.slice().sort())};switch(Object.prototype.toString.call(t)){case"[object Arguments]":return"(function() { return arguments; }("+i(n,t).join(", ")+"))";case"[object Array]":return"["+i(n,t).concat(f(t,c(function(t){return/^\d+$/.test(t)},s(t)))).join(", ")+"]";case"[object Boolean]":return"object"==typeof t?"new Boolean("+n(t.valueOf())+")":t.toString();case"[object Date]":return"new Date("+(isNaN(t.valueOf())?n(NaN):a(u(t)))+")";case"[object Null]":return"null";case"[object Number]":return"object"==typeof t?"new Number("+n(t.valueOf())+")":1/t===-(1/0)?"-0":t.toString(10);case"[object String]":return"object"==typeof t?"new String("+n(t.valueOf())+")":a(t);case"[object Undefined]":return"undefined";default:if("function"==typeof t.toString){var p=t.toString();if("[object Object]"!==p)return p}return"{"+f(t,s(t)).join(", ")+"}"}}var o=n(24),i=n(42),a=n(265),u=n(267),s=n(17),c=n(48);t.exports=r},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.f=t,this.all=!0}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.all&&(t=this.xf["@@transducer/step"](t,!0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)||(this.all=!1,t=o(this.xf["@@transducer/step"](t,!1))),t},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(14),o=n(1),i=n(5),a=function(){function t(t,e){this.xf=e,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.store(e),this.full?this.xf["@@transducer/step"](t,this.getCopy()):t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t.prototype.getCopy=function(){return r(Array.prototype.slice.call(this.acc,this.pos),Array.prototype.slice.call(this.acc,0,this.pos))},t}(),u=o(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(257),i=n(8),a=r(function(t,e){return i(t,o(e))});t.exports=a},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.n=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){return this.n>0?(this.n-=1,t):this.xf["@@transducer/step"](t,e)},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.full&&(t=this.xf["@@transducer/step"](t,this.acc[this.pos])),this.store(e),t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(12),i=n(5),a=function(){function t(t,e){this.f=t,this.retained=[],this.xf=e}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.retained=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)?this.retain(t,e):this.flush(t,e)},t.prototype.flush=function(t,e){return t=o(this.xf["@@transducer/step"],t,this.retained),this.retained=[],this.xf["@@transducer/step"](t,e)},t.prototype.retain=function(t,e){return this.retained.push(e),t},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){if(this.f){if(this.f(e))return t;this.f=null}return this.xf["@@transducer/step"](t,e)},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){return this.f(e)?this.xf["@@transducer/step"](t,e):t},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.f=t,this.found=!1}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,void 0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)&&(this.found=!0,t=o(this.xf["@@transducer/step"](t,e))),t},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.f=t,this.idx=-1,this.found=!1}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,-1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){return this.idx+=1,this.f(e)&&(this.found=!0,t=o(this.xf["@@transducer/step"](t,this.idx))),t},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.last))},t.prototype["@@transducer/step"]=function(t,e){return this.f(e)&&(this.last=e),t},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t,this.idx=-1,this.lastIdx=-1}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.lastIdx))},t.prototype["@@transducer/step"]=function(t,e){return this.idx+=1,this.f(e)&&(this.lastIdx=this.idx),t},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){return this.xf["@@transducer/step"](t,this.f(e))},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(38),o=n(7),i=n(5),a=function(){function t(t,e,n,r){this.valueFn=t,this.valueAcc=e,this.keyFn=n,this.xf=r,this.inputs={}}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=function(t){var e;for(e in this.inputs)if(o(e,this.inputs)&&(t=this.xf["@@transducer/step"](t,this.inputs[e]),t["@@transducer/reduced"])){t=t["@@transducer/value"];break}return this.inputs=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,e){var n=this.keyFn(e);return this.inputs[n]=this.inputs[n]||[n,this.valueAcc],this.inputs[n][1]=this.valueFn(this.inputs[n][1],e),t},t}(),u=r(4,[],function(t,e,n,r){return new a(t,e,n,r)});t.exports=u},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.n=t,this.i=0}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=i.result,t.prototype["@@transducer/step"]=function(t,e){this.i+=1;var n=0===this.n?t:this.xf["@@transducer/step"](t,e);return this.n>=0&&this.i>=this.n?o(n):n},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(20),i=n(5),a=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=i.init,t.prototype["@@transducer/result"]=i.result,t.prototype["@@transducer/step"]=function(t,e){return this.f(e)?this.xf["@@transducer/step"](t,e):o(t)},t}(),u=r(function(t,e){return new a(t,e)});t.exports=u},function(t,e,n){var r=n(1),o=n(5),i=function(){function t(t,e){this.xf=e,this.f=t}return t.prototype["@@transducer/init"]=o.init,t.prototype["@@transducer/result"]=o.result,t.prototype["@@transducer/step"]=function(t,e){return this.f(e),this.xf["@@transducer/step"](t,e)},t}(),a=r(function(t,e){return new i(t,e)});t.exports=a},function(t,e,n){var r=n(24),o=n(1),i=n(61),a=n(36),u=n(71),s=o(function(t,e){var n,o;return t.length>e.length?(n=t,o=e):(n=e,o=t),u(i(a(r)(n),o))});t.exports=s},function(t,e,n){var r=n(27),o=n(1),i=o(r("intersperse",function(t,e){for(var n=[],r=0,o=e.length;r<o;)r===o-1?n.push(e[r]):n.push(e[r],t),r+=1;return n}));t.exports=i},function(t,e,n){var r=n(108),o=n(3),i=n(65),a=n(12),u=n(266),s=o(function(t,e,n){return i(t)?a(e(t),t["@@transducer/init"](),n):a(e(u(t)),r(t,[],[],!1),n)});t.exports=s},function(t,e,n){var r=n(2),o=n(7),i=n(17),a=r(function(t){for(var e=i(t),n=e.length,r=0,a={};r<n;){var u=e[r],s=t[u],c=o(s,a)?a[s]:a[s]=[];c[c.length]=u,r+=1}return a});t.exports=a},function(t,e,n){var r=n(2),o=n(17),i=r(function(t){for(var e=o(t),n=e.length,r=0,i={};r<n;){var a=e[r];i[t[a]]=a,r+=1}return i});t.exports=i},function(t,e,n){var r=n(2),o=n(106),i=n(11),a=r(function(t){return null!=t&&i(t,o(t))});t.exports=a},function(t,e,n){var r=n(29),o=r(1,"join");t.exports=o},function(t,e,n){var r=n(2),o=r(function(t){var e,n=[];for(e in t)n[n.length]=e;return n});t.exports=o},function(t,e,n){var r=n(1),o=n(19),i=n(11),a=r(function(t,e){if("function"!=typeof e.lastIndexOf||o(e)){for(var n=e.length-1;n>=0;){if(i(e[n],t))return n;n-=1}return-1}return e.lastIndexOf(t)});t.exports=a},function(t,e,n){var r=n(2),o=n(43),i=n(30),a=n(72),u=r(function(t){return o(i(t),a(t))});t.exports=u},function(t,e,n){var r=n(2),o=n(95),i=n(43),a=n(26),u=r(function(t){return i(a(t),o(t))});t.exports=u},function(t,e,n){var r=n(2),o=n(35),i=n(43),a=n(67),u=r(function(t){return i(a(t),o(t))});t.exports=u},function(t,e,n){var r=n(1),o=r(function(t,e){return t<e});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return t<=e});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=0,o=n.length,i=[],a=[e];r<o;)a=t(a[0],n[r]),i[r]=a[1],r+=1;return[a[0],i]});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=n.length-1,o=[],i=[e];r>=0;)i=t(n[r],i[0]),o[r]=i[1],r-=1;return[o,i[0]]});t.exports=o},function(t,e,n){var r=n(1),o=n(12),i=n(17),a=r(function(t,e){return o(function(n,r){return n[r]=t(e[r],r,e),n},{},i(e))});t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){return e.match(t)||[]});t.exports=o},function(t,e,n){var r=n(1),o=n(63),i=r(function(t,e){return o(t)?!o(e)||e<1?NaN:(t%e+e)%e:NaN});t.exports=i},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(n)>t(e)?n:e});t.exports=o},function(t,e,n){var r=n(2),o=n(125),i=r(function(t){var e=t.length;if(0===e)return NaN;var n=2-e%2,r=(e-n)/2;return o(Array.prototype.slice.call(t,0).sort(function(t,e){return t<e?-1:t>e?1:0}).slice(r,r+n))});t.exports=i},function(t,e,n){var r=n(126),o=n(32),i=r(function(){return o(arguments)});t.exports=i},function(t,e,n){var r=n(60),o=n(1),i=o(function(t,e){return r({},t,e)});t.exports=i},function(t,e,n){var r=n(60),o=n(2),i=o(function(t){return r.apply(null,[{}].concat(t))});t.exports=i},function(t,e,n){var r=n(1),o=n(45),i=r(function(t,e){return o(function(t,e,n){return e},t,e)});t.exports=i},function(t,e,n){var r=n(1),o=n(45),i=r(function(t,e){return o(function(t,e,n){return n},t,e)});t.exports=i},function(t,e,n){var r=n(3),o=n(45),i=r(function(t,e,n){return o(function(e,n,r){return t(n,r)},e,n)});t.exports=i},function(t,e,n){var r=n(3),o=n(66),i=r(function(t,e,n){return o(function(e,n,r){return t(n,r)},e,n)});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){return e<t?e:t});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(n)<t(e)?n:e});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return t%e});t.exports=o},function(t,e,n){var r=n(2),o=r(function(t){return-t});t.exports=o},function(t,e,n){var r=n(110),o=n(1),i=n(4),a=n(116),u=n(93),s=o(r(i(["any"],a,u)));t.exports=s},function(t,e,n){var r=n(2),o=n(6),i=n(30),a=r(function(t){var e=t<0?1:t+1;return o(e,function(){return i(t,arguments)})});t.exports=a},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(e(n))});t.exports=o},function(t,e,n){var r=n(2),o=n(262),i=r(o);t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n={},r={},o=0,i=t.length;o<i;)r[t[o]]=1,o+=1;for(var a in e)r.hasOwnProperty(a)||(n[a]=e[a]);return n});t.exports=o},function(t,e,n){var r=n(16),o=n(2),i=o(function(t){var e,n=!1;return r(t.length,function(){return n?e:(n=!0,e=t.apply(this,arguments))})});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){return[t,e]});t.exports=o},function(t,e,n){var r=n(14),o=n(111),i=o(r);t.exports=i},function(t,e,n){var r=n(14),o=n(111),i=n(36),a=o(i(r));t.exports=a},function(t,e,n){var r=n(58),o=n(121),i=n(48),a=o([r,i]);t.exports=a},function(t,e,n){var r=n(3),o=n(11),i=n(26),a=r(function(t,e,n){return o(i(t,n),e)});t.exports=a},function(t,e,n){var r=n(3),o=n(100),i=n(26),a=r(function(t,e,n){return o(t,i(e,n))});t.exports=a},function(t,e,n){var r=n(3),o=n(26),i=r(function(t,e,n){return e.length>0&&t(o(e,n))});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n={},r=0;r<t.length;)t[r]in e&&(n[t[r]]=e[t[r]]),r+=1;return n});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){var n={};for(var r in e)t(e[r],r,e)&&(n[r]=e[r]);return n});t.exports=o},function(t,e,n){function r(){if(0===arguments.length)throw new Error("pipeK requires at least one argument");return o.apply(this,i(arguments))}var o=n(97),i=n(49);t.exports=r},function(t,e,n){var r=n(127),o=n(18),i=o(r,1);t.exports=i},function(t,e,n){var r=n(42),o=n(59),i=n(132),a=n(144),u=a(r,[i,o]);t.exports=u},function(t,e,n){var r=n(3),o=n(11),i=r(function(t,e,n){return o(e,n[t])});t.exports=i},function(t,e,n){var r=n(3),o=n(119),i=r(function(t,e,n){return o(t,n[e])});t.exports=i},function(t,e,n){var r=n(3),o=n(7),i=r(function(t,e,n){return null!=n&&o(e,n)?n[e]:t});t.exports=i},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(n[e])});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=t.length,r=[],o=0;o<n;)r[o]=e[t[o]],o+=1;return r});t.exports=o},function(t,e,n){var r=n(1),o=n(114),i=r(function(t,e){if(!o(t)||!o(e))throw new TypeError("Both arguments to range must be numbers");for(var n=[],r=t;r<e;)n.push(r),r+=1;return n});t.exports=i},function(t,e,n){var r=n(38),o=n(12),i=n(20),a=r(4,[],function(t,e,n,r){return o(function(n,r){return t(n,r)?e(n,r):i(n)},n,r)});t.exports=a},function(t,e,n){var r=n(2),o=n(20),i=r(o);t.exports=i},function(t,e,n){var r=n(1),o=n(23),i=n(141),a=r(function(t,e){return i(o(t),e)});t.exports=a},function(t,e,n){var r=n(3),o=r(function(t,e,n){return n.replace(t,e)});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=0,o=n.length,i=[e];r<o;)e=t(e,n[r]),i[r+1]=e,r+=1;return i});t.exports=o},function(t,e,n){var r=n(3),o=n(23),i=n(131),a=r(function(t,e,n){return i(t,o(e),n)});t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){return Array.prototype.slice.call(e,0).sort(t)});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return Array.prototype.slice.call(e,0).sort(function(e,n){var r=t(e),o=t(n);return r<o?-1:r>o?1:0})});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){return Array.prototype.slice.call(e,0).sort(function(e,n){for(var r=0,o=0;0===r&&o<t.length;)r=t[o](e,n),o+=1;return r})});t.exports=o},function(t,e,n){var r=n(29),o=r(1,"split");t.exports=o},function(t,e,n){var r=n(1),o=n(123),i=n(15),a=r(function(t,e){return[i(0,t,e),i(t,o(e),e)]});t.exports=a},function(t,e,n){var r=n(1),o=n(15),i=r(function(t,e){if(t<=0)throw new Error("First argument to splitEvery must be a positive integer");for(var n=[],r=0;r<e.length;)n.push(o(r,r+=t,e));return n});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=0,r=e.length,o=[];n<r&&!t(e[n]);)o.push(e[n]),n+=1;return[o,Array.prototype.slice.call(e,n)]});t.exports=o},function(t,e,n){var r=n(1),o=n(11),i=n(69),a=r(function(t,e){return o(i(t.length,e),t)});t.exports=a},function(t,e,n){var r=n(1),o=r(function(t,e){return Number(t)-Number(e)});t.exports=o},function(t,e,n){var r=n(1),o=n(56),i=n(101),a=r(function(t,e){return o(i(t,e),i(e,t))});t.exports=a},function(t,e,n){var r=n(3),o=n(56),i=n(102),a=r(function(t,e,n){return o(i(t,e,n),i(t,n,e))});t.exports=a},function(t,e,n){var r=n(1),o=n(15),i=r(function(t,e){for(var n=e.length-1;n>=0&&t(e[n]);)n-=1;return o(n+1,1/0,e)});t.exports=i},function(t,e,n){var r=n(1),o=n(4),i=n(284),a=n(15),u=r(o(["takeWhile"],i,function(t,e){for(var n=0,r=e.length;n<r&&t(e[n]);)n+=1;return a(0,n,e)}));t.exports=u},function(t,e,n){var r=n(1),o=n(4),i=n(285),a=r(o([],i,function(t,e){return t(e),e}));t.exports=a},function(t,e,n){var r=n(109),o=n(1),i=n(260),a=n(32),u=o(function(t,e){if(!i(t))throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received "+a(t));return r(t).test(e)});t.exports=u},function(t,e,n){var r=n(29),o=r(0,"toLowerCase");t.exports=o},function(t,e,n){var r=n(2),o=n(7),i=r(function(t){var e=[];for(var n in t)o(n,t)&&(e[e.length]=[n,t[n]]);return e});t.exports=i},function(t,e,n){var r=n(2),o=r(function(t){var e=[];for(var n in t)e[e.length]=[n,t[n]];return e});t.exports=o},function(t,e,n){var r=n(29),o=r(0,"toUpperCase");t.exports=o},function(t,e,n){var r=n(12),o=n(118),i=n(6),a=i(4,function(t,e,n,i){return r(t("function"==typeof e?o(e):e),n,i)});t.exports=a},function(t,e,n){var r=n(2),o=r(function(t){for(var e=0,n=[];e<t.length;){for(var r=t[e],o=0;o<r.length;)"undefined"==typeof n[o]&&(n[o]=[]),n[o].push(r[o]),o+=1;e+=1}return n});t.exports=o},function(t,e,n){var r=n(3),o=n(8),i=n(138),a=r(function(t,e,n){return"function"==typeof n["fantasy-land/traverse"]?n["fantasy-land/traverse"](e,t):i(t,o(e,n))});t.exports=a},function(t,e,n){var r=n(2),o="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff",i="​",a="function"==typeof String.prototype.trim,u=a&&!o.trim()&&i.trim()?function(t){return t.trim()}:function(t){var e=new RegExp("^["+o+"]["+o+"]*"),n=new RegExp("["+o+"]["+o+"]*$");return t.replace(e,"").replace(n,"");
},s=r(u);t.exports=s},function(t,e,n){var r=n(16),o=n(14),i=n(1),a=i(function(t,e){return r(t.length,function(){try{return t.apply(this,arguments)}catch(t){return e.apply(this,o([t],arguments))}})});t.exports=a},function(t,e,n){var r=n(2),o=r(function(t){return function(){return t(Array.prototype.slice.call(arguments,0))}});t.exports=o},function(t,e,n){var r=n(2),o=n(46),i=r(function(t){return o(1,t)});t.exports=i},function(t,e,n){var r=n(1),o=n(6),i=r(function(t,e){return o(t,function(){for(var n,r=1,o=e,i=0;r<=t&&"function"==typeof o;)n=r===t?arguments.length:i+o.length,o=o.apply(this,Array.prototype.slice.call(arguments,i,n)),r+=1,i=n;return o})});t.exports=i},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=t(e),r=[];n&&n.length;)r[r.length]=n[0],n=t(n[1]);return r});t.exports=o},function(t,e,n){var r=n(14),o=n(1),i=n(55),a=n(71),u=o(i(a,r));t.exports=u},function(t,e,n){var r=n(14),o=n(3),i=n(143),a=o(function(t,e,n){return i(t,r(e,n))});t.exports=a},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(n)?n:e(n)});t.exports=o},function(t,e,n){var r=n(62),o=n(54),i=o(r);t.exports=i},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=n;!t(r);)r=e(r);return r});t.exports=o},function(t,e,n){var r=n(2),o=r(function(t){var e,n=[];for(e in t)n[n.length]=t[e];return n});t.exports=o},function(t,e,n){var r=n(1),o=function(t){return{value:t,"fantasy-land/map":function(){return this}}},i=r(function(t,e){return t(o)(e).value});t.exports=i},function(t,e,n){var r=n(3),o=r(function(t,e,n){return t(n)?e(n):n});t.exports=o},function(t,e,n){var r=n(1),o=n(11),i=n(8),a=n(146),u=r(function(t,e){return a(i(o,t),e)});t.exports=u},function(t,e,n){var r=n(24),o=n(1),i=n(36),a=n(48),u=o(function(t,e){return a(i(r)(t),e)});t.exports=u},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n,r=0,o=t.length,i=e.length,a=[];r<o;){for(n=0;n<i;)a[a.length]=[t[r],e[n]],n+=1;r+=1}return a});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=[],r=0,o=Math.min(t.length,e.length);r<o;)n[r]=[t[r],e[r]],r+=1;return n});t.exports=o},function(t,e,n){var r=n(1),o=r(function(t,e){for(var n=0,r=Math.min(t.length,e.length),o={};n<r;)o[t[n]]=e[n],n+=1;return o});t.exports=o},function(t,e,n){var r=n(3),o=r(function(t,e,n){for(var r=[],o=0,i=Math.min(e.length,n.length);o<i;)r[o]=t(e[o],n[o]),o+=1;return r});t.exports=o}]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var en_US = __webpack_require__(14);

var languages = {
  "en_US": en_US
};

module.exports = function () {
  var lang = languages[window.LANGUAGE] || {};
  var strings = {};
  for (var i in en_US) {
    if (lang[i]) strings[i] = lang[i];else strings[i] = en_US[i];
  }
  return strings;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var en_US = __webpack_require__(15);

var languages = {
  "en_US": en_US
};

module.exports = function () {
  var lang = languages[window.LANGUAGE] || {};
  var strings = {};
  for (var i in en_US) {
    if (lang[i]) strings[i] = lang[i];else strings[i] = en_US[i];
  }
  return strings;
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = {"AVENIR_ROMAN":"Avenir-Roman","AVENIR_BLACK":"Avenir-Black","AVENIR_BOOK":"Avenir-Book","AVENIR_HEAVY":"Avenir-Heavy","AVENIR_MEDIUM":"Avenir-Medium","ROBOTOMONO_REGULAR":"RobotoMono-Regular","ROBOTOMONO_BOLD":"RobotoMono-Bold"}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = {"A__FFFFFFFF":"#ffffffff","A__FF757575":"#ff757575","A__FFFF0000":"#ffff0000","A__FFD7D7D7":"#ffd7d7d7","A__FFEE0000":"#ffee0000","A__19BBBBBB":"#19bbbbbb","A__00FFFFFF":"#00ffffff","A__FFF7F7F7":"#fff7f7f7"}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {"A_18":"18","A_60":"60","A_40":"40","A_16":"16","A_22":"22","A_30":"30","A_24":"24","A_36":"36","A_20":"20","A_26":"26","A_32":"32","A_28":"28"}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = {"A__FF3A3A3A":"#ff3a3a3a","A__FFFFFFFF":"#ffffffff","A__FFFF0000":"#ffff0000","A__FF4A494A":"#ff4a494a","A__FF000000":"#ff000000","A__FFEE0000":"#ffee0000","A__FFED0000":"#ffed0000","A__FFCCCCCC":"#ffcccccc"}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
* Copyright (c) 2012-2017 "JUSPAY Technologies"
* JUSPAY Technologies Pvt. Ltd. [https://www.juspay.in]
*
* This file is part of JUSPAY Platform.
*
* JUSPAY Platform is free software: you can redistribute it and/or modify
* it for only educational purposes under the terms of the GNU Affero General
* Public License (GNU AGPL) as published by the Free Software Foundation,
* either version 3 of the License, or (at your option) any later version.
* For Enterprise/Commerical licenses, contact <info@juspay.in>.
*
* This program is distributed in the hope that it will be useful,
* but WITHOUT ANY WARRANTY; without even the implied warranty of
* MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  The end user will
* be liable for all damages without limitation, which is caused by the
* ABUSE of the LICENSED SOFTWARE and shall INDEMNIFY JUSPAY for such
* damages, claims, cost, including reasonable attorney fee claimed on Juspay.
* The end user has NO right to claim any indemnification based on its use
* of Licensed Software. See the GNU Affero General Public License for more details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program. If not, see <https://www.gnu.org/licenses/agpl.html>.
*/

var meta = __webpack_require__(10);
var init = __webpack_require__(0).init;

if (window.__WIDTH >= 600) {
	document.body.style.zoom = window.__WIDTH / 1440 * 100 + "%";
}
if (window.__WIDTH < 600) {
	document.body.style.zoom = window.__WIDTH / 360 * 100 + "%";
}

function main() {
	window.__duiShowScreen(null, { screen: "INIT_UI" });
}

window.pages = __webpack_require__(34);
init(meta, main);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RootScreen = __webpack_require__(11);
// Screens of page: Main
var Home = __webpack_require__(12);
var SFP = __webpack_require__(16);
var Project = __webpack_require__(18);
var Presto = __webpack_require__(20);
var Home2 = __webpack_require__(22);

// Screens of page: Mobile
var MobileHome = __webpack_require__(24);
var MobileSFP = __webpack_require__(26);
var MobileProject = __webpack_require__(28);
var MobilePresto = __webpack_require__(30);
var MobileHome2 = __webpack_require__(32);

var screens = {
	Home: Home,
	SFP: SFP,
	Project: Project,
	Presto: Presto,
	Home2: Home2,
	MobileHome: MobileHome,
	MobileSFP: MobileSFP,
	MobileProject: MobileProject,
	MobilePresto: MobilePresto,
	MobileHome2: MobileHome2,
	RootScreen: RootScreen
};

var screen;

if (window.__WIDTH <= 600) screen = "MobileHome2";else screen = "Home2";

if (window.location.hash == "#Presto") {
	if (window.__WIDTH <= 600) screen = "MobilePresto";else screen = "Presto";
}

var INIT_UI = screen;

module.exports = {
	screens: screens,
	INIT_UI: INIT_UI
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/RootScreen.js";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
* Copyright (c) 2012-2017 "JUSPAY Technologies"
* JUSPAY Technologies Pvt. Ltd. [https://www.juspay.in]
*
* This file is part of JUSPAY Platform.
*
* JUSPAY Platform is free software: you can redistribute it and/or modify
* it for only educational purposes under the terms of the GNU Affero General
* Public License (GNU AGPL) as published by the Free Software Foundation,
* either version 3 of the License, or (at your option) any later version.
* For Enterprise/Commerical licenses, contact <info@juspay.in>.
*
* This program is distributed in the hope that it will be useful,
* but WITHOUT ANY WARRANTY; without even the implied warranty of
* MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  The end user will
* be liable for all damages without limitation, which is caused by the
* ABUSE of the LICENSED SOFTWARE and shall INDEMNIFY JUSPAY for such
* damages, claims, cost, including reasonable attorney fee claimed on Juspay.
* The end user has NO right to claim any indemnification based on its use
* of Licensed Software. See the GNU Affero General Public License for more details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program. If not, see <https://www.gnu.org/licenses/agpl.html>.
*/

var dom = __webpack_require__(0).doms;
var View = __webpack_require__(0).baseView;
var RelativeLayout = __webpack_require__(0).views.RelativeLayout;

var RootScreen = function (_View) {
  _inherits(RootScreen, _View);

  function RootScreen(props, children) {
    _classCallCheck(this, RootScreen);

    var _this = _possibleConstructorReturn(this, (RootScreen.__proto__ || Object.getPrototypeOf(RootScreen)).call(this, props, children));

    _this.setIds(['root']);
    return _this;
  }

  _createClass(RootScreen, [{
    key: "render",
    value: function render() {

      this.layout = dom(RelativeLayout, {
        root: "true",
        width: "match_parent",
        height: "match_parent",
        id: this.idSet.root, __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      });

      return this.layout.render();
    }
  }]);

  return RootScreen;
}(View);

module.exports = RootScreen;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Main/Home.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(13);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var Home = function (_Controller) {
	_inherits(Home, _Controller);

	function Home(props, children, state) {
		_classCallCheck(this, Home);

		var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Content100000000ø"),
						height: "100",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,25,80,24",
						cornerRadius: "0",
						style: _this.style_Content100000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Group_3"),
							height: "36",
							width: "300",
							orientation: "horizontal",
							margin: "0,7,0,0",
							style: _this.style_Group_3, __source: {
								fileName: _jsxFileName,
								lineNumber: 47
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Juspay_Logo_V3"),
								height: "34",
								width: "153",
								orientation: "horizontal",
								gravity: "center",
								weight: "1",
								style: _this.style_Juspay_Logo_V3, __source: {
									fileName: _jsxFileName,
									lineNumber: 54
								}
							},
							dom(ImageView, {
								id: _this.id("Juspay_Logo_V3200000000ø"),
								height: "34",
								width: "match_parent",
								imageUrl: "juspay_logo_v32",
								style: _this.style_Juspay_Logo_V3200000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 62
								}
							})
						),
						dom(ImageView, {
							id: _this.id("University"),
							height: "31",
							width: "143",
							margin: "4,5,0,0",
							imageUrl: "university1",
							style: _this.style_University, __source: {
								fileName: _jsxFileName,
								lineNumber: 69
							}
						})
					),
					dom(LinearLayout, {
						id: _this.id("Space"),
						weight: "1",
						style: _this.style_Space, __source: {
							fileName: _jsxFileName,
							lineNumber: 77
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group_2"),
							height: "50",
							width: "380",
							orientation: "horizontal",
							style: _this.style_Group_2, __source: {
								fileName: _jsxFileName,
								lineNumber: 81
							}
						},
						dom(TextView, {
							id: _this.id("Register"),
							height: "25",
							width: "67",
							margin: "0,13,0,0",
							text: _this.STR.Register1,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Register, __source: {
								fileName: _jsxFileName,
								lineNumber: 87
							}
						}),
						dom(TextView, {
							id: _this.id("Forum"),
							height: "25",
							width: "53",
							margin: "50,13,0,0",
							text: _this.STR.Forum2,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Forum, __source: {
								fileName: _jsxFileName,
								lineNumber: 98
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Group"),
								height: "50",
								width: "160",
								orientation: "vertical",
								padding: "33,13,0,12",
								margin: "50,0,0,0",
								weight: "1",
								background: Color.A__FFFF0000,
								cornerRadius: "4",
								style: _this.style_Group, __source: {
									fileName: _jsxFileName,
									lineNumber: 109
								}
							},
							dom(TextView, {
								id: _this.id("Get_Started"),
								height: "25",
								width: "95",
								text: _this.STR.Get_Started3,
								textSize: FontSize.A_18,
								color: FontColor.A__FFFFFFFF,
								fontStyle: Font.AVENIR_ROMAN,
								gravity: "left",
								style: _this.style_Get_Started, __source: {
									fileName: _jsxFileName,
									lineNumber: 120
								}
							})
						)
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("BgHerotextHe"),
						height: "700",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "80,30,80,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_BgHerotextHe, __source: {
							fileName: _jsxFileName,
							lineNumber: 133
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Landing"),
							height: "606",
							width: "match_parent",
							orientation: "horizontal",
							style: _this.style_Landing, __source: {
								fileName: _jsxFileName,
								lineNumber: 143
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("HerotextHero"),
								height: "606",
								width: "660",
								orientation: "vertical",
								padding: "0,40,0,0",
								weight: "1",
								cornerRadius: "0",
								style: _this.style_HerotextHero, __source: {
									fileName: _jsxFileName,
									lineNumber: 149
								}
							},
							dom(ImageView, {
								id: _this.id("Hero"),
								height: "255",
								width: "445",
								margin: "88,0,0,0",
								imageUrl: "hero3",
								style: _this.style_Hero, __source: {
									fileName: _jsxFileName,
									lineNumber: 158
								}
							}),
							dom(LinearLayout, {
								id: _this.id("Space500000000ø"),
								weight: "1",
								style: _this.style_Space500000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 165
								}
							}),
							dom(
								LinearLayout,
								{
									id: _this.id("Hero_text"),
									height: "237",
									width: "match_parent",
									orientation: "vertical",
									gravity: "center_horizontal",
									cornerRadius: "0",
									style: _this.style_Hero_text, __source: {
										fileName: _jsxFileName,
										lineNumber: 169
									}
								},
								dom(TextView, {
									id: _this.id("Build_real_products"),
									height: "142",
									width: "match_parent",
									text: _this.STR.Build_real_products4,
									textSize: FontSize.A_60,
									color: FontColor.A__FFFF0000,
									fontStyle: Font.AVENIR_BLACK,
									lineHeight: "71px",
									gravity: "left",
									style: _this.style_Build_real_products, __source: {
										fileName: _jsxFileName,
										lineNumber: 177
									}
								}),
								dom(TextView, {
									id: _this.id("In_the_process_of_cr"),
									height: "80",
									width: "match_parent",
									margin: "0,15,0,0",
									text: _this.STR.In_the_process_of_cr5,
									textSize: FontSize.A_18,
									color: FontColor.A__FF4A494A,
									fontStyle: Font.AVENIR_BOOK,
									lineHeight: "28px",
									gravity: "left",
									style: _this.style_In_the_process_of_cr, __source: {
										fileName: _jsxFileName,
										lineNumber: 188
									}
								})
							)
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Group300000000ø"),
								height: "606",
								width: "350",
								orientation: "vertical",
								margin: "110,0,0,0",
								cornerRadius: "0",
								style: _this.style_Group300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 202
								}
							},
							dom(TextView, {
								id: _this.id("Story_of_1B_txns"),
								height: "50",
								width: "match_parent",
								text: _this.STR.Story_of_1B_txns6,
								textSize: FontSize.A_40,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_BLACK,
								lineHeight: "42px",
								gravity: "left",
								style: _this.style_Story_of_1B_txns, __source: {
									fileName: _jsxFileName,
									lineNumber: 210
								}
							}),
							dom(TextView, {
								id: _this.id("Our_engineering_adva"),
								height: "50",
								width: "match_parent",
								margin: "0,5,0,0",
								text: _this.STR.Our_engineering_adva7,
								textSize: FontSize.A_16,
								color: FontColor.A__FF4A494A,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "24px",
								gravity: "left",
								style: _this.style_Our_engineering_adva, __source: {
									fileName: _jsxFileName,
									lineNumber: 221
								}
							}),
							dom(TextView, {
								id: _this.id("Know_how"),
								height: "25",
								width: "95",
								margin: "0,20,0,0",
								text: _this.STR.Know_how8,
								textSize: FontSize.A_18,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Know_how, __source: {
									fileName: _jsxFileName,
									lineNumber: 233
								}
							}),
							dom(LinearLayout, {
								id: _this.id("Line"),
								height: "3",
								width: "match_parent",
								background: Color.A__FFD7D7D7,
								stroke: "3,#ff0000",
								margin: "0,36,0,0",
								cornerRadius: "0",
								style: _this.style_Line, __source: {
									fileName: _jsxFileName,
									lineNumber: 244
								}
							}),
							dom(TextView, {
								id: _this.id("School_of_FP"),
								height: "50",
								width: "match_parent",
								margin: "0,40,0,0",
								text: _this.STR.School_of_FP9,
								textSize: FontSize.A_40,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_BLACK,
								lineHeight: "42px",
								gravity: "left",
								style: _this.style_School_of_FP, __source: {
									fileName: _jsxFileName,
									lineNumber: 253
								}
							}),
							dom(TextView, {
								id: _this.id("Breaking_the_myth_th"),
								height: "50",
								width: "match_parent",
								margin: "0,5,0,0",
								text: _this.STR.Breaking_the_myth_th10,
								textSize: FontSize.A_16,
								color: FontColor.A__FF4A494A,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "24px",
								gravity: "left",
								style: _this.style_Breaking_the_myth_th, __source: {
									fileName: _jsxFileName,
									lineNumber: 265
								}
							}),
							dom(TextView, {
								id: _this.id("Link"),
								height: "25",
								width: "105",
								margin: "0,20,0,0",
								text: _this.STR.Get_Started3,
								textSize: FontSize.A_18,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Link, __source: {
									fileName: _jsxFileName,
									lineNumber: 277
								}
							}),
							dom(LinearLayout, {
								id: _this.id("Line400000000ø"),
								height: "3",
								width: "match_parent",
								background: Color.A__FFD7D7D7,
								stroke: "3,#ff0000",
								margin: "0,34,0,0",
								cornerRadius: "0",
								style: _this.style_Line400000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 288
								}
							}),
							dom(TextView, {
								id: _this.id("Foundation"),
								height: "50",
								width: "match_parent",
								margin: "0,40,0,0",
								text: _this.STR.Foundation11,
								textSize: FontSize.A_40,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_BLACK,
								lineHeight: "42px",
								gravity: "left",
								style: _this.style_Foundation, __source: {
									fileName: _jsxFileName,
									lineNumber: 297
								}
							}),
							dom(TextView, {
								id: _this.id("Derived_from_the_mat"),
								height: "50",
								width: "match_parent",
								margin: "0,5,0,0",
								text: _this.STR.Derived_from_the_mat12,
								textSize: FontSize.A_16,
								color: FontColor.A__FF4A494A,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "24px",
								gravity: "left",
								style: _this.style_Derived_from_the_mat, __source: {
									fileName: _jsxFileName,
									lineNumber: 309
								}
							}),
							dom(TextView, {
								id: _this.id("Coming_soon"),
								height: "25",
								width: "120",
								margin: "0,20,0,0",
								text: _this.STR.Coming_soon13,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Coming_soon, __source: {
									fileName: _jsxFileName,
									lineNumber: 321
								}
							})
						)
					),
					dom(LinearLayout, {
						id: _this.id("Rectangle"),
						height: "20",
						width: "964",
						background: Color.A__FFFFFFFF,
						margin: "0,44,0,0",
						cornerRadius: "0",
						style: _this.style_Rectangle, __source: {
							fileName: _jsxFileName,
							lineNumber: 334
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return Home;
}(Controller);

;

module.exports = Home;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var Home = function (_View) {
	_inherits(Home, _View);

	function Home(props, children, state) {
		_classCallCheck(this, Home);

		var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_Know_how = {
			onClick: _this.onClickKnowHow.bind(_this)
		};

		_this.style_Link = {
			onClick: _this.onClickLetsStart.bind(_this)
		};
		return _this;
	}

	_createClass(Home, [{
		key: "onClickLetsStart",
		value: function onClickLetsStart() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "34", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainHomejs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileSFP" });else window.__duiShowScreen(null, { screen: "SFP" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickKnowHow",
		value: function onClickKnowHow() {
			window.open("https://www.juspay.in", '_blank');
		}
	}]);

	return Home;
}(View);

module.exports = Home;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {"Register1":"Register","Forum2":"Forum","Get_Started3":"Get Started","Build_real_products4":"Build real products\nwhile in college","In_the_process_of_cr5":"In the process of creating market leading payments applications, we're evolving a way to simplify the creation of applications. Juspay University is our way of sharing our learnings and simplifying app creation.","Story_of_1B_txns6":"Story of 1B txns","Our_engineering_adva7":"Our engineering advancement powered us to deliver products like JuspaySafe, BHIM, quickly","Know_how8":"Know how","School_of_FP9":"School of FP","Breaking_the_myth_th10":"Breaking the myth that Functional Programming needs special talent and takes years to master","Foundation11":"Foundation","Derived_from_the_mat12":"Derived from the math of category theory, closely resembling the truths of nature","Coming_soon13":"Coming soon","School_of_Functional14":"School of Functional Programming","We_d_like_to_see_stu15":"We’d like to see students like you develop a lasting love for building products. To enable you become a true Product Maker, you’ll learn the hard fundamentals, which once learnt, shape you to create real-world, large scale applications.","Course16":"Course","Take_the_course17":"Take the course","The_course_provides18":"The course provides a clear path to learn the basic of functional programming and Presto","Basics_of_Functional19":"Basics of Functional Programming","A_simplified_path_to20":"A simplified path to understand basic functional programming concepts like functions, types and monads.","Presto_21":"Presto!","Presto_is_an_app_dev22":"Presto is an app development framework we built using Purely-functional-Programming. Our innovation is bringing the fundamentals of building systems from mathematical theory to a very practical use case.","What_is_Presto_23":"What is Presto?","Internship24":"Internship","Know_more25":"Know more","Learn_the_basics_of26":"Learn the basics of Functional programming  ","Learn_Presto27":"Learn Presto ","Apply_for_an_interns28":"Apply for an internship at Juspay","Internship___Juspay29":"Internship @ Juspay","While_learning_to_cr30":"While learning to create mobile apps is a reward in itself, graduating from the School of Functional Programming, gives you an opportunity to work with the creators of Presto. Work on this project and upon completion, you can choose to submit it to Juspay. Your submission can get you hired at Juspay.","Project31":"Project","Overview32":"Overview","For_an_eager_learner33":"For an eager learner, there’s joy in meeting an expert teacher. In this project you will create an application using Presto to connect such learners and teachers.","The_app_will_allow_l34":"The app will allow learners to geographically locate and connect with teachers in within a 1 km radius. To get you started, here are some ideas about how the app should function.\n","App_Features35":"App Features","Get_user_details_lik36":"Get user details like email id, name, phone number etc","If_user_is_a_learner37":"If user is a learner, the app will get the topics he wishes to learn\nIf user is a teacher, the app will get the topcis he wishes to teach","Explore38":"Explore","A_learner_can_explor39":"A learner can explore to find teachers in his area and get information. If can also explore to find learners with common interests","Learn40":"Learn","A_learner_can_commun41":"A learner can communicate with the teacher and can also request an one-on-one meeting","Tips42":"Tips","Use_a_hosted_server43":"Use a hosted server like Google Appengine / Parse / Linode etc. ","If_that_is_not_possi44":"If that is not possible, send in your code","Use_websockets_for_i45":"Use websockets for instant real time updates","Feel_free_to_design46":"Feel free to design the user interface for maximum impact as you wish. \nUnleash your creativity!","Submit47":"Submit","Pure_functional_appl48":"Pure functional application development framework ","Presto_Flow49":"Presto Flow","Quick_Start50":"Quick Start","View_Code51":"View Code","Code_business_flows52":"Code business flows from composable building blocks. Let Presto deal with errors, state and side effects","Conversational_Flow53":"Conversational Flow","Writing_code_is_like54":"Writing code is like writing a story","Building_Blocks55":"Building Blocks","Every_system_is_a_re56":"Every system is a reusable building block","Focus_on_Conversion57":"Focus on Conversion","Systems_which_have_i58":"Systems which have inbuilt error handling","Improved_Maintainabi59":"Improved Maintainability","Making_development_a60":"Making development and maintenance simple","Presto_UI61":"Presto UI","Generate_UI_Code_dir62":"Generate UI Code directly from Sketch design\nCross Platform. Pixel Perfect","Single_Source_Code63":"Single Source Code","Design_once_and_have64":"Design once and have UI code ready across platforms","Full_Control65":"Full Control","Change_the_UI_withou66":"Change the UI without worrying about messing up Business Logic","Syntax67":"Syntax","Inspired_by_Android68":"Inspired by Android UI layouts and React JSX Syntax","Quick_Development69":"Quick Development","Auto_generate_UI_cod70":"Auto-generate UI code as designed - pixel for pixel, quick","Get_the_latest_Prest71":"Get the latest Presto framework news and updates.","Your_email_address72":"your email address","Subscribe73":"Subscribe","LetsStartText74":"Let’s Start","Hero_Epic75":"Build real products\nwhile in college.","Section_body76":"We want to enable you to become a Product Maker. Join us to learn Functional Programming, Category Theory and Product Design. Start creating scalable, real-world applications while still studying. ","Jump_in___get_starte77":"Jump in & get started.","PrestoSectionText78":"Presto gives a path for students to become professionals","PrestoSectionHelpText79":"Isn’t FP hard to master? Well, “Presto” changes that myth. We built\n Presto with care to make pure FP techniques accessible to beginners.\n With the power of the deep theories of FP, Presto allows beginners\n to write scalable applications from scratch, fast.\n\nBHIM, Juspay Safe, Juspay Fuel and many more large scale applications\n were built by fresheres who mastered the hard parts of \nFunctional Programming (FP) techniques using Presto!","LearnPrestoText80":"Learn more about Presto","WhatCourseText81":"What you’ll do in this course","CurriculumText82":"Curriculum","CurriculumHelpText83":"The course provides a clear path to learn:\n\n- Understand Functional Programming concepts\n- Define lego blocks of app development\n- Explore the Presto Framework\n- Apply Presto to develop a working app","ProjectHelpText84":"Upon completion, you can choose to submit the project to Juspay. Your submission can get you hired at Juspay.","SoundsExcitingText85":"Sounds exciting? Then let’s get learning\nand make something kick-ass.","Discover_Presto86":"Discover Presto","While_learning_to_cr87":"While learning to create mobile apps is a reward in itself, graduating from the School of Functional , gives you an opportunity to work with the creators of Presto. Work on this project and upon completion, you can choose to submit it to Juspay. Your submission can get you hired at Juspay.","Every_system_is_reus88":"Every system is reusable building block","Generate_UI_Code_dir89":"Generate UI Code directly from Sketch design\nCross Platform. \nPixel Perfect","Hero_Story90":"Isn’t FP hard to master? Well, “Presto” changes that myth. We built Presto with care to make pure FP techniques accessible to beginners. With the power of the deep theories of FP, Presto allows beginners to write scalable applications from scratch, fast.\n\nBHIM, Juspay Safe, Juspay Fuel and many more large scale applications were built by fresheres who mastered the hard parts of \nFunctional Programming (FP) techniques using Presto!","Hero_Story_Copy91":"17-Million Total Users","Hero_Story_Copy_292":"800-Million Txns processed","Hero_Story_Copy_293":"UPI Payments at Petrol Pumps","SoundsText94":"Sounds exciting? Then let’s get learning and make something kick-ass.","Let_s_Start95":"Let’s Start "}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Main/SFP.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(17);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var SFP = function (_Controller) {
	_inherits(SFP, _Controller);

	function SFP(props, children, state) {
		_classCallCheck(this, SFP);

		var _this = _possibleConstructorReturn(this, (SFP.__proto__ || Object.getPrototypeOf(SFP)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "99",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,32,80,31",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 38
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Group_5"),
							height: "36",
							width: "299",
							orientation: "horizontal",
							style: _this.style_Group_5, __source: {
								fileName: _jsxFileName,
								lineNumber: 47
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Juspay_Logo_V3"),
								height: "34",
								width: "152",
								orientation: "horizontal",
								gravity: "center",
								weight: "1",
								style: _this.style_Juspay_Logo_V3, __source: {
									fileName: _jsxFileName,
									lineNumber: 53
								}
							},
							dom(ImageView, {
								id: _this.id("Juspay_Logo_V3100000000ø"),
								height: "34",
								width: "match_parent",
								imageUrl: "juspay_logo_v321",
								style: _this.style_Juspay_Logo_V3100000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 61
								}
							})
						),
						dom(ImageView, {
							id: _this.id("University"),
							height: "31",
							width: "143",
							margin: "4,5,0,0",
							imageUrl: "university20",
							style: _this.style_University, __source: {
								fileName: _jsxFileName,
								lineNumber: 68
							}
						})
					),
					dom(LinearLayout, {
						id: _this.id("Space"),
						weight: "1",
						style: _this.style_Space, __source: {
							fileName: _jsxFileName,
							lineNumber: 76
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group"),
							height: "25",
							width: "171",
							orientation: "horizontal",
							margin: "0,5,0,0",
							style: _this.style_Group, __source: {
								fileName: _jsxFileName,
								lineNumber: 80
							}
						},
						dom(TextView, {
							id: _this.id("Register"),
							height: "25",
							width: "67",
							weight: "1",
							text: _this.STR.Register1,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Register, __source: {
								fileName: _jsxFileName,
								lineNumber: 87
							}
						}),
						dom(TextView, {
							id: _this.id("Forum"),
							height: "25",
							width: "53",
							margin: "51,0,0,0",
							text: _this.STR.Forum2,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Forum, __source: {
								fileName: _jsxFileName,
								lineNumber: 98
							}
						})
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Wedliketosee"),
						height: "678",
						width: "1120",
						orientation: "vertical",
						padding: "300,0,0,0",
						margin: "80,40,0,0",
						cornerRadius: "0",
						style: _this.style_Wedliketosee, __source: {
							fileName: _jsxFileName,
							lineNumber: 111
						}
					},
					dom(TextView, {
						id: _this.id("School_of_Functional"),
						height: "130",
						width: "800",
						text: _this.STR.School_of_Functional14,
						textSize: FontSize.A_60,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "65px",
						gravity: "left",
						style: _this.style_School_of_Functional, __source: {
							fileName: _jsxFileName,
							lineNumber: 120
						}
					}),
					dom(ImageView, {
						id: _this.id("Group_3_Copy"),
						height: "387",
						width: "308",
						margin: "176,41,0,0",
						imageUrl: "group3copy19",
						style: _this.style_Group_3_Copy, __source: {
							fileName: _jsxFileName,
							lineNumber: 131
						}
					}),
					dom(TextView, {
						id: _this.id("We_d_like_to_see_stu"),
						height: "80",
						width: "match_parent",
						margin: "0,40,0,0",
						text: _this.STR.We_d_like_to_see_stu15,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_We_d_like_to_see_stu, __source: {
							fileName: _jsxFileName,
							lineNumber: 138
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("BgPrestoisan"),
						height: "429",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,0,75,0",
						margin: "0,80,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_BgPrestoisan, __source: {
							fileName: _jsxFileName,
							lineNumber: 151
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Line2CourseB"),
							height: "153",
							width: "250",
							orientation: "vertical",
							cornerRadius: "0",
							style: _this.style_Line2CourseB, __source: {
								fileName: _jsxFileName,
								lineNumber: 161
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line_2"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "3,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line_2, __source: {
								fileName: _jsxFileName,
								lineNumber: 168
							}
						}),
						dom(TextView, {
							id: _this.id("Course"),
							height: "50",
							width: "171",
							margin: "0,40,0,0",
							text: _this.STR.Course16,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Course, __source: {
								fileName: _jsxFileName,
								lineNumber: 176
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Takethecours"),
								height: "31",
								width: "220",
								orientation: "horizontal",
								margin: "0,30,0,0",
								cornerRadius: "0",
								style: _this.style_Takethecours, __source: {
									fileName: _jsxFileName,
									lineNumber: 188
								}
							},
							dom(ImageView, {
								id: _this.id("Group_7"),
								height: "31",
								width: "30",
								imageUrl: "group718",
								style: _this.style_Group_7, __source: {
									fileName: _jsxFileName,
									lineNumber: 196
								}
							}),
							dom(TextView, {
								id: _this.id("Take_the_course"),
								height: "30",
								width: "180",
								margin: "10,1,0,0",
								weight: "1",
								text: _this.STR.Take_the_course17,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Take_the_course, __source: {
									fileName: _jsxFileName,
									lineNumber: 202
								}
							})
						)
					),
					dom(
						LinearLayout,
						{
							id: _this.id("Prestoisanap"),
							height: "377",
							width: "825",
							orientation: "vertical",
							padding: "0,0,5,0",
							margin: "50,52,0,0",
							weight: "1",
							cornerRadius: "0",
							style: _this.style_Prestoisanap, __source: {
								fileName: _jsxFileName,
								lineNumber: 216
							}
						},
						dom(TextView, {
							id: _this.id("The_course_provides"),
							height: "30",
							width: "800",
							text: _this.STR.The_course_provides18,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_The_course_provides, __source: {
								fileName: _jsxFileName,
								lineNumber: 226
							}
						}),
						dom(TextView, {
							id: _this.id("Basics_of_Functional"),
							height: "50",
							width: "729",
							margin: "0,15,0,0",
							text: _this.STR.Basics_of_Functional19,
							textSize: FontSize.A_30,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_HEAVY,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Basics_of_Functional, __source: {
								fileName: _jsxFileName,
								lineNumber: 237
							}
						}),
						dom(TextView, {
							id: _this.id("A_simplified_path_to"),
							height: "60",
							width: "match_parent",
							margin: "0,7,0,0",
							text: _this.STR.A_simplified_path_to20,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_A_simplified_path_to, __source: {
								fileName: _jsxFileName,
								lineNumber: 249
							}
						}),
						dom(TextView, {
							id: _this.id("Presto_"),
							height: "50",
							width: "660",
							margin: "0,30,0,0",
							text: _this.STR.Presto_21,
							textSize: FontSize.A_30,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_HEAVY,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Presto_, __source: {
								fileName: _jsxFileName,
								lineNumber: 261
							}
						}),
						dom(TextView, {
							id: _this.id("Presto_is_an_app_dev"),
							height: "90",
							width: "match_parent",
							margin: "0,5,0,0",
							text: _this.STR.Presto_is_an_app_dev22,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Presto_is_an_app_dev, __source: {
								fileName: _jsxFileName,
								lineNumber: 273
							}
						}),
						dom(TextView, {
							id: _this.id("What_is_Presto_"),
							height: "30",
							width: "164",
							margin: "0,10,0,0",
							text: _this.STR.What_is_Presto_23,
							textSize: FontSize.A_22,
							color: FontColor.A__FFFF0000,
							fontStyle: Font.AVENIR_HEAVY,
							gravity: "left",
							style: _this.style_What_is_Presto_, __source: {
								fileName: _jsxFileName,
								lineNumber: 285
							}
						})
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("BgGroup10Kno"),
						height: "152",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,0,94,0",
						margin: "0,60,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_BgGroup10Kno, __source: {
							fileName: _jsxFileName,
							lineNumber: 298
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Group10Knowm"),
							height: "142",
							width: "250",
							orientation: "vertical",
							cornerRadius: "0",
							style: _this.style_Group10Knowm, __source: {
								fileName: _jsxFileName,
								lineNumber: 308
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line_2200000000ø"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "3,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line_2200000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 315
							}
						}),
						dom(TextView, {
							id: _this.id("Internship"),
							height: "50",
							width: "230",
							margin: "0,30,0,0",
							text: _this.STR.Internship24,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Internship, __source: {
								fileName: _jsxFileName,
								lineNumber: 323
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("KnowmoreGroup10"),
								height: "30",
								width: "190",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_KnowmoreGroup10, __source: {
									fileName: _jsxFileName,
									lineNumber: 335
								}
							},
							dom(ImageView, {
								id: _this.id("Group_10"),
								height: "30",
								width: "30",
								imageUrl: "group1017",
								style: _this.style_Group_10, __source: {
									fileName: _jsxFileName,
									lineNumber: 342
								}
							}),
							dom(TextView, {
								id: _this.id("Know_more"),
								height: "30",
								width: "150",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Know_more25,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Know_more, __source: {
									fileName: _jsxFileName,
									lineNumber: 348
								}
							})
						)
					),
					dom(
						LinearLayout,
						{
							id: _this.id("Learnthebasi"),
							height: "110",
							width: "806",
							orientation: "vertical",
							margin: "50,42,0,0",
							weight: "1",
							cornerRadius: "0",
							style: _this.style_Learnthebasi, __source: {
								fileName: _jsxFileName,
								lineNumber: 362
							}
						},
						dom(TextView, {
							id: _this.id("Learn_the_basics_of"),
							height: "30",
							width: "match_parent",
							text: _this.STR.Learn_the_basics_of26,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Learn_the_basics_of, __source: {
								fileName: _jsxFileName,
								lineNumber: 371
							}
						}),
						dom(TextView, {
							id: _this.id("Learn_Presto"),
							height: "30",
							width: "107",
							margin: "0,10,0,0",
							text: _this.STR.Learn_Presto27,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Learn_Presto, __source: {
								fileName: _jsxFileName,
								lineNumber: 382
							}
						}),
						dom(TextView, {
							id: _this.id("Apply_for_an_interns"),
							height: "30",
							width: "266",
							margin: "0,10,0,0",
							text: _this.STR.Apply_for_an_interns28,
							textSize: FontSize.A_18,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Apply_for_an_interns, __source: {
								fileName: _jsxFileName,
								lineNumber: 394
							}
						})
					)
				),
				dom(LinearLayout, {
					id: _this.id("Rectangle_2"),
					height: "40",
					width: "343",
					background: Color.A__FFFFFFFF,
					margin: "469,22,0,0",
					cornerRadius: "0",
					style: _this.style_Rectangle_2, __source: {
						fileName: _jsxFileName,
						lineNumber: 407
					}
				})
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return SFP;
}(Controller);

;

module.exports = SFP;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var SFP = function (_View) {
	_inherits(SFP, _View);

	function SFP(props, children, state) {
		_classCallCheck(this, SFP);

		var _this = _possibleConstructorReturn(this, (SFP.__proto__ || Object.getPrototypeOf(SFP)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};

		_this.style_Takethecours = {
			onClick: _this.onClickTake.bind(_this)
		};

		_this.style_KnowmoreGroup10 = {
			onClick: _this.onClickKnow.bind(_this)
		};

		_this.style_What_is_Presto_ = {
			onClick: _this.onClickPresto.bind(_this)
		};
		return _this;
	}

	_createClass(SFP, [{
		key: "onClickHome",
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "38", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickTake",
		value: function onClickTake() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/", '_blank');
		}
	}, {
		key: "onClickPresto",
		value: function onClickPresto() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "61", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobilePresto" });else window.__duiShowScreen(null, { screen: "Presto" });
		}
	}, {
		key: "onClickKnow",
		value: function onClickKnow() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "72", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileProject" });else window.__duiShowScreen(null, { screen: "Project" });
		}
	}]);

	return SFP;
}(View);

module.exports = SFP;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Main/Project.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(19);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var Project = function (_Controller) {
	_inherits(Project, _Controller);

	function Project(props, children, state) {
		_classCallCheck(this, Project);

		var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "99",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,32,80,31",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Group_5"),
							height: "36",
							width: "299",
							orientation: "horizontal",
							style: _this.style_Group_5, __source: {
								fileName: _jsxFileName,
								lineNumber: 48
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Juspay_Logo_V3"),
								height: "34",
								width: "152",
								orientation: "horizontal",
								gravity: "center",
								weight: "1",
								style: _this.style_Juspay_Logo_V3, __source: {
									fileName: _jsxFileName,
									lineNumber: 54
								}
							},
							dom(ImageView, {
								id: _this.id("Juspay_Logo_V3100000000ø"),
								height: "34",
								width: "match_parent",
								imageUrl: "juspay_logo_v329",
								style: _this.style_Juspay_Logo_V3100000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 62
								}
							})
						),
						dom(ImageView, {
							id: _this.id("University"),
							height: "31",
							width: "143",
							margin: "4,5,0,0",
							imageUrl: "university28",
							style: _this.style_University, __source: {
								fileName: _jsxFileName,
								lineNumber: 69
							}
						})
					),
					dom(LinearLayout, {
						id: _this.id("Space"),
						weight: "1",
						style: _this.style_Space, __source: {
							fileName: _jsxFileName,
							lineNumber: 77
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group"),
							height: "25",
							width: "171",
							orientation: "horizontal",
							margin: "0,5,0,0",
							style: _this.style_Group, __source: {
								fileName: _jsxFileName,
								lineNumber: 81
							}
						},
						dom(TextView, {
							id: _this.id("Register"),
							height: "25",
							width: "67",
							weight: "1",
							text: _this.STR.Register1,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Register, __source: {
								fileName: _jsxFileName,
								lineNumber: 88
							}
						}),
						dom(TextView, {
							id: _this.id("Forum"),
							height: "25",
							width: "53",
							margin: "51,0,0,0",
							text: _this.STR.Forum2,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "left",
							style: _this.style_Forum, __source: {
								fileName: _jsxFileName,
								lineNumber: 99
							}
						})
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Group_9"),
						height: "1325",
						width: "660",
						orientation: "vertical",
						gravity: "center_horizontal",
						margin: "0,40,0,0",
						style: _this.style_Group_9, __source: {
							fileName: _jsxFileName,
							lineNumber: 112
						}
					},
					dom(TextView, {
						id: _this.id("Internship___Juspay"),
						height: "64",
						width: "match_parent",
						text: _this.STR.Internship___Juspay29,
						textSize: FontSize.A_60,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "64px",
						gravity: "left",
						style: _this.style_Internship___Juspay, __source: {
							fileName: _jsxFileName,
							lineNumber: 120
						}
					}),
					dom(TextView, {
						id: _this.id("While_learning_to_cr"),
						height: "112",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.While_learning_to_cr30,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_While_learning_to_cr, __source: {
							fileName: _jsxFileName,
							lineNumber: 131
						}
					}),
					dom(TextView, {
						id: _this.id("Project"),
						height: "33",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Project31,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						gravity: "left",
						style: _this.style_Project, __source: {
							fileName: _jsxFileName,
							lineNumber: 143
						}
					}),
					dom(TextView, {
						id: _this.id("Overview"),
						height: "25",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Overview32,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Overview, __source: {
							fileName: _jsxFileName,
							lineNumber: 154
						}
					}),
					dom(TextView, {
						id: _this.id("For_an_eager_learner"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.For_an_eager_learner33,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_For_an_eager_learner, __source: {
							fileName: _jsxFileName,
							lineNumber: 165
						}
					}),
					dom(TextView, {
						id: _this.id("The_app_will_allow_l"),
						height: "90",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.The_app_will_allow_l34,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_The_app_will_allow_l, __source: {
							fileName: _jsxFileName,
							lineNumber: 177
						}
					}),
					dom(TextView, {
						id: _this.id("App_Features"),
						height: "30",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.App_Features35,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_App_Features, __source: {
							fileName: _jsxFileName,
							lineNumber: 189
						}
					}),
					dom(TextView, {
						id: _this.id("Register200000000ø"),
						height: "30",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Register200000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 201
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group_8"),
							height: "90",
							width: "match_parent",
							orientation: "vertical",
							gravity: "center_horizontal",
							margin: "0,5,0,0",
							style: _this.style_Group_8, __source: {
								fileName: _jsxFileName,
								lineNumber: 213
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Group300000000ø"),
								height: "30",
								width: "match_parent",
								orientation: "horizontal",
								gravity: "center_vertical",
								style: _this.style_Group300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 221
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									style: _this.style_Bullet, __source: {
										fileName: _jsxFileName,
										lineNumber: 228
									}
								},
								dom(ImageView, {
									id: _this.id("Group400000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group26",
									style: _this.style_Group400000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 235
									}
								})
							),
							dom(TextView, {
								id: _this.id("Get_user_details_lik"),
								height: "30",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Get_user_details_lik36,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_Get_user_details_lik, __source: {
									fileName: _jsxFileName,
									lineNumber: 242
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Group_3"),
								height: "60",
								width: "match_parent",
								orientation: "horizontal",
								padding: "0,0,0,-1",
								style: _this.style_Group_3, __source: {
									fileName: _jsxFileName,
									lineNumber: 256
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet500000000ø"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									margin: "0,11,0,0",
									style: _this.style_Bullet500000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 263
									}
								},
								dom(ImageView, {
									id: _this.id("Group600000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group27",
									style: _this.style_Group600000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 271
									}
								})
							),
							dom(TextView, {
								id: _this.id("If_user_is_a_learner"),
								height: "60",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.If_user_is_a_learner37,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_If_user_is_a_learner, __source: {
									fileName: _jsxFileName,
									lineNumber: 278
								}
							})
						)
					),
					dom(TextView, {
						id: _this.id("Explore"),
						height: "25",
						width: "match_parent",
						margin: "0,15,0,0",
						text: _this.STR.Explore38,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						gravity: "left",
						style: _this.style_Explore, __source: {
							fileName: _jsxFileName,
							lineNumber: 293
						}
					}),
					dom(TextView, {
						id: _this.id("A_learner_can_explor"),
						height: "60",
						width: "match_parent",
						margin: "0,5,0,0",
						text: _this.STR.A_learner_can_explor39,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_A_learner_can_explor, __source: {
							fileName: _jsxFileName,
							lineNumber: 304
						}
					}),
					dom(TextView, {
						id: _this.id("Learn"),
						height: "25",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Learn40,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						gravity: "left",
						style: _this.style_Learn, __source: {
							fileName: _jsxFileName,
							lineNumber: 316
						}
					}),
					dom(TextView, {
						id: _this.id("A_learner_can_commun"),
						height: "60",
						width: "match_parent",
						margin: "0,5,0,0",
						text: _this.STR.A_learner_can_commun41,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_A_learner_can_commun, __source: {
							fileName: _jsxFileName,
							lineNumber: 327
						}
					}),
					dom(TextView, {
						id: _this.id("Tips"),
						height: "30",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Tips42,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Tips, __source: {
							fileName: _jsxFileName,
							lineNumber: 339
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group_7"),
							height: "150",
							width: "match_parent",
							orientation: "vertical",
							gravity: "center_horizontal",
							margin: "0,10,0,0",
							style: _this.style_Group_7, __source: {
								fileName: _jsxFileName,
								lineNumber: 351
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Group_2"),
								height: "30",
								width: "match_parent",
								orientation: "horizontal",
								gravity: "center_vertical",
								style: _this.style_Group_2, __source: {
									fileName: _jsxFileName,
									lineNumber: 359
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet700000000ø"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									style: _this.style_Bullet700000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 366
									}
								},
								dom(ImageView, {
									id: _this.id("Group800000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group22",
									style: _this.style_Group800000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 373
									}
								})
							),
							dom(TextView, {
								id: _this.id("Use_a_hosted_server"),
								height: "30",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Use_a_hosted_server43,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_Use_a_hosted_server, __source: {
									fileName: _jsxFileName,
									lineNumber: 380
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Group_4"),
								height: "30",
								width: "match_parent",
								orientation: "horizontal",
								style: _this.style_Group_4, __source: {
									fileName: _jsxFileName,
									lineNumber: 394
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet900000000ø"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									margin: "0,11,0,0",
									style: _this.style_Bullet900000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 400
									}
								},
								dom(ImageView, {
									id: _this.id("Group1000000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group25",
									style: _this.style_Group1000000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 408
									}
								})
							),
							dom(TextView, {
								id: _this.id("If_that_is_not_possi"),
								height: "30",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.If_that_is_not_possi44,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_If_that_is_not_possi, __source: {
									fileName: _jsxFileName,
									lineNumber: 415
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Group_6"),
								height: "30",
								width: "match_parent",
								orientation: "horizontal",
								style: _this.style_Group_6, __source: {
									fileName: _jsxFileName,
									lineNumber: 429
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet1100000000ø"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									margin: "0,11,0,0",
									style: _this.style_Bullet1100000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 435
									}
								},
								dom(ImageView, {
									id: _this.id("Group1200000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group23",
									style: _this.style_Group1200000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 443
									}
								})
							),
							dom(TextView, {
								id: _this.id("Use_websockets_for_i"),
								height: "30",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Use_websockets_for_i45,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_Use_websockets_for_i, __source: {
									fileName: _jsxFileName,
									lineNumber: 450
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Group_51300000000ø"),
								height: "60",
								width: "match_parent",
								orientation: "horizontal",
								style: _this.style_Group_51300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 464
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Bullet1400000000ø"),
									height: "8",
									width: "8",
									orientation: "horizontal",
									gravity: "center",
									margin: "0,11,0,0",
									style: _this.style_Bullet1400000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 470
									}
								},
								dom(ImageView, {
									id: _this.id("Group1500000000ø"),
									height: "8",
									width: "8",
									imageUrl: "group24",
									style: _this.style_Group1500000000ø, __source: {
										fileName: _jsxFileName,
										lineNumber: 478
									}
								})
							),
							dom(TextView, {
								id: _this.id("Feel_free_to_design"),
								height: "60",
								width: "642",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Feel_free_to_design46,
								textSize: FontSize.A_18,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "28px",
								gravity: "left",
								style: _this.style_Feel_free_to_design, __source: {
									fileName: _jsxFileName,
									lineNumber: 485
								}
							})
						)
					),
					dom(
						LinearLayout,
						{
							id: _this.id("ButtonGroup"),
							height: "60",
							width: "match_parent",
							orientation: "horizontal",
							gravity: "center_vertical",
							padding: "0,0,460,0",
							margin: "0,50,0,0",
							cornerRadius: "0",
							style: _this.style_ButtonGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 500
							}
						},
						dom(LinearLayout, {
							id: _this.id("Space1600000000ø"),
							weight: "1",
							style: _this.style_Space1600000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 510
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Button"),
								height: "60",
								width: "200",
								orientation: "vertical",
								padding: "60,14,0,13",
								background: Color.A__FFFF0000,
								cornerRadius: "4",
								style: _this.style_Button, __source: {
									fileName: _jsxFileName,
									lineNumber: 514
								}
							},
							dom(TextView, {
								id: _this.id("Submit"),
								height: "33",
								width: "80",
								text: _this.STR.Submit47,
								textSize: FontSize.A_24,
								color: FontColor.A__FFFFFFFF,
								fontStyle: Font.AVENIR_BLACK,
								gravity: "left",
								style: _this.style_Submit, __source: {
									fileName: _jsxFileName,
									lineNumber: 523
								}
							})
						)
					),
					dom(LinearLayout, {
						id: _this.id("Rectangle"),
						height: "90",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						margin: "0,21,0,0",
						cornerRadius: "0",
						style: _this.style_Rectangle, __source: {
							fileName: _jsxFileName,
							lineNumber: 535
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return Project;
}(Controller);

;

module.exports = Project;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var Project = function (_View) {
	_inherits(Project, _View);

	function Project(props, children, state) {
		_classCallCheck(this, Project);

		var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};

		_this.style_Button = {
			onClick: _this.onClickSubmit.bind(_this)
		};
		return _this;
	}

	_createClass(Project, [{
		key: "onClickHome",
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "30", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainProjectjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickSubmit",
		value: function onClickSubmit() {
			window.open("https://docs.google.com/forms/d/e/1FAIpQLSfB2DXrYR7RHLdbdEJAE9h5WVb3LV3tIh3aC74A8IwXIF1WZw/viewform", '_blank');
		}
	}]);

	return Project;
}(View);

module.exports = Project;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Main/Presto.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;
var EditText = __webpack_require__(0).views.EditText;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(21);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var Presto = function (_Controller) {
	_inherits(Presto, _Controller);

	function Presto(props, children, state) {
		_classCallCheck(this, Presto);

		var _this = _possibleConstructorReturn(this, (Presto.__proto__ || Object.getPrototypeOf(Presto)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					padding: "0,0,0,33",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 30
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header_Presto"),
						height: "99",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,32,85,31",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header_Presto, __source: {
							fileName: _jsxFileName,
							lineNumber: 41
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "36",
						width: "301",
						imageUrl: "group536",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 50
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Space700000000ø"),
						weight: "1",
						style: _this.style_Space700000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 56
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "53",
						margin: "0,5,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 60
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Hero_text"),
						height: "500",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "0,0,0,72",
						margin: "0,54,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Hero_text, __source: {
							fileName: _jsxFileName,
							lineNumber: 72
						}
					},
					dom(TextView, {
						id: _this.id("Title"),
						height: "64",
						width: "match_parent",
						text: _this.STR.Presto_21,
						textSize: FontSize.A_60,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "64px",
						gravity: "center",
						style: _this.style_Title, __source: {
							fileName: _jsxFileName,
							lineNumber: 83
						}
					}),
					dom(TextView, {
						id: _this.id("Pure_functional_appl"),
						height: "49",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Pure_functional_appl48,
						textSize: FontSize.A_36,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "center",
						style: _this.style_Pure_functional_appl, __source: {
							fileName: _jsxFileName,
							lineNumber: 94
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Space800000000ø"),
						weight: "1",
						style: _this.style_Space800000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 105
						}
					}),
					dom(ImageView, {
						id: _this.id("Hero_Image"),
						height: "230",
						width: "304",
						imageUrl: "heroimage35",
						style: _this.style_Hero_Image, __source: {
							fileName: _jsxFileName,
							lineNumber: 109
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Presto_flow"),
						height: "402",
						width: "match_parent",
						orientation: "vertical",
						padding: "80,0,80,0",
						margin: "0,47,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Presto_flow, __source: {
							fileName: _jsxFileName,
							lineNumber: 116
						}
					},
					dom(LinearLayout, {
						id: _this.id("Line"),
						height: "2",
						width: "250",
						background: Color.A__FFD7D7D7,
						stroke: "3,#ff0000",
						cornerRadius: "0",
						style: _this.style_Line, __source: {
							fileName: _jsxFileName,
							lineNumber: 126
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("CodebusinessGithubmarkpr"),
							height: "370",
							width: "match_parent",
							orientation: "horizontal",
							margin: "0,30,0,0",
							style: _this.style_CodebusinessGithubmarkpr, __source: {
								fileName: _jsxFileName,
								lineNumber: 134
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("GithubmarkPr"),
								height: "171",
								width: "300",
								orientation: "vertical",
								cornerRadius: "0",
								style: _this.style_GithubmarkPr, __source: {
									fileName: _jsxFileName,
									lineNumber: 141
								}
							},
							dom(TextView, {
								id: _this.id("Presto_Flow"),
								height: "50",
								width: "match_parent",
								text: _this.STR.Presto_Flow49,
								textSize: FontSize.A_40,
								color: FontColor.A__FF000000,
								fontStyle: Font.AVENIR_BLACK,
								lineHeight: "42px",
								gravity: "left",
								style: _this.style_Presto_Flow, __source: {
									fileName: _jsxFileName,
									lineNumber: 148
								}
							}),
							dom(
								LinearLayout,
								{
									id: _this.id("Group7Quickstart"),
									height: "31",
									width: "185",
									orientation: "horizontal",
									margin: "0,30,0,0",
									style: _this.style_Group7Quickstart, __source: {
										fileName: _jsxFileName,
										lineNumber: 159
									}
								},
								dom(ImageView, {
									id: _this.id("Group_7"),
									height: "31",
									width: "30",
									imageUrl: "group733",
									style: _this.style_Group_7, __source: {
										fileName: _jsxFileName,
										lineNumber: 166
									}
								}),
								dom(TextView, {
									id: _this.id("Quick_Start"),
									height: "30",
									width: "143",
									margin: "12,1,0,0",
									weight: "1",
									text: _this.STR.Quick_Start50,
									textSize: FontSize.A_22,
									color: FontColor.A__FFFF0000,
									fontStyle: Font.AVENIR_HEAVY,
									gravity: "left",
									style: _this.style_Quick_Start, __source: {
										fileName: _jsxFileName,
										lineNumber: 172
									}
								})
							),
							dom(
								LinearLayout,
								{
									id: _this.id("ViewcodeGithubmark"),
									height: "30",
									width: "155",
									orientation: "horizontal",
									margin: "0,30,0,0",
									style: _this.style_ViewcodeGithubmark, __source: {
										fileName: _jsxFileName,
										lineNumber: 185
									}
								},
								dom(ImageView, {
									id: _this.id("GitHub_Mark"),
									height: "30",
									width: "30",
									imageUrl: "githubmark34",
									style: _this.style_GitHub_Mark, __source: {
										fileName: _jsxFileName,
										lineNumber: 192
									}
								}),
								dom(TextView, {
									id: _this.id("View_Code"),
									height: "30",
									width: "115",
									margin: "10,0,0,0",
									weight: "1",
									text: _this.STR.View_Code51,
									textSize: FontSize.A_22,
									color: FontColor.A__FFFF0000,
									fontStyle: Font.AVENIR_HEAVY,
									gravity: "left",
									style: _this.style_View_Code, __source: {
										fileName: _jsxFileName,
										lineNumber: 198
									}
								})
							)
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Codebusiness"),
								height: "370",
								width: "820",
								orientation: "vertical",
								gravity: "center_horizontal",
								weight: "1",
								cornerRadius: "0",
								style: _this.style_Codebusiness, __source: {
									fileName: _jsxFileName,
									lineNumber: 212
								}
							},
							dom(TextView, {
								id: _this.id("Code_business_flows"),
								height: "60",
								width: "match_parent",
								text: _this.STR.Code_business_flows52,
								textSize: FontSize.A_20,
								color: FontColor.A__FF4A494A,
								fontStyle: Font.AVENIR_ROMAN,
								lineHeight: "30px",
								gravity: "left",
								style: _this.style_Code_business_flows, __source: {
									fileName: _jsxFileName,
									lineNumber: 221
								}
							}),
							dom(
								LinearLayout,
								{
									id: _this.id("WritingcodeiEverysystemi"),
									height: "115",
									width: "match_parent",
									orientation: "horizontal",
									margin: "0,50,0,0",
									style: _this.style_WritingcodeiEverysystemi, __source: {
										fileName: _jsxFileName,
										lineNumber: 232
									}
								},
								dom(
									LinearLayout,
									{
										id: _this.id("Writingcodei"),
										height: "85",
										width: "360",
										orientation: "vertical",
										gravity: "center_horizontal",
										weight: "1",
										cornerRadius: "0",
										style: _this.style_Writingcodei, __source: {
											fileName: _jsxFileName,
											lineNumber: 239
										}
									},
									dom(TextView, {
										id: _this.id("Conversational_Flow"),
										height: "50",
										width: "match_parent",
										text: _this.STR.Conversational_Flow53,
										textSize: FontSize.A_26,
										color: FontColor.A__FF000000,
										fontStyle: Font.AVENIR_MEDIUM,
										lineHeight: "42px",
										gravity: "left",
										style: _this.style_Conversational_Flow, __source: {
											fileName: _jsxFileName,
											lineNumber: 248
										}
									}),
									dom(TextView, {
										id: _this.id("Writing_code_is_like"),
										height: "30",
										width: "match_parent",
										margin: "0,5,0,0",
										text: _this.STR.Writing_code_is_like54,
										textSize: FontSize.A_20,
										color: FontColor.A__FF4A494A,
										fontStyle: Font.AVENIR_ROMAN,
										lineHeight: "28px",
										gravity: "left",
										style: _this.style_Writing_code_is_like, __source: {
											fileName: _jsxFileName,
											lineNumber: 259
										}
									})
								),
								dom(
									LinearLayout,
									{
										id: _this.id("Everysystemi"),
										height: "115",
										width: "360",
										orientation: "vertical",
										gravity: "center_horizontal",
										margin: "100,0,0,0",
										weight: "1",
										cornerRadius: "0",
										style: _this.style_Everysystemi, __source: {
											fileName: _jsxFileName,
											lineNumber: 272
										}
									},
									dom(TextView, {
										id: _this.id("Building_Blocks"),
										height: "50",
										width: "match_parent",
										text: _this.STR.Building_Blocks55,
										textSize: FontSize.A_26,
										color: FontColor.A__FF000000,
										fontStyle: Font.AVENIR_MEDIUM,
										lineHeight: "42px",
										gravity: "left",
										style: _this.style_Building_Blocks, __source: {
											fileName: _jsxFileName,
											lineNumber: 282
										}
									}),
									dom(TextView, {
										id: _this.id("Every_system_is_a_re"),
										height: "60",
										width: "match_parent",
										margin: "0,5,0,0",
										text: _this.STR.Every_system_is_a_re56,
										textSize: FontSize.A_20,
										color: FontColor.A__FF4A494A,
										fontStyle: Font.AVENIR_ROMAN,
										lineHeight: "28px",
										gravity: "left",
										style: _this.style_Every_system_is_a_re, __source: {
											fileName: _jsxFileName,
											lineNumber: 293
										}
									})
								)
							),
							dom(
								LinearLayout,
								{
									id: _this.id("SystemswhichMakingdevelo"),
									height: "115",
									width: "match_parent",
									orientation: "horizontal",
									margin: "0,30,0,0",
									style: _this.style_SystemswhichMakingdevelo, __source: {
										fileName: _jsxFileName,
										lineNumber: 307
									}
								},
								dom(
									LinearLayout,
									{
										id: _this.id("Systemswhich"),
										height: "115",
										width: "360",
										orientation: "vertical",
										gravity: "center_horizontal",
										weight: "1",
										cornerRadius: "0",
										style: _this.style_Systemswhich, __source: {
											fileName: _jsxFileName,
											lineNumber: 314
										}
									},
									dom(TextView, {
										id: _this.id("Focus_on_Conversion"),
										height: "50",
										width: "match_parent",
										text: _this.STR.Focus_on_Conversion57,
										textSize: FontSize.A_26,
										color: FontColor.A__FF000000,
										fontStyle: Font.AVENIR_MEDIUM,
										lineHeight: "42px",
										gravity: "left",
										style: _this.style_Focus_on_Conversion, __source: {
											fileName: _jsxFileName,
											lineNumber: 323
										}
									}),
									dom(TextView, {
										id: _this.id("Systems_which_have_i"),
										height: "60",
										width: "match_parent",
										margin: "0,5,0,0",
										text: _this.STR.Systems_which_have_i58,
										textSize: FontSize.A_20,
										color: FontColor.A__FF4A494A,
										fontStyle: Font.AVENIR_ROMAN,
										lineHeight: "28px",
										gravity: "left",
										style: _this.style_Systems_which_have_i, __source: {
											fileName: _jsxFileName,
											lineNumber: 334
										}
									})
								),
								dom(
									LinearLayout,
									{
										id: _this.id("Makingdevelo"),
										height: "115",
										width: "360",
										orientation: "vertical",
										gravity: "center_horizontal",
										margin: "100,0,0,0",
										weight: "1",
										cornerRadius: "0",
										style: _this.style_Makingdevelo, __source: {
											fileName: _jsxFileName,
											lineNumber: 347
										}
									},
									dom(TextView, {
										id: _this.id("Improved_Maintainabi"),
										height: "50",
										width: "match_parent",
										text: _this.STR.Improved_Maintainabi59,
										textSize: FontSize.A_26,
										color: FontColor.A__FF000000,
										fontStyle: Font.AVENIR_MEDIUM,
										lineHeight: "42px",
										gravity: "left",
										style: _this.style_Improved_Maintainabi, __source: {
											fileName: _jsxFileName,
											lineNumber: 357
										}
									}),
									dom(TextView, {
										id: _this.id("Making_development_a"),
										height: "60",
										width: "match_parent",
										margin: "0,5,0,0",
										text: _this.STR.Making_development_a60,
										textSize: FontSize.A_20,
										color: FontColor.A__FF4A494A,
										fontStyle: Font.AVENIR_ROMAN,
										lineHeight: "28px",
										gravity: "left",
										style: _this.style_Making_development_a, __source: {
											fileName: _jsxFileName,
											lineNumber: 368
										}
									})
								)
							)
						)
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Presto_Ui"),
						height: "403",
						width: "match_parent",
						orientation: "horizontal",
						padding: "80,0,80,0",
						margin: "0,100,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Presto_Ui, __source: {
							fileName: _jsxFileName,
							lineNumber: 385
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Group_2"),
							height: "204",
							width: "300",
							orientation: "vertical",
							cornerRadius: "0",
							style: _this.style_Group_2, __source: {
								fileName: _jsxFileName,
								lineNumber: 395
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line100000000ø"),
							height: "2",
							width: "250",
							background: Color.A__FFD7D7D7,
							stroke: "3,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line100000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 402
							}
						}),
						dom(TextView, {
							id: _this.id("Presto_UI"),
							height: "50",
							width: "match_parent",
							margin: "0,31,0,0",
							text: _this.STR.Presto_UI61,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Presto_UI, __source: {
								fileName: _jsxFileName,
								lineNumber: 410
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Group7Quickstarts"),
								height: "31",
								width: "185",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_Group7Quickstarts, __source: {
									fileName: _jsxFileName,
									lineNumber: 422
								}
							},
							dom(ImageView, {
								id: _this.id("Group_7200000000ø"),
								height: "31",
								width: "30",
								imageUrl: "group732",
								style: _this.style_Group_7200000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 429
								}
							}),
							dom(TextView, {
								id: _this.id("Quick_Start300000000ø"),
								height: "30",
								width: "143",
								margin: "12,1,0,0",
								weight: "1",
								text: _this.STR.Quick_Start50,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Quick_Start300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 435
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("ViewcodeGithubmarks"),
								height: "30",
								width: "155",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_ViewcodeGithubmarks, __source: {
									fileName: _jsxFileName,
									lineNumber: 448
								}
							},
							dom(ImageView, {
								id: _this.id("GitHub_Mark400000000ø"),
								height: "30",
								width: "30",
								imageUrl: "githubmark31",
								style: _this.style_GitHub_Mark400000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 455
								}
							}),
							dom(TextView, {
								id: _this.id("View_Code500000000ø"),
								height: "30",
								width: "115",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.View_Code51,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_View_Code500000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 461
								}
							})
						)
					),
					dom(
						LinearLayout,
						{
							id: _this.id("Generateuico"),
							height: "370",
							width: "820",
							orientation: "vertical",
							gravity: "center_horizontal",
							margin: "0,33,0,0",
							weight: "1",
							cornerRadius: "0",
							style: _this.style_Generateuico, __source: {
								fileName: _jsxFileName,
								lineNumber: 475
							}
						},
						dom(TextView, {
							id: _this.id("Generate_UI_Code_dir"),
							height: "60",
							width: "match_parent",
							text: _this.STR.Generate_UI_Code_dir62,
							textSize: FontSize.A_20,
							color: FontColor.A__FF4A494A,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "30px",
							gravity: "left",
							style: _this.style_Generate_UI_Code_dir, __source: {
								fileName: _jsxFileName,
								lineNumber: 485
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("FullcontrolcSinglesource"),
								height: "115",
								width: "match_parent",
								orientation: "horizontal",
								margin: "0,50,0,0",
								style: _this.style_FullcontrolcSinglesource, __source: {
									fileName: _jsxFileName,
									lineNumber: 496
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("Singlesource"),
									height: "115",
									width: "360",
									orientation: "vertical",
									gravity: "center_horizontal",
									weight: "1",
									cornerRadius: "0",
									style: _this.style_Singlesource, __source: {
										fileName: _jsxFileName,
										lineNumber: 503
									}
								},
								dom(TextView, {
									id: _this.id("Single_Source_Code"),
									height: "50",
									width: "match_parent",
									text: _this.STR.Single_Source_Code63,
									textSize: FontSize.A_26,
									color: FontColor.A__FF000000,
									fontStyle: Font.AVENIR_MEDIUM,
									lineHeight: "42px",
									gravity: "left",
									style: _this.style_Single_Source_Code, __source: {
										fileName: _jsxFileName,
										lineNumber: 512
									}
								}),
								dom(TextView, {
									id: _this.id("Design_once_and_have"),
									height: "60",
									width: "match_parent",
									margin: "0,5,0,0",
									text: _this.STR.Design_once_and_have64,
									textSize: FontSize.A_20,
									color: FontColor.A__FF4A494A,
									fontStyle: Font.AVENIR_ROMAN,
									lineHeight: "28px",
									gravity: "left",
									style: _this.style_Design_once_and_have, __source: {
										fileName: _jsxFileName,
										lineNumber: 523
									}
								})
							),
							dom(
								LinearLayout,
								{
									id: _this.id("FullcontrolC"),
									height: "115",
									width: "360",
									orientation: "vertical",
									gravity: "center_horizontal",
									margin: "100,0,0,0",
									weight: "1",
									cornerRadius: "0",
									style: _this.style_FullcontrolC, __source: {
										fileName: _jsxFileName,
										lineNumber: 536
									}
								},
								dom(TextView, {
									id: _this.id("Full_Control"),
									height: "50",
									width: "match_parent",
									text: _this.STR.Full_Control65,
									textSize: FontSize.A_26,
									color: FontColor.A__FF000000,
									fontStyle: Font.AVENIR_MEDIUM,
									lineHeight: "42px",
									gravity: "left",
									style: _this.style_Full_Control, __source: {
										fileName: _jsxFileName,
										lineNumber: 546
									}
								}),
								dom(TextView, {
									id: _this.id("Change_the_UI_withou"),
									height: "60",
									width: "match_parent",
									margin: "0,5,0,0",
									text: _this.STR.Change_the_UI_withou66,
									textSize: FontSize.A_20,
									color: FontColor.A__FF4A494A,
									fontStyle: Font.AVENIR_ROMAN,
									lineHeight: "28px",
									gravity: "left",
									style: _this.style_Change_the_UI_withou, __source: {
										fileName: _jsxFileName,
										lineNumber: 557
									}
								})
							)
						),
						dom(
							LinearLayout,
							{
								id: _this.id("QuickdevelopSyntaxinspir"),
								height: "115",
								width: "match_parent",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_QuickdevelopSyntaxinspir, __source: {
									fileName: _jsxFileName,
									lineNumber: 571
								}
							},
							dom(
								LinearLayout,
								{
									id: _this.id("SyntaxInspir"),
									height: "115",
									width: "360",
									orientation: "vertical",
									gravity: "center_horizontal",
									weight: "1",
									cornerRadius: "0",
									style: _this.style_SyntaxInspir, __source: {
										fileName: _jsxFileName,
										lineNumber: 578
									}
								},
								dom(TextView, {
									id: _this.id("Syntax"),
									height: "50",
									width: "match_parent",
									text: _this.STR.Syntax67,
									textSize: FontSize.A_26,
									color: FontColor.A__FF000000,
									fontStyle: Font.AVENIR_MEDIUM,
									lineHeight: "42px",
									gravity: "left",
									style: _this.style_Syntax, __source: {
										fileName: _jsxFileName,
										lineNumber: 587
									}
								}),
								dom(TextView, {
									id: _this.id("Inspired_by_Android"),
									height: "60",
									width: "match_parent",
									margin: "0,5,0,0",
									text: _this.STR.Inspired_by_Android68,
									textSize: FontSize.A_20,
									color: FontColor.A__FF4A494A,
									fontStyle: Font.AVENIR_ROMAN,
									lineHeight: "28px",
									gravity: "left",
									style: _this.style_Inspired_by_Android, __source: {
										fileName: _jsxFileName,
										lineNumber: 598
									}
								})
							),
							dom(
								LinearLayout,
								{
									id: _this.id("Quickdevelop"),
									height: "115",
									width: "360",
									orientation: "vertical",
									gravity: "center_horizontal",
									margin: "100,0,0,0",
									weight: "1",
									cornerRadius: "0",
									style: _this.style_Quickdevelop, __source: {
										fileName: _jsxFileName,
										lineNumber: 611
									}
								},
								dom(TextView, {
									id: _this.id("Quick_Development"),
									height: "50",
									width: "match_parent",
									text: _this.STR.Quick_Development69,
									textSize: FontSize.A_26,
									color: FontColor.A__FF000000,
									fontStyle: Font.AVENIR_MEDIUM,
									lineHeight: "42px",
									gravity: "left",
									style: _this.style_Quick_Development, __source: {
										fileName: _jsxFileName,
										lineNumber: 621
									}
								}),
								dom(TextView, {
									id: _this.id("Auto_generate_UI_cod"),
									height: "60",
									width: "match_parent",
									margin: "0,5,0,0",
									text: _this.STR.Auto_generate_UI_cod70,
									textSize: FontSize.A_20,
									color: FontColor.A__FF4A494A,
									fontStyle: Font.AVENIR_ROMAN,
									lineHeight: "28px",
									gravity: "left",
									style: _this.style_Auto_generate_UI_cod, __source: {
										fileName: _jsxFileName,
										lineNumber: 632
									}
								})
							)
						)
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Subscribe"),
						height: "262",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						margin: "0,100,0,0",
						padding: "80,0,80,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Subscribe, __source: {
							fileName: _jsxFileName,
							lineNumber: 648
						}
					},
					dom(LinearLayout, {
						id: _this.id("Line_2"),
						height: "2",
						width: "match_parent",
						background: Color.A__FFD7D7D7,
						stroke: "3,#ff0000",
						cornerRadius: "0",
						style: _this.style_Line_2, __source: {
							fileName: _jsxFileName,
							lineNumber: 659
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group_3"),
							height: "142",
							width: "416",
							orientation: "horizontal",
							gravity: "center",
							margin: "0,38,0,0",
							style: _this.style_Group_3, __source: {
								fileName: _jsxFileName,
								lineNumber: 667
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Group_4"),
								height: "match_parent",
								width: "match_parent",
								orientation: "vertical",
								style: _this.style_Group_4, __source: {
									fileName: _jsxFileName,
									lineNumber: 675
								}
							},
							dom(TextView, {
								id: _this.id("Get_the_latest_Prest"),
								height: "25",
								width: "match_parent",
								text: _this.STR.Get_the_latest_Prest71,
								textSize: FontSize.A_18,
								color: FontColor.A__FF4A494A,
								fontStyle: Font.AVENIR_ROMAN,
								gravity: "left",
								style: _this.style_Get_the_latest_Prest, __source: {
									fileName: _jsxFileName,
									lineNumber: 681
								}
							}),
							dom(
								LinearLayout,
								{
									id: _this.id("Group"),
									height: "36",
									width: "350",
									orientation: "vertical",
									margin: "0,31,0,0",
									style: _this.style_Group, __source: {
										fileName: _jsxFileName,
										lineNumber: 691
									}
								},
								dom(
									LinearLayout,
									{
										id: _this.id("YouremailaddressNoun_1358889_cc"),
										height: "25",
										width: "match_parent",
										orientation: "horizontal",
										style: _this.style_YouremailaddressNoun_1358889_cc, __source: {
											fileName: _jsxFileName,
											lineNumber: 698
										}
									},
									dom(ImageView, {
										id: _this.id("Noun_1358889_cc"),
										height: "20",
										width: "34",
										margin: "0,4,0,0",
										imageUrl: "noun_1358889_cc30",
										style: _this.style_Noun_1358889_cc, __source: {
											fileName: _jsxFileName,
											lineNumber: 704
										}
									}),
									dom(EditText, {
										id: _this.id("Your_email_address"),
										height: "25",
										width: "297",
										margin: "18,0,0,0",
										weight: "1",
										textSize: FontSize.A_18,
										color: FontColor.A__FF000000,
										fontStyle: Font.AVENIR_ROMAN,
										gravity: "left",
										hint: _this.STR.Your_email_address72,
										background: "#ffffff",
										padding: "0,0,0,0",
										style: _this.style_Your_email_address, __source: {
											fileName: _jsxFileName,
											lineNumber: 711
										}
									})
								),
								dom(LinearLayout, {
									id: _this.id("Line_3"),
									height: "2",
									width: "match_parent",
									background: Color.A__FFD7D7D7,
									stroke: "1,#ff0000",
									margin: "0,9,0,0",
									cornerRadius: "0",
									style: _this.style_Line_3, __source: {
										fileName: _jsxFileName,
										lineNumber: 726
									}
								})
							),
							dom(TextView, {
								id: _this.id("Subscribe600000000ø"),
								height: "30",
								width: "101",
								margin: "0,20,0,0",
								text: _this.STR.Subscribe73,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Subscribe600000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 736
								}
							})
						)
					),
					dom(LinearLayout, {
						id: _this.id("Rectangle"),
						height: "63",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						margin: "0,17,0,0",
						cornerRadius: "0",
						style: _this.style_Rectangle, __source: {
							fileName: _jsxFileName,
							lineNumber: 749
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return Presto;
}(Controller);

;

module.exports = Presto;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var __this = void 0;

var Presto = function (_View) {
	_inherits(Presto, _View);

	function Presto(props, children, state) {
		_classCallCheck(this, Presto);

		var _this = _possibleConstructorReturn(this, (Presto.__proto__ || Object.getPrototypeOf(Presto)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		__this = _this;

		_this.setIds(['Content', 'Your_email_address', 'Subscribe600000000ø', 'Get_the_latest_Prest']);

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};

		_this.style_Group7Quickstart = {
			onClick: _this.onClickQuickStartFlow.bind(_this)
		};

		_this.style_ViewcodeGithubmark = {
			onClick: _this.onClickViewCodeFlow.bind(_this)
		};

		_this.style_Group7Quickstarts = {
			onClick: _this.onClickQuickStartUI.bind(_this)
		};

		_this.style_ViewcodeGithubmarks = {
			onClick: _this.onClickViewCodeUI.bind(_this)
		};

		_this.style_Subscribe600000000ø = {
			onClick: _this.onClickSubscribe.bind(_this),
			width: "150"
		};

		_this.style_Your_email_address = {
			onChange: _this.onChangeEmail.bind(_this)
		};

		_this.subscribed = false;
		return _this;
	}

	_createClass(Presto, [{
		key: 'onChangeEmail',
		value: function onChangeEmail(data) {
			this.email = data;
		}
	}, {
		key: 'onClickHome',
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, '57', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: 'onClickForum',
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: 'onClickQuickStartFlow',
		value: function onClickQuickStartFlow() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/install.html", '_blank');
		}
	}, {
		key: 'onClickViewCodeFlow',
		value: function onClickViewCodeFlow() {
			window.open("https://github.com/juspay/purescript-presto", '_blank');
		}
	}, {
		key: 'onClickQuickStartUI',
		value: function onClickQuickStartUI() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/presto-ui/", '_blank');
		}
	}, {
		key: 'onClickViewCodeUI',
		value: function onClickViewCodeUI() {
			window.open("https://github.com/juspay/presto-ui", '_blank');
		}
	}, {
		key: 'onClickSubscribe',
		value: function onClickSubscribe() {
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.responseText);
						if (response.status == "SUCCESS") {
							var cmd = __this.cmd({ id: __this.idSet.Your_email_address, text: "" });
							Android.runInUI(cmd, null, '94', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Subscribe600000000ø, text: "Subscribed", color: "#AA000000", clickable: "false" });
							Android.runInUI(cmd, null, '96', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "We will keep you posted." });
							Android.runInUI(cmd, null, '98', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
							__this.email = "0";
						}
					} else if (this.readyState == 4 && this.status == 500) {
						var _response = JSON.parse(this.responseText);
						if (_response.status == "FAILURE" && _response.errorCode == 2) {
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Sorry, Try Again." });
							Android.runInUI(cmd, null, '105', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
						}
					} else if (this.readyState == 4 && this.status == 400) {
						var _response2 = JSON.parse(this.responseText);
						if (_response2.status == "FAILURE" && _response2.errorCode == 1) {
							var cmd = __this.cmd({ id: __this.idSet.Your_email_address, text: "" });
							Android.runInUI(cmd, null, '111', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "This email is already registered." });
							Android.runInUI(cmd, null, '113', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
						}
					}
				};

				xhttp.onloadend = function () {
					if (xhttp.status != 200) {
						var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Oops, unable to reach our server" });
						Android.runInUI(cmd, null, '121', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
					}
				};

				xhttp.open("GET", "/insertEmail?email=" + this.email, true);
				xhttp.send();
			} else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) && this.email != "0") {
				var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Not a Valid E-mail..." });
				Android.runInUI(cmd, null, '130', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainPrestojs');
			}
		}
	}]);

	return Presto;
}(View);

module.exports = Presto;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Main/Home2.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(23);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var Home2 = function (_Controller) {
	_inherits(Home2, _Controller);

	function Home2(props, children, state) {
		_classCallCheck(this, Home2);

		var _this = _possibleConstructorReturn(this, (Home2.__proto__ || Object.getPrototypeOf(Home2)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("HeaderGroup"),
						height: "170",
						width: "match_parent",
						orientation: "horizontal",
						gravity: "center_vertical",
						padding: "100,60,100,60",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_HeaderGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(ImageView, {
						id: _this.id("JuspayUniveristyLogo"),
						height: "40",
						width: "333",
						imageUrl: "juspayuniveristylogo48",
						style: _this.style_JuspayUniveristyLogo, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("NavBarGroup"),
							height: "50",
							width: "518",
							orientation: "horizontal",
							margin: "389,0,0,0",
							weight: "1",
							style: _this.style_NavBarGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 55
							}
						},
						dom(TextView, {
							id: _this.id("RegisterText"),
							height: "33",
							width: "92",
							margin: "0,9,0,0",
							text: _this.STR.Register1,
							textSize: FontSize.A_24,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "center",
							style: _this.style_RegisterText, __source: {
								fileName: _jsxFileName,
								lineNumber: 63
							}
						}),
						dom(TextView, {
							id: _this.id("ForumText"),
							height: "33",
							width: "72",
							margin: "76,9,0,0",
							text: _this.STR.Forum2,
							textSize: FontSize.A_24,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.AVENIR_ROMAN,
							gravity: "center",
							style: _this.style_ForumText, __source: {
								fileName: _jsxFileName,
								lineNumber: 74
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("LetsStartGroup"),
								height: "50",
								width: "200",
								orientation: "vertical",
								padding: "0,9,0,8",
								margin: "78,0,0,0",
								weight: "1",
								background: Color.A__FFEE0000,
								cornerRadius: "4",
								style: _this.style_LetsStartGroup, __source: {
									fileName: _jsxFileName,
									lineNumber: 85
								}
							},
							dom(TextView, {
								id: _this.id("LetsStartText"),
								height: "33",
								width: "match_parent",
								text: _this.STR.LetsStartText74,
								textSize: FontSize.A_24,
								color: FontColor.A__FFFFFFFF,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "center",
								style: _this.style_LetsStartText, __source: {
									fileName: _jsxFileName,
									lineNumber: 96
								}
							})
						)
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("HeroGroup"),
						height: "730",
						width: "match_parent",
						orientation: "horizontal",
						padding: "85,56,85,110",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_HeroGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 109
						}
					},
					dom(ImageView, {
						id: _this.id("HeroVideoGroup"),
						height: "564",
						width: "569",
						imageUrl: "herovideogroup47",
						style: _this.style_HeroVideoGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 118
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("HeroTextGroup"),
							height: "366",
							width: "635",
							orientation: "vertical",
							margin: "66,83,0,0",
							weight: "1",
							style: _this.style_HeroTextGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 124
							}
						},
						dom(TextView, {
							id: _this.id("Hero_Epic"),
							height: "144",
							width: "match_parent",
							text: _this.STR.Hero_Epic75,
							textSize: FontSize.A_60,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "72px",
							gravity: "left",
							style: _this.style_Hero_Epic, __source: {
								fileName: _jsxFileName,
								lineNumber: 132
							}
						}),
						dom(TextView, {
							id: _this.id("Section_body"),
							height: "128",
							width: "match_parent",
							margin: "0,30,0,0",
							text: _this.STR.Section_body76,
							textSize: FontSize.A_18,
							color: FontColor.A__FF3A3A3A,
							fontStyle: Font.ROBOTOMONO_REGULAR,
							lineHeight: "32px",
							gravity: "left",
							style: _this.style_Section_body, __source: {
								fileName: _jsxFileName,
								lineNumber: 143
							}
						}),
						dom(TextView, {
							id: _this.id("Jump_in___get_starte"),
							height: "32",
							width: "240",
							margin: "0,32,0,0",
							text: _this.STR.Jump_in___get_starte77,
							textSize: FontSize.A_18,
							color: FontColor.A__FFEE0000,
							fontStyle: Font.ROBOTOMONO_BOLD,
							lineHeight: "32px",
							gravity: "left",
							style: _this.style_Jump_in___get_starte, __source: {
								fileName: _jsxFileName,
								lineNumber: 155
							}
						})
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("PrestoSectionGroup"),
						height: "900",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "0,109,0,0",
						background: Color.A__19BBBBBB,
						cornerRadius: "0",
						style: _this.style_PrestoSectionGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 169
						}
					},
					dom(TextView, {
						id: _this.id("PrestoSectionText"),
						height: "55",
						width: "match_parent",
						text: _this.STR.PrestoSectionText78,
						textSize: FontSize.A_40,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						gravity: "center",
						style: _this.style_PrestoSectionText, __source: {
							fileName: _jsxFileName,
							lineNumber: 179
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("BrandsGroup"),
							height: "93",
							width: "1196",
							orientation: "horizontal",
							padding: "38,0,0,0",
							margin: "0,109,0,0",
							background: Color.A__00FFFFFF,
							cornerRadius: "0",
							style: _this.style_BrandsGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 189
							}
						},
						dom(ImageView, {
							id: _this.id("BhimGroup"),
							height: "93",
							width: "221",
							imageUrl: "bhimgroup41",
							style: _this.style_BhimGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 199
							}
						}),
						dom(ImageView, {
							id: _this.id("JuspaySafeGroup"),
							height: "93",
							width: "244",
							margin: "217,0,0,0",
							imageUrl: "juspaysafegroup43",
							style: _this.style_JuspaySafeGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 205
							}
						}),
						dom(LinearLayout, {
							id: _this.id("Space"),
							weight: "1",
							style: _this.style_Space, __source: {
								fileName: _jsxFileName,
								lineNumber: 212
							}
						}),
						dom(ImageView, {
							id: _this.id("JusPayFuelGroup"),
							height: "93",
							width: "261",
							imageUrl: "juspayfuelgroup45",
							style: _this.style_JusPayFuelGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 216
							}
						})
					),
					dom(TextView, {
						id: _this.id("PrestoSectionHelpText"),
						height: "256",
						width: "match_parent",
						margin: "0,100,0,0",
						text: _this.STR.PrestoSectionHelpText79,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.ROBOTOMONO_REGULAR,
						lineHeight: "32px",
						gravity: "center",
						style: _this.style_PrestoSectionHelpText, __source: {
							fileName: _jsxFileName,
							lineNumber: 223
						}
					}),
					dom(TextView, {
						id: _this.id("LearnPrestoText"),
						height: "24",
						width: "match_parent",
						margin: "0,50,0,0",
						text: _this.STR.LearnPrestoText80,
						textSize: FontSize.A_18,
						color: FontColor.A__FFED0000,
						fontStyle: Font.ROBOTOMONO_BOLD,
						gravity: "center",
						style: _this.style_LearnPrestoText, __source: {
							fileName: _jsxFileName,
							lineNumber: 235
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("WhatCourseGroup"),
						height: "777",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "0,100,0,100",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_WhatCourseGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 247
						}
					},
					dom(TextView, {
						id: _this.id("WhatCourseText"),
						height: "72",
						width: "match_parent",
						text: _this.STR.WhatCourseText81,
						textSize: FontSize.A_40,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "72px",
						gravity: "center",
						style: _this.style_WhatCourseText, __source: {
							fileName: _jsxFileName,
							lineNumber: 257
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Space100000000ø"),
						weight: "1",
						style: _this.style_Space100000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 268
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("CourseGroup"),
							height: "445",
							width: "1200",
							orientation: "horizontal",
							style: _this.style_CourseGroup, __source: {
								fileName: _jsxFileName,
								lineNumber: 272
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("CurriculumGroup"),
								height: "445",
								width: "500",
								orientation: "vertical",
								weight: "1",
								background: Color.A__FFFFFFFF,
								cornerRadius: "0",
								style: _this.style_CurriculumGroup, __source: {
									fileName: _jsxFileName,
									lineNumber: 278
								}
							},
							dom(TextView, {
								id: _this.id("CurriculumText"),
								height: "33",
								width: "match_parent",
								text: _this.STR.CurriculumText82,
								textSize: FontSize.A_24,
								color: FontColor.A__FFED0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_CurriculumText, __source: {
									fileName: _jsxFileName,
									lineNumber: 287
								}
							}),
							dom(ImageView, {
								id: _this.id("Open_book"),
								height: "120",
								width: "162",
								margin: "0,40,0,0",
								imageUrl: "openbook39",
								style: _this.style_Open_book, __source: {
									fileName: _jsxFileName,
									lineNumber: 297
								}
							}),
							dom(LinearLayout, {
								id: _this.id("Space200000000ø"),
								weight: "1",
								style: _this.style_Space200000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 304
								}
							}),
							dom(TextView, {
								id: _this.id("CurriculumHelpText"),
								height: "192",
								width: "match_parent",
								text: _this.STR.CurriculumHelpText83,
								textSize: FontSize.A_18,
								color: FontColor.A__FF3A3A3A,
								fontStyle: Font.ROBOTOMONO_REGULAR,
								lineHeight: "32px",
								gravity: "left",
								style: _this.style_CurriculumHelpText, __source: {
									fileName: _jsxFileName,
									lineNumber: 308
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("ProjectGroup"),
								height: "349",
								width: "500",
								orientation: "vertical",
								margin: "200,0,0,0",
								weight: "1",
								background: Color.A__FFFFFFFF,
								cornerRadius: "0",
								style: _this.style_ProjectGroup, __source: {
									fileName: _jsxFileName,
									lineNumber: 320
								}
							},
							dom(TextView, {
								id: _this.id("ProjectText"),
								height: "33",
								width: "match_parent",
								text: _this.STR.Project31,
								textSize: FontSize.A_24,
								color: FontColor.A__FFED0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_ProjectText, __source: {
									fileName: _jsxFileName,
									lineNumber: 330
								}
							}),
							dom(ImageView, {
								id: _this.id("School_material"),
								height: "120",
								width: "120",
								margin: "0,40,0,0",
								imageUrl: "schoolmaterial40",
								style: _this.style_School_material, __source: {
									fileName: _jsxFileName,
									lineNumber: 340
								}
							}),
							dom(LinearLayout, {
								id: _this.id("Space300000000ø"),
								weight: "1",
								style: _this.style_Space300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 347
								}
							}),
							dom(TextView, {
								id: _this.id("ProjectHelpText"),
								height: "96",
								width: "match_parent",
								text: _this.STR.ProjectHelpText84,
								textSize: FontSize.A_18,
								color: FontColor.A__FF3A3A3A,
								fontStyle: Font.ROBOTOMONO_REGULAR,
								lineHeight: "32px",
								gravity: "left",
								style: _this.style_ProjectHelpText, __source: {
									fileName: _jsxFileName,
									lineNumber: 351
								}
							})
						)
					)
				),
				dom(
					LinearLayout,
					{
						id: _this.id("FooterGroup"),
						height: "423",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_FooterGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 365
						}
					},
					dom(
						LinearLayout,
						{
							id: _this.id("Footer"),
							height: "270",
							width: "1240",
							orientation: "horizontal",
							padding: "100,95,100,95",
							background: Color.A__FFEE0000,
							cornerRadius: "0",
							style: _this.style_Footer, __source: {
								fileName: _jsxFileName,
								lineNumber: 374
							}
						},
						dom(TextView, {
							id: _this.id("SoundsExcitingText"),
							height: "80",
							width: "580",
							weight: "1",
							text: _this.STR.SoundsExcitingText85,
							textSize: FontSize.A_24,
							color: FontColor.A__FFFFFFFF,
							fontStyle: Font.ROBOTOMONO_REGULAR,
							lineHeight: "40px",
							gravity: "left",
							style: _this.style_SoundsExcitingText, __source: {
								fileName: _jsxFileName,
								lineNumber: 383
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("LetsStartFooterGroup"),
								height: "60",
								width: "240",
								orientation: "vertical",
								padding: "48,10,0,9",
								margin: "220,9,0,0",
								background: Color.A__FFFFFFFF,
								cornerRadius: "4",
								style: _this.style_LetsStartFooterGroup, __source: {
									fileName: _jsxFileName,
									lineNumber: 395
								}
							},
							dom(TextView, {
								id: _this.id("LetsStartFooterText"),
								height: "41",
								width: "144",
								text: _this.STR.LetsStartText74,
								textSize: FontSize.A_30,
								color: FontColor.A__FFED0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "center",
								style: _this.style_LetsStartFooterText, __source: {
									fileName: _jsxFileName,
									lineNumber: 405
								}
							})
						)
					),
					dom(LinearLayout, {
						id: _this.id("LastSpace"),
						height: "153",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_LastSpace, __source: {
							fileName: _jsxFileName,
							lineNumber: 417
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return Home2;
}(Controller);

;

module.exports = Home2;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var Home2 = function (_View) {
	_inherits(Home2, _View);

	function Home2(props, children, state) {
		_classCallCheck(this, Home2);

		var _this = _possibleConstructorReturn(this, (Home2.__proto__ || Object.getPrototypeOf(Home2)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		document.title = "Juspay University";

		var link = document.createElement('meta');
		link.name = "description";
		link.content = "We want to enable you to become a Product Maker. Join us to learn Functional Programming, Category Theory and Product Design. Start creating scalable, real-world applications while still studying.";
		document.getElementsByTagName('head')[0].appendChild(link);

		_this.setIds(['Content']);

		_this.style_RegisterText = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_ForumText = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_LetsStartGroup = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_Jump_in___get_starte = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_LearnPrestoText = {
			onClick: _this.onClickPresto.bind(_this)
		};

		_this.style_LetsStartFooterGroup = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_HeroVideoGroup = {
			onClick: _this.onClickVideo.bind(_this)
		};
		return _this;
	}

	_createClass(Home2, [{
		key: "onClickLetsStart",
		value: function onClickLetsStart() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "49", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainHomejs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileSFP" });else window.__duiShowScreen(null, { screen: "SFP" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickPresto",
		value: function onClickPresto() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "68", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMainHomejs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobilePresto" });else window.__duiShowScreen(null, { screen: "Presto" });
		}
	}, {
		key: "onClickVideo",
		value: function onClickVideo() {
			window.open("https://www.youtube.com/watch?v=ffzzXQI_i5s&feature=youtu.be", '_blank');
		}
	}]);

	return Home2;
}(View);

module.exports = Home2;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Mobile/MobileHome.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(25);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var MobileHome = function (_Controller) {
	_inherits(MobileHome, _Controller);

	function MobileHome(props, children, state) {
		_classCallCheck(this, MobileHome);

		var _this = _possibleConstructorReturn(this, (MobileHome.__proto__ || Object.getPrototypeOf(MobileHome)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "226",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "30,31,30,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "33",
						width: "match_parent",
						margin: "10,0,10,0",
						imageUrl: "group549",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(TextView, {
						id: _this.id("Register"),
						height: "25",
						width: "match_parent",
						margin: "0,44,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Register, __source: {
							fileName: _jsxFileName,
							lineNumber: 56
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 67
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Group_2"),
						height: "1274",
						width: "300",
						orientation: "vertical",
						margin: "0,10,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Group_2, __source: {
							fileName: _jsxFileName,
							lineNumber: 79
						}
					},
					dom(ImageView, {
						id: _this.id("Hero"),
						height: "160",
						width: "match_parent",
						margin: "10,0,0,0",
						imageUrl: "hero51",
						style: _this.style_Hero, __source: {
							fileName: _jsxFileName,
							lineNumber: 88
						}
					}),
					dom(TextView, {
						id: _this.id("Build_real_products"),
						height: "80",
						width: "match_parent",
						margin: "0,35,0,0",
						text: _this.STR.Build_real_products4,
						textSize: FontSize.A_32,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_Build_real_products, __source: {
							fileName: _jsxFileName,
							lineNumber: 95
						}
					}),
					dom(TextView, {
						id: _this.id("In_the_process_of_cr"),
						height: "210",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.In_the_process_of_cr5,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_BOOK,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_In_the_process_of_cr, __source: {
							fileName: _jsxFileName,
							lineNumber: 107
						}
					}),
					dom(TextView, {
						id: _this.id("Story_of_1B_txns"),
						height: "42",
						width: "match_parent",
						margin: "0,33,0,0",
						text: _this.STR.Story_of_1B_txns6,
						textSize: FontSize.A_32,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Story_of_1B_txns, __source: {
							fileName: _jsxFileName,
							lineNumber: 119
						}
					}),
					dom(TextView, {
						id: _this.id("Our_engineering_adva"),
						height: "75",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Our_engineering_adva7,
						textSize: FontSize.A_16,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "24px",
						gravity: "left",
						style: _this.style_Our_engineering_adva, __source: {
							fileName: _jsxFileName,
							lineNumber: 131
						}
					}),
					dom(TextView, {
						id: _this.id("Know_how"),
						height: "25",
						width: "102",
						margin: "0,20,0,0",
						text: _this.STR.Know_how8,
						textSize: FontSize.A_18,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Know_how, __source: {
							fileName: _jsxFileName,
							lineNumber: 143
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Line"),
						height: "3",
						width: "match_parent",
						background: Color.A__FFD7D7D7,
						stroke: "4,#ff0000",
						margin: "0,30,0,0",
						cornerRadius: "0",
						style: _this.style_Line, __source: {
							fileName: _jsxFileName,
							lineNumber: 154
						}
					}),
					dom(TextView, {
						id: _this.id("School_of_FP"),
						height: "42",
						width: "match_parent",
						margin: "0,43,0,0",
						text: _this.STR.School_of_FP9,
						textSize: FontSize.A_32,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_School_of_FP, __source: {
							fileName: _jsxFileName,
							lineNumber: 163
						}
					}),
					dom(TextView, {
						id: _this.id("Breaking_the_myth_th"),
						height: "75",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Breaking_the_myth_th10,
						textSize: FontSize.A_16,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "24px",
						gravity: "left",
						style: _this.style_Breaking_the_myth_th, __source: {
							fileName: _jsxFileName,
							lineNumber: 175
						}
					}),
					dom(TextView, {
						id: _this.id("Get_Started"),
						height: "25",
						width: "103",
						margin: "0,20,0,0",
						text: _this.STR.Get_Started3,
						textSize: FontSize.A_18,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Get_Started, __source: {
							fileName: _jsxFileName,
							lineNumber: 187
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Line100000000ø"),
						height: "3",
						width: "match_parent",
						background: Color.A__FFD7D7D7,
						stroke: "4,#ff0000",
						margin: "0,30,0,0",
						cornerRadius: "0",
						style: _this.style_Line100000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 198
						}
					}),
					dom(TextView, {
						id: _this.id("Foundation"),
						height: "42",
						width: "match_parent",
						margin: "0,43,0,0",
						text: _this.STR.Foundation11,
						textSize: FontSize.A_32,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Foundation, __source: {
							fileName: _jsxFileName,
							lineNumber: 207
						}
					}),
					dom(TextView, {
						id: _this.id("Derived_from_the_mat"),
						height: "75",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Derived_from_the_mat12,
						textSize: FontSize.A_16,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "24px",
						gravity: "left",
						style: _this.style_Derived_from_the_mat, __source: {
							fileName: _jsxFileName,
							lineNumber: 219
						}
					}),
					dom(TextView, {
						id: _this.id("Coming_soon"),
						height: "25",
						width: "119",
						margin: "0,20,0,0",
						text: _this.STR.Coming_soon13,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Coming_soon, __source: {
							fileName: _jsxFileName,
							lineNumber: 231
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Rectangle"),
						height: "66",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Rectangle, __source: {
							fileName: _jsxFileName,
							lineNumber: 242
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return MobileHome;
}(Controller);

;

module.exports = MobileHome;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var MobileHome = function (_View) {
	_inherits(MobileHome, _View);

	function MobileHome(props, children, state) {
		_classCallCheck(this, MobileHome);

		var _this = _possibleConstructorReturn(this, (MobileHome.__proto__ || Object.getPrototypeOf(MobileHome)).call(this, props, children, state));

		_this.shouldCacheScreen = false;
		return _this;
	}

	return MobileHome;
}(View);

module.exports = MobileHome;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Mobile/MobileSFP.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(27);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var MobileSFP = function (_Controller) {
	_inherits(MobileSFP, _Controller);

	function MobileSFP(props, children, state) {
		_classCallCheck(this, MobileSFP);

		var _this = _possibleConstructorReturn(this, (MobileSFP.__proto__ || Object.getPrototypeOf(MobileSFP)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "226",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "30,31,30,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "33",
						width: "match_parent",
						margin: "10,0,10,0",
						imageUrl: "group565",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(TextView, {
						id: _this.id("Register"),
						height: "25",
						width: "match_parent",
						margin: "0,44,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Register, __source: {
							fileName: _jsxFileName,
							lineNumber: 56
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 67
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Group_4"),
						height: "1985",
						width: "300",
						orientation: "vertical",
						margin: "0,20,0,0",
						cornerRadius: "0",
						style: _this.style_Group_4, __source: {
							fileName: _jsxFileName,
							lineNumber: 79
						}
					},
					dom(TextView, {
						id: _this.id("School_of_Functional"),
						height: "120",
						width: "match_parent",
						text: _this.STR.School_of_Functional14,
						textSize: FontSize.A_32,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_School_of_Functional, __source: {
							fileName: _jsxFileName,
							lineNumber: 87
						}
					}),
					dom(ImageView, {
						id: _this.id("Group_3_Copy"),
						height: "317",
						width: "252",
						margin: "0,50,0,0",
						imageUrl: "group3copy67",
						style: _this.style_Group_3_Copy, __source: {
							fileName: _jsxFileName,
							lineNumber: 98
						}
					}),
					dom(TextView, {
						id: _this.id("We_d_like_to_see_stu"),
						height: "210",
						width: "match_parent",
						margin: "0,50,0,0",
						text: _this.STR.We_d_like_to_see_stu15,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_We_d_like_to_see_stu, __source: {
							fileName: _jsxFileName,
							lineNumber: 105
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Course"),
							height: "153",
							width: "match_parent",
							orientation: "vertical",
							margin: "0,30,0,0",
							cornerRadius: "0",
							style: _this.style_Course, __source: {
								fileName: _jsxFileName,
								lineNumber: 117
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line_2"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "4,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line_2, __source: {
								fileName: _jsxFileName,
								lineNumber: 125
							}
						}),
						dom(TextView, {
							id: _this.id("Course100000000ø"),
							height: "50",
							width: "171",
							margin: "0,40,0,0",
							text: _this.STR.Course16,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Course100000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 133
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Takethecours"),
								height: "31",
								width: "220",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_Takethecours, __source: {
									fileName: _jsxFileName,
									lineNumber: 145
								}
							},
							dom(ImageView, {
								id: _this.id("Group_7"),
								height: "31",
								width: "30",
								imageUrl: "group768",
								style: _this.style_Group_7, __source: {
									fileName: _jsxFileName,
									lineNumber: 152
								}
							}),
							dom(TextView, {
								id: _this.id("Take_the_course"),
								height: "30",
								width: "180",
								margin: "10,1,0,0",
								weight: "1",
								text: _this.STR.Take_the_course17,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Take_the_course, __source: {
									fileName: _jsxFileName,
									lineNumber: 158
								}
							})
						)
					),
					dom(TextView, {
						id: _this.id("The_course_provides"),
						height: "90",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.The_course_provides18,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_The_course_provides, __source: {
							fileName: _jsxFileName,
							lineNumber: 172
						}
					}),
					dom(TextView, {
						id: _this.id("Basics_of_Functional"),
						height: "90",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Basics_of_Functional19,
						textSize: FontSize.A_30,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Basics_of_Functional, __source: {
							fileName: _jsxFileName,
							lineNumber: 184
						}
					}),
					dom(TextView, {
						id: _this.id("A_simplified_path_to"),
						height: "120",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.A_simplified_path_to20,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_A_simplified_path_to, __source: {
							fileName: _jsxFileName,
							lineNumber: 196
						}
					}),
					dom(TextView, {
						id: _this.id("Presto_"),
						height: "50",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Presto_21,
						textSize: FontSize.A_30,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Presto_, __source: {
							fileName: _jsxFileName,
							lineNumber: 208
						}
					}),
					dom(TextView, {
						id: _this.id("Presto_is_an_app_dev"),
						height: "210",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Presto_is_an_app_dev22,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Presto_is_an_app_dev, __source: {
							fileName: _jsxFileName,
							lineNumber: 220
						}
					}),
					dom(TextView, {
						id: _this.id("Discover_Presto"),
						height: "30",
						width: "165",
						margin: "0,10,0,0",
						text: "What is Presto?",
						textSize: FontSize.A_22,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Discover_Presto, __source: {
							fileName: _jsxFileName,
							lineNumber: 232
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Internship"),
							height: "142",
							width: "match_parent",
							orientation: "vertical",
							margin: "0,50,0,0",
							cornerRadius: "0",
							style: _this.style_Internship, __source: {
								fileName: _jsxFileName,
								lineNumber: 243
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line_2200000000ø"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "4,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line_2200000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 251
							}
						}),
						dom(TextView, {
							id: _this.id("Internship300000000ø"),
							height: "50",
							width: "230",
							margin: "0,30,0,0",
							text: _this.STR.Internship24,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Internship300000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 259
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("KnowmoreGroup10"),
								height: "30",
								width: "190",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_KnowmoreGroup10, __source: {
									fileName: _jsxFileName,
									lineNumber: 271
								}
							},
							dom(ImageView, {
								id: _this.id("Group_10"),
								height: "30",
								width: "30",
								imageUrl: "group1069",
								style: _this.style_Group_10, __source: {
									fileName: _jsxFileName,
									lineNumber: 278
								}
							}),
							dom(TextView, {
								id: _this.id("Know_more"),
								height: "30",
								width: "150",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.Know_more25,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Know_more, __source: {
									fileName: _jsxFileName,
									lineNumber: 284
								}
							})
						)
					),
					dom(TextView, {
						id: _this.id("Learn_the_basics_of"),
						height: "60",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Learn_the_basics_of26,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Learn_the_basics_of, __source: {
							fileName: _jsxFileName,
							lineNumber: 298
						}
					}),
					dom(TextView, {
						id: _this.id("Learn_Presto"),
						height: "30",
						width: "match_parent",
						margin: "0,13,0,0",
						text: _this.STR.Learn_Presto27,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Learn_Presto, __source: {
							fileName: _jsxFileName,
							lineNumber: 310
						}
					}),
					dom(TextView, {
						id: _this.id("Apply_for_an_interns"),
						height: "30",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Apply_for_an_interns28,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Apply_for_an_interns, __source: {
							fileName: _jsxFileName,
							lineNumber: 322
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return MobileSFP;
}(Controller);

;

module.exports = MobileSFP;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var MobileSFP = function (_View) {
	_inherits(MobileSFP, _View);

	function MobileSFP(props, children, state) {
		_classCallCheck(this, MobileSFP);

		var _this = _possibleConstructorReturn(this, (MobileSFP.__proto__ || Object.getPrototypeOf(MobileSFP)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};

		_this.style_Takethecours = {
			onClick: _this.onClickTake.bind(_this)
		};

		_this.style_KnowmoreGroup10 = {
			onClick: _this.onClickKnow.bind(_this)
		};

		_this.style_Discover_Presto = {
			onClick: _this.onClickPresto.bind(_this)
		};
		return _this;
	}

	_createClass(MobileSFP, [{
		key: "onClickHome",
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "38", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobileSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickTake",
		value: function onClickTake() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/", '_blank');
		}
	}, {
		key: "onClickPresto",
		value: function onClickPresto() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "61", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobileSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobilePresto" });else window.__duiShowScreen(null, { screen: "Presto" });
		}
	}, {
		key: "onClickKnow",
		value: function onClickKnow() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "72", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobileSFPjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileProject" });else window.__duiShowScreen(null, { screen: "Project" });
		}
	}]);

	return MobileSFP;
}(View);

module.exports = MobileSFP;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Mobile/MobileProject.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(29);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var MobileProject = function (_Controller) {
	_inherits(MobileProject, _Controller);

	function MobileProject(props, children, state) {
		_classCallCheck(this, MobileProject);

		var _this = _possibleConstructorReturn(this, (MobileProject.__proto__ || Object.getPrototypeOf(MobileProject)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "226",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "30,31,30,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "33",
						width: "match_parent",
						margin: "10,0,10,0",
						imageUrl: "group570",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(TextView, {
						id: _this.id("Register"),
						height: "25",
						width: "match_parent",
						margin: "0,44,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Register, __source: {
							fileName: _jsxFileName,
							lineNumber: 56
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 67
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Group"),
						height: "1954",
						width: "match_parent",
						orientation: "vertical",
						margin: "29,20,29,0",
						cornerRadius: "0",
						style: _this.style_Group, __source: {
							fileName: _jsxFileName,
							lineNumber: 79
						}
					},
					dom(TextView, {
						id: _this.id("Internship___Juspay"),
						height: "80",
						width: "match_parent",
						margin: "2,0,0,0",
						text: _this.STR.Internship___Juspay29,
						textSize: FontSize.A_32,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_Internship___Juspay, __source: {
							fileName: _jsxFileName,
							lineNumber: 87
						}
					}),
					dom(TextView, {
						id: _this.id("While_learning_to_cr"),
						height: "270",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.While_learning_to_cr87,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_While_learning_to_cr, __source: {
							fileName: _jsxFileName,
							lineNumber: 99
						}
					}),
					dom(TextView, {
						id: _this.id("Project"),
						height: "33",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.Project31,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						gravity: "left",
						style: _this.style_Project, __source: {
							fileName: _jsxFileName,
							lineNumber: 111
						}
					}),
					dom(TextView, {
						id: _this.id("Overview"),
						height: "25",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.Overview32,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Overview, __source: {
							fileName: _jsxFileName,
							lineNumber: 122
						}
					}),
					dom(TextView, {
						id: _this.id("For_an_eager_learner"),
						height: "150",
						width: "match_parent",
						margin: "2,10,0,0",
						text: _this.STR.For_an_eager_learner33,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_For_an_eager_learner, __source: {
							fileName: _jsxFileName,
							lineNumber: 133
						}
					}),
					dom(TextView, {
						id: _this.id("The_app_will_allow_l"),
						height: "180",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.The_app_will_allow_l34,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_The_app_will_allow_l, __source: {
							fileName: _jsxFileName,
							lineNumber: 145
						}
					}),
					dom(TextView, {
						id: _this.id("App_Features"),
						height: "30",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.App_Features35,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_App_Features, __source: {
							fileName: _jsxFileName,
							lineNumber: 157
						}
					}),
					dom(TextView, {
						id: _this.id("Register100000000ø"),
						height: "30",
						width: "match_parent",
						margin: "2,10,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Register100000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 169
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Ug2"),
							height: "60",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_Ug2, __source: {
								fileName: _jsxFileName,
								lineNumber: 181
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet"),
								height: "8",
								width: "8",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet, __source: {
									fileName: _jsxFileName,
									lineNumber: 188
								}
							},
							dom(ImageView, {
								id: _this.id("Group200000000ø"),
								height: "8",
								width: "8",
								imageUrl: "group72",
								style: _this.style_Group200000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 196
								}
							})
						),
						dom(TextView, {
							id: _this.id("Get_user_details_lik"),
							height: "60",
							width: "282",
							margin: "10,0,0,0",
							weight: "1",
							text: _this.STR.Get_user_details_lik36,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Get_user_details_lik, __source: {
								fileName: _jsxFileName,
								lineNumber: 203
							}
						})
					),
					dom(
						LinearLayout,
						{
							id: _this.id("Ug1"),
							height: "120",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_Ug1, __source: {
								fileName: _jsxFileName,
								lineNumber: 217
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet300000000ø"),
								height: "8",
								width: "8",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet300000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 224
								}
							},
							dom(ImageView, {
								id: _this.id("Group400000000ø"),
								height: "8",
								width: "8",
								imageUrl: "group73",
								style: _this.style_Group400000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 232
								}
							})
						),
						dom(TextView, {
							id: _this.id("If_user_is_a_learner"),
							height: "120",
							width: "282",
							margin: "10,0,0,0",
							weight: "1",
							text: _this.STR.If_user_is_a_learner37,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_If_user_is_a_learner, __source: {
								fileName: _jsxFileName,
								lineNumber: 239
							}
						})
					),
					dom(TextView, {
						id: _this.id("Explore"),
						height: "25",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.Explore38,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						gravity: "left",
						style: _this.style_Explore, __source: {
							fileName: _jsxFileName,
							lineNumber: 253
						}
					}),
					dom(TextView, {
						id: _this.id("A_learner_can_explor"),
						height: "120",
						width: "match_parent",
						margin: "2,5,0,0",
						text: _this.STR.A_learner_can_explor39,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_A_learner_can_explor, __source: {
							fileName: _jsxFileName,
							lineNumber: 264
						}
					}),
					dom(TextView, {
						id: _this.id("Learn"),
						height: "25",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Learn40,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						gravity: "left",
						style: _this.style_Learn, __source: {
							fileName: _jsxFileName,
							lineNumber: 276
						}
					}),
					dom(TextView, {
						id: _this.id("A_learner_can_commun"),
						height: "90",
						width: "match_parent",
						margin: "2,9,0,0",
						text: _this.STR.A_learner_can_commun41,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_A_learner_can_commun, __source: {
							fileName: _jsxFileName,
							lineNumber: 287
						}
					}),
					dom(TextView, {
						id: _this.id("Tips"),
						height: "30",
						width: "match_parent",
						margin: "2,20,0,0",
						text: _this.STR.Tips42,
						textSize: FontSize.A_18,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_HEAVY,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Tips, __source: {
							fileName: _jsxFileName,
							lineNumber: 299
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("G4"),
							height: "60",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_G4, __source: {
								fileName: _jsxFileName,
								lineNumber: 311
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet500000000ø"),
								height: "8",
								width: "8",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet500000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 318
								}
							},
							dom(ImageView, {
								id: _this.id("Group600000000ø"),
								height: "8",
								width: "8",
								imageUrl: "group74",
								style: _this.style_Group600000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 326
								}
							})
						),
						dom(TextView, {
							id: _this.id("Use_a_hosted_server"),
							height: "60",
							width: "282",
							margin: "10,0,0,0",
							weight: "1",
							text: _this.STR.Use_a_hosted_server43,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Use_a_hosted_server, __source: {
								fileName: _jsxFileName,
								lineNumber: 333
							}
						})
					),
					dom(
						LinearLayout,
						{
							id: _this.id("G1"),
							height: "60",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_G1, __source: {
								fileName: _jsxFileName,
								lineNumber: 347
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet700000000ø"),
								height: "8",
								width: "7",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet700000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 354
								}
							},
							dom(ImageView, {
								id: _this.id("Group800000000ø"),
								height: "8",
								width: "7",
								imageUrl: "group77",
								style: _this.style_Group800000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 362
								}
							})
						),
						dom(TextView, {
							id: _this.id("If_that_is_not_possi"),
							height: "60",
							width: "283",
							margin: "9,0,0,0",
							weight: "1",
							text: _this.STR.If_that_is_not_possi44,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_If_that_is_not_possi, __source: {
								fileName: _jsxFileName,
								lineNumber: 369
							}
						})
					),
					dom(
						LinearLayout,
						{
							id: _this.id("G3"),
							height: "60",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_G3, __source: {
								fileName: _jsxFileName,
								lineNumber: 383
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet900000000ø"),
								height: "8",
								width: "8",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet900000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 390
								}
							},
							dom(ImageView, {
								id: _this.id("Group1000000000ø"),
								height: "8",
								width: "8",
								imageUrl: "group75",
								style: _this.style_Group1000000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 398
								}
							})
						),
						dom(TextView, {
							id: _this.id("Use_websockets_for_i"),
							height: "60",
							width: "282",
							margin: "10,0,0,0",
							weight: "1",
							text: _this.STR.Use_websockets_for_i45,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Use_websockets_for_i, __source: {
								fileName: _jsxFileName,
								lineNumber: 405
							}
						})
					),
					dom(
						LinearLayout,
						{
							id: _this.id("G2"),
							height: "120",
							width: "match_parent",
							orientation: "horizontal",
							margin: "2,10,0,0",
							style: _this.style_G2, __source: {
								fileName: _jsxFileName,
								lineNumber: 419
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("Bullet1100000000ø"),
								height: "8",
								width: "8",
								orientation: "horizontal",
								gravity: "center",
								margin: "0,11,0,0",
								style: _this.style_Bullet1100000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 426
								}
							},
							dom(ImageView, {
								id: _this.id("Group1200000000ø"),
								height: "8",
								width: "8",
								imageUrl: "group76",
								style: _this.style_Group1200000000ø, __source: {
									fileName: _jsxFileName,
									lineNumber: 434
								}
							})
						),
						dom(TextView, {
							id: _this.id("Feel_free_to_design"),
							height: "120",
							width: "282",
							margin: "10,0,0,0",
							weight: "1",
							text: _this.STR.Feel_free_to_design46,
							textSize: FontSize.A_18,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_ROMAN,
							lineHeight: "28px",
							gravity: "left",
							style: _this.style_Feel_free_to_design, __source: {
								fileName: _jsxFileName,
								lineNumber: 441
							}
						})
					),
					dom(
						LinearLayout,
						{
							id: _this.id("Group_3"),
							height: "60",
							width: "200",
							orientation: "vertical",
							padding: "60,14,0,13",
							margin: "2,30,0,0",
							background: Color.A__FFFF0000,
							cornerRadius: "4",
							style: _this.style_Group_3, __source: {
								fileName: _jsxFileName,
								lineNumber: 455
							}
						},
						dom(TextView, {
							id: _this.id("Submit"),
							height: "33",
							width: "80",
							text: _this.STR.Submit47,
							textSize: FontSize.A_24,
							color: FontColor.A__FFFFFFFF,
							fontStyle: Font.AVENIR_BLACK,
							gravity: "left",
							style: _this.style_Submit, __source: {
								fileName: _jsxFileName,
								lineNumber: 465
							}
						})
					),
					dom(LinearLayout, {
						id: _this.id("Rectangle"),
						height: "37",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						margin: "2,5,0,0",
						cornerRadius: "0",
						style: _this.style_Rectangle, __source: {
							fileName: _jsxFileName,
							lineNumber: 476
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return MobileProject;
}(Controller);

;

module.exports = MobileProject;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var MobileProject = function (_View) {
	_inherits(MobileProject, _View);

	function MobileProject(props, children, state) {
		_classCallCheck(this, MobileProject);

		var _this = _possibleConstructorReturn(this, (MobileProject.__proto__ || Object.getPrototypeOf(MobileProject)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_Group_3 = {
			onClick: _this.onClickSubmit.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};
		return _this;
	}

	_createClass(MobileProject, [{
		key: "onClickHome",
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "30", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobileProjectjs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickSubmit",
		value: function onClickSubmit() {
			window.open("https://docs.google.com/forms/d/e/1FAIpQLSfB2DXrYR7RHLdbdEJAE9h5WVb3LV3tIh3aC74A8IwXIF1WZw/viewform", '_blank');
		}
	}]);

	return MobileProject;
}(View);

module.exports = MobileProject;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Mobile/MobilePresto.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;
var EditText = __webpack_require__(0).views.EditText;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(31);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var MobilePresto = function (_Controller) {
	_inherits(MobilePresto, _Controller);

	function MobilePresto(props, children, state) {
		_classCallCheck(this, MobilePresto);

		var _this = _possibleConstructorReturn(this, (MobilePresto.__proto__ || Object.getPrototypeOf(MobilePresto)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 30
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "160",
						width: "match_parent",
						orientation: "vertical",
						padding: "40,31,40,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 40
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "34",
						width: "match_parent",
						imageUrl: "group578",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "63",
						margin: "0,44,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 55
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("Body"),
						height: "2600",
						width: "300",
						orientation: "vertical",
						margin: "0,20,0,0",
						cornerRadius: "0",
						style: _this.style_Body, __source: {
							fileName: _jsxFileName,
							lineNumber: 67
						}
					},
					dom(TextView, {
						id: _this.id("Presto_"),
						height: "40",
						width: "match_parent",
						text: _this.STR.Presto_21,
						textSize: FontSize.A_32,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_Presto_, __source: {
							fileName: _jsxFileName,
							lineNumber: 75
						}
					}),
					dom(TextView, {
						id: _this.id("Pure_functional_appl"),
						height: "120",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Pure_functional_appl48,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_Pure_functional_appl, __source: {
							fileName: _jsxFileName,
							lineNumber: 86
						}
					}),
					dom(ImageView, {
						id: _this.id("Hero_Image"),
						height: "150",
						width: "match_parent",
						margin: "0,40,0,0",
						imageUrl: "heroimage80",
						style: _this.style_Hero_Image, __source: {
							fileName: _jsxFileName,
							lineNumber: 98
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Prestofloow"),
							height: "203",
							width: "match_parent",
							orientation: "vertical",
							margin: "0,80,0,0",
							style: _this.style_Prestofloow, __source: {
								fileName: _jsxFileName,
								lineNumber: 105
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "4,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line, __source: {
								fileName: _jsxFileName,
								lineNumber: 112
							}
						}),
						dom(TextView, {
							id: _this.id("Presto_Flow"),
							height: "50",
							width: "match_parent",
							margin: "0,30,0,0",
							text: _this.STR.Presto_Flow49,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Presto_Flow, __source: {
								fileName: _jsxFileName,
								lineNumber: 120
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("GroupQuickstart"),
								height: "31",
								width: "185",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_GroupQuickstart, __source: {
									fileName: _jsxFileName,
									lineNumber: 132
								}
							},
							dom(ImageView, {
								id: _this.id("Gr"),
								height: "31",
								width: "30",
								imageUrl: "gr81",
								style: _this.style_Gr, __source: {
									fileName: _jsxFileName,
									lineNumber: 139
								}
							}),
							dom(TextView, {
								id: _this.id("Quick_St"),
								height: "30",
								width: "143",
								margin: "12,1,0,0",
								weight: "1",
								text: _this.STR.Quick_Start50,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Quick_St, __source: {
									fileName: _jsxFileName,
									lineNumber: 145
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("Gitbub_button"),
								height: "30",
								width: "155",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_Gitbub_button, __source: {
									fileName: _jsxFileName,
									lineNumber: 158
								}
							},
							dom(ImageView, {
								id: _this.id("GitHub_Mar"),
								height: "30",
								width: "30",
								imageUrl: "githubmar82",
								style: _this.style_GitHub_Mar, __source: {
									fileName: _jsxFileName,
									lineNumber: 165
								}
							}),
							dom(TextView, {
								id: _this.id("View_Co"),
								height: "30",
								width: "115",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.View_Code51,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_View_Co, __source: {
									fileName: _jsxFileName,
									lineNumber: 171
								}
							})
						)
					),
					dom(TextView, {
						id: _this.id("Code_business_flows"),
						height: "120",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Code_business_flows52,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "30px",
						gravity: "left",
						style: _this.style_Code_business_flows, __source: {
							fileName: _jsxFileName,
							lineNumber: 185
						}
					}),
					dom(TextView, {
						id: _this.id("Conversational_Flow"),
						height: "40",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Conversational_Flow53,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Conversational_Flow, __source: {
							fileName: _jsxFileName,
							lineNumber: 197
						}
					}),
					dom(TextView, {
						id: _this.id("Writing_code_is_like"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Writing_code_is_like54,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Writing_code_is_like, __source: {
							fileName: _jsxFileName,
							lineNumber: 209
						}
					}),
					dom(TextView, {
						id: _this.id("Building_Blocks"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Building_Blocks55,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Building_Blocks, __source: {
							fileName: _jsxFileName,
							lineNumber: 221
						}
					}),
					dom(TextView, {
						id: _this.id("Every_system_is_reus"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Every_system_is_reus88,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Every_system_is_reus, __source: {
							fileName: _jsxFileName,
							lineNumber: 233
						}
					}),
					dom(TextView, {
						id: _this.id("Focus_on_Conversion"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Focus_on_Conversion57,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Focus_on_Conversion, __source: {
							fileName: _jsxFileName,
							lineNumber: 245
						}
					}),
					dom(TextView, {
						id: _this.id("Systems_which_have_i"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Systems_which_have_i58,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Systems_which_have_i, __source: {
							fileName: _jsxFileName,
							lineNumber: 257
						}
					}),
					dom(TextView, {
						id: _this.id("Improved_Maintainabi"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Improved_Maintainabi59,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Improved_Maintainabi, __source: {
							fileName: _jsxFileName,
							lineNumber: 269
						}
					}),
					dom(TextView, {
						id: _this.id("Making_development_a"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Making_development_a60,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Making_development_a, __source: {
							fileName: _jsxFileName,
							lineNumber: 281
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("PrestoUioo"),
							height: "203",
							width: "match_parent",
							orientation: "vertical",
							margin: "0,80,0,0",
							style: _this.style_PrestoUioo, __source: {
								fileName: _jsxFileName,
								lineNumber: 293
							}
						},
						dom(LinearLayout, {
							id: _this.id("Line100000000ø"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "4,#ff0000",
							cornerRadius: "0",
							style: _this.style_Line100000000ø, __source: {
								fileName: _jsxFileName,
								lineNumber: 300
							}
						}),
						dom(TextView, {
							id: _this.id("Presto_UI"),
							height: "50",
							width: "match_parent",
							margin: "0,30,0,0",
							text: _this.STR.Presto_UI61,
							textSize: FontSize.A_40,
							color: FontColor.A__FF000000,
							fontStyle: Font.AVENIR_BLACK,
							lineHeight: "42px",
							gravity: "left",
							style: _this.style_Presto_UI, __source: {
								fileName: _jsxFileName,
								lineNumber: 308
							}
						}),
						dom(
							LinearLayout,
							{
								id: _this.id("Group7Quickstart"),
								height: "31",
								width: "185",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_Group7Quickstart, __source: {
									fileName: _jsxFileName,
									lineNumber: 320
								}
							},
							dom(ImageView, {
								id: _this.id("Group_7"),
								height: "31",
								width: "30",
								imageUrl: "group783",
								style: _this.style_Group_7, __source: {
									fileName: _jsxFileName,
									lineNumber: 327
								}
							}),
							dom(TextView, {
								id: _this.id("Quick_Start"),
								height: "30",
								width: "143",
								margin: "12,1,0,0",
								weight: "1",
								text: _this.STR.Quick_Start50,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_Quick_Start, __source: {
									fileName: _jsxFileName,
									lineNumber: 333
								}
							})
						),
						dom(
							LinearLayout,
							{
								id: _this.id("ViewcodeGithubmark"),
								height: "30",
								width: "155",
								orientation: "horizontal",
								margin: "0,30,0,0",
								style: _this.style_ViewcodeGithubmark, __source: {
									fileName: _jsxFileName,
									lineNumber: 346
								}
							},
							dom(ImageView, {
								id: _this.id("GitHub_Mark"),
								height: "30",
								width: "30",
								imageUrl: "githubmark84",
								style: _this.style_GitHub_Mark, __source: {
									fileName: _jsxFileName,
									lineNumber: 353
								}
							}),
							dom(TextView, {
								id: _this.id("View_Code"),
								height: "30",
								width: "115",
								margin: "10,0,0,0",
								weight: "1",
								text: _this.STR.View_Code51,
								textSize: FontSize.A_22,
								color: FontColor.A__FFFF0000,
								fontStyle: Font.AVENIR_HEAVY,
								gravity: "left",
								style: _this.style_View_Code, __source: {
									fileName: _jsxFileName,
									lineNumber: 359
								}
							})
						)
					),
					dom(TextView, {
						id: _this.id("Generate_UI_Code_dir"),
						height: "120",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Generate_UI_Code_dir89,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "30px",
						gravity: "left",
						style: _this.style_Generate_UI_Code_dir, __source: {
							fileName: _jsxFileName,
							lineNumber: 373
						}
					}),
					dom(TextView, {
						id: _this.id("Single_Source_Code"),
						height: "40",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Single_Source_Code63,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Single_Source_Code, __source: {
							fileName: _jsxFileName,
							lineNumber: 385
						}
					}),
					dom(TextView, {
						id: _this.id("Design_once_and_have"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Design_once_and_have64,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Design_once_and_have, __source: {
							fileName: _jsxFileName,
							lineNumber: 397
						}
					}),
					dom(TextView, {
						id: _this.id("Full_Control"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Full_Control65,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Full_Control, __source: {
							fileName: _jsxFileName,
							lineNumber: 409
						}
					}),
					dom(TextView, {
						id: _this.id("Change_the_UI_withou"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Change_the_UI_withou66,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Change_the_UI_withou, __source: {
							fileName: _jsxFileName,
							lineNumber: 421
						}
					}),
					dom(TextView, {
						id: _this.id("Syntax"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Syntax67,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Syntax, __source: {
							fileName: _jsxFileName,
							lineNumber: 433
						}
					}),
					dom(TextView, {
						id: _this.id("Inspired_by_Android"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Inspired_by_Android68,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Inspired_by_Android, __source: {
							fileName: _jsxFileName,
							lineNumber: 445
						}
					}),
					dom(TextView, {
						id: _this.id("Quick_Development"),
						height: "40",
						width: "match_parent",
						margin: "0,20,0,0",
						text: _this.STR.Quick_Development69,
						textSize: FontSize.A_26,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_MEDIUM,
						lineHeight: "42px",
						gravity: "left",
						style: _this.style_Quick_Development, __source: {
							fileName: _jsxFileName,
							lineNumber: 457
						}
					}),
					dom(TextView, {
						id: _this.id("Auto_generate_UI_cod"),
						height: "60",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Auto_generate_UI_cod70,
						textSize: FontSize.A_20,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "28px",
						gravity: "left",
						style: _this.style_Auto_generate_UI_cod, __source: {
							fileName: _jsxFileName,
							lineNumber: 469
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Line_4"),
						height: "2",
						width: "match_parent",
						background: Color.A__FFD7D7D7,
						stroke: "4,#ff0000",
						margin: "0,50,0,0",
						cornerRadius: "0",
						style: _this.style_Line_4, __source: {
							fileName: _jsxFileName,
							lineNumber: 481
						}
					}),
					dom(TextView, {
						id: _this.id("Get_the_latest_Prest"),
						height: "60",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Get_the_latest_Prest71,
						textSize: FontSize.A_18,
						color: FontColor.A__FF4A494A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Get_the_latest_Prest, __source: {
							fileName: _jsxFileName,
							lineNumber: 490
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("Group"),
							height: "36",
							width: "match_parent",
							orientation: "vertical",
							gravity: "center_horizontal",
							margin: "0,20,0,0",
							style: _this.style_Group, __source: {
								fileName: _jsxFileName,
								lineNumber: 501
							}
						},
						dom(
							LinearLayout,
							{
								id: _this.id("YouremailaddressNoun_1358889_cc"),
								height: "25",
								width: "match_parent",
								orientation: "horizontal",
								style: _this.style_YouremailaddressNoun_1358889_cc, __source: {
									fileName: _jsxFileName,
									lineNumber: 509
								}
							},
							dom(ImageView, {
								id: _this.id("Noun_1358889_cc"),
								height: "20",
								width: "34",
								margin: "0,4,0,0",
								imageUrl: "noun_1358889_cc85",
								style: _this.style_Noun_1358889_cc, __source: {
									fileName: _jsxFileName,
									lineNumber: 515
								}
							}),
							dom(EditText, {
								id: _this.id("Your_email_address"),
								height: "25",
								width: "248",
								margin: "18,0,0,0",
								weight: "1",
								textSize: FontSize.A_18,
								color: FontColor.A__FFCCCCCC,
								fontStyle: Font.AVENIR_ROMAN,
								gravity: "left",
								hint: _this.STR.Your_email_address72,
								background: "#ffffff",
								padding: "0,0,0,0",
								style: _this.style_Your_email_address, __source: {
									fileName: _jsxFileName,
									lineNumber: 522
								}
							})
						),
						dom(LinearLayout, {
							id: _this.id("Line_3"),
							height: "2",
							width: "match_parent",
							background: Color.A__FFD7D7D7,
							stroke: "1,#ff0000",
							margin: "0,9,0,0",
							cornerRadius: "0",
							style: _this.style_Line_3, __source: {
								fileName: _jsxFileName,
								lineNumber: 537
							}
						})
					),
					dom(TextView, {
						id: _this.id("Subscribe"),
						height: "30",
						width: "101",
						margin: "0,20,0,0",
						text: _this.STR.Subscribe73,
						textSize: FontSize.A_22,
						color: FontColor.A__FFFF0000,
						fontStyle: Font.AVENIR_HEAVY,
						gravity: "left",
						style: _this.style_Subscribe, __source: {
							fileName: _jsxFileName,
							lineNumber: 547
						}
					}),
					dom(LinearLayout, {
						id: _this.id("Rectangle_2"),
						height: "39",
						width: "match_parent",
						background: Color.A__FFFFFFFF,
						margin: "0,7,0,0",
						cornerRadius: "0",
						style: _this.style_Rectangle_2, __source: {
							fileName: _jsxFileName,
							lineNumber: 558
						}
					})
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return MobilePresto;
}(Controller);

;

module.exports = MobilePresto;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var __this = void 0;

var MobilePresto = function (_View) {
	_inherits(MobilePresto, _View);

	function MobilePresto(props, children, state) {
		_classCallCheck(this, MobilePresto);

		var _this = _possibleConstructorReturn(this, (MobilePresto.__proto__ || Object.getPrototypeOf(MobilePresto)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		__this = _this;

		_this.setIds(['Content', 'Subscribe', 'Your_email_address', 'Get_the_latest_Prest']);

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_GroupQuickstart = {
			onClick: _this.onClickQuickStartFlow.bind(_this)
		};

		_this.style_Gitbub_button = {
			onClick: _this.onClickViewCodeFlow.bind(_this)
		};

		_this.style_Group7Quickstart = {
			onClick: _this.onClickQuickStartUI.bind(_this)
		};

		_this.style_ViewcodeGithubmark = {
			onClick: _this.onClickViewCodeUI.bind(_this)
		};

		_this.style_Subscribe = {
			onClick: _this.onClickSubscribe.bind(_this)
		};

		_this.style_Your_email_address = {
			onChange: _this.onChangeEmail.bind(_this)
		};

		_this.style_Group_5 = {
			onClick: _this.onClickHome.bind(_this)
		};
		return _this;
	}

	_createClass(MobilePresto, [{
		key: 'onClickHome',
		value: function onClickHome() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, '50', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileHome2" });else window.__duiShowScreen(null, { screen: "Home2" });
		}
	}, {
		key: 'onClickForum',
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: 'onChangeEmail',
		value: function onChangeEmail(data) {
			this.email = data;
		}
	}, {
		key: 'onClickQuickStartFlow',
		value: function onClickQuickStartFlow() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/install.html", '_blank');
		}
	}, {
		key: 'onClickViewCodeFlow',
		value: function onClickViewCodeFlow() {
			window.open("https://github.com/juspay/purescript-presto", '_blank');
		}
	}, {
		key: 'onClickQuickStartUI',
		value: function onClickQuickStartUI() {
			window.open("https://juspay.gitbooks.io/presto-guide/content/presto-ui/", '_blank');
		}
	}, {
		key: 'onClickViewCodeUI',
		value: function onClickViewCodeUI() {
			window.open("https://github.com/juspay/presto-ui", '_blank');
		}
	}, {
		key: 'onClickSubscribe',
		value: function onClickSubscribe() {
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.responseText);
						if (response.status == "SUCCESS") {
							var cmd = __this.cmd({ id: __this.idSet.Your_email_address, text: "" });
							Android.runInUI(cmd, null, '91', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Subscribe600000000ø, text: "Subscribed", color: "#AA000000", clickable: "false" });
							Android.runInUI(cmd, null, '93', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "We will keep you posted." });
							Android.runInUI(cmd, null, '95', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
							__this.email = "0";
						}
					} else if (this.readyState == 4 && this.status == 500) {
						var _response = JSON.parse(this.responseText);
						if (_response.status == "FAILURE" && _response.errorCode == 2) {
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Sorry, Try Again." });
							Android.runInUI(cmd, null, '102', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
						}
					} else if (this.readyState == 4 && this.status == 400) {
						var _response2 = JSON.parse(this.responseText);
						if (_response2.status == "FAILURE" && _response2.errorCode == 1) {
							var cmd = __this.cmd({ id: __this.idSet.Your_email_address, text: "" });
							Android.runInUI(cmd, null, '108', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
							var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "This email is already registered." });
							Android.runInUI(cmd, null, '110', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
						}
					}
				};

				xhttp.onloadend = function () {
					if (xhttp.status != 200) {
						var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Oops, unable to reach our server" });
						Android.runInUI(cmd, null, '118', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
					}
				};

				xhttp.open("GET", "/insertEmail?email=" + this.email, true);
				xhttp.send();
			} else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) && this.email != "0") {
				var cmd = __this.cmd({ id: __this.idSet.Get_the_latest_Prest, text: "Not a Valid E-mail..." });
				Android.runInUI(cmd, null, '127', 'UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobilePrestojs');
			}
		}
	}]);

	return MobilePresto;
}(View);

module.exports = MobilePresto;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsxFileName = "/Users/ronak.jain/Juspay/juspay-university/JusUni/views/Mobile/MobileHome2.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;
var dom = __webpack_require__(0).doms;

var LinearLayout = __webpack_require__(0).views.LinearLayout;
var ImageView = __webpack_require__(0).views.ImageView;
var TextView = __webpack_require__(0).views.TextView;

var Config = __webpack_require__(1);
var Controller = __webpack_require__(33);
var Strings = __webpack_require__(2);
var Accessibility = __webpack_require__(3);
var Font = __webpack_require__(4);
var Color = __webpack_require__(5);
var FontSize = __webpack_require__(6);
var FontColor = __webpack_require__(7);

var MobileHome2 = function (_Controller) {
	_inherits(MobileHome2, _Controller);

	function MobileHome2(props, children, state) {
		_classCallCheck(this, MobileHome2);

		var _this = _possibleConstructorReturn(this, (MobileHome2.__proto__ || Object.getPrototypeOf(MobileHome2)).call(this, props, children, state));

		_this.onPop = function () {};

		_this.render = function () {
			_this.layout = dom(
				LinearLayout,
				{
					id: _this.id("Content"),
					height: "match_parent",
					width: "match_parent",
					orientation: "vertical",
					gravity: "center_horizontal",
					background: Color.A__FFFFFFFF,
					cornerRadius: "0",
					root: true,
					style: _this.style_Content, __source: {
						fileName: _jsxFileName,
						lineNumber: 29
					}
				},
				dom(
					LinearLayout,
					{
						id: _this.id("Header"),
						height: "226",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "30,31,30,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 39
						}
					},
					dom(ImageView, {
						id: _this.id("Group_5"),
						height: "33",
						width: "match_parent",
						margin: "10,0,10,0",
						imageUrl: "group592",
						style: _this.style_Group_5, __source: {
							fileName: _jsxFileName,
							lineNumber: 49
						}
					}),
					dom(TextView, {
						id: _this.id("Register"),
						height: "25",
						width: "match_parent",
						margin: "0,44,0,0",
						text: _this.STR.Register1,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Register, __source: {
							fileName: _jsxFileName,
							lineNumber: 56
						}
					}),
					dom(TextView, {
						id: _this.id("Forum"),
						height: "25",
						width: "match_parent",
						margin: "0,30,0,0",
						text: _this.STR.Forum2,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "left",
						style: _this.style_Forum, __source: {
							fileName: _jsxFileName,
							lineNumber: 67
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("HeroGroup"),
						height: "835",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "20,0,20,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_HeroGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 79
						}
					},
					dom(TextView, {
						id: _this.id("HeroHeaderText"),
						height: "72",
						width: "match_parent",
						text: _this.STR.Hero_Epic75,
						textSize: FontSize.A_28,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "36px",
						gravity: "left",
						style: _this.style_HeroHeaderText, __source: {
							fileName: _jsxFileName,
							lineNumber: 89
						}
					}),
					dom(ImageView, {
						id: _this.id("JuspayVideo"),
						height: "319",
						width: "match_parent",
						margin: "0,30,0,0",
						imageUrl: "juspayvideo86",
						style: _this.style_JuspayVideo, __source: {
							fileName: _jsxFileName,
							lineNumber: 100
						}
					}),
					dom(TextView, {
						id: _this.id("HeroHelpText"),
						height: "256",
						width: "match_parent",
						margin: "0,26,0,0",
						text: _this.STR.Section_body76,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.ROBOTOMONO_REGULAR,
						lineHeight: "32px",
						gravity: "left",
						style: _this.style_HeroHelpText, __source: {
							fileName: _jsxFileName,
							lineNumber: 107
						}
					}),
					dom(TextView, {
						id: _this.id("LetsStartLink"),
						height: "32",
						width: "match_parent",
						margin: "0,40,0,0",
						text: _this.STR.Jump_in___get_starte77,
						textSize: FontSize.A_18,
						color: FontColor.A__FFEE0000,
						fontStyle: Font.ROBOTOMONO_BOLD,
						lineHeight: "32px",
						gravity: "left",
						style: _this.style_LetsStartLink, __source: {
							fileName: _jsxFileName,
							lineNumber: 119
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("PrestoSectionGroup"),
						height: "1112",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "0,60,0,0",
						background: Color.A__FFF7F7F7,
						cornerRadius: "0",
						style: _this.style_PrestoSectionGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 132
						}
					},
					dom(TextView, {
						id: _this.id("Presto_Section_Header"),
						height: "108",
						width: "match_parent",
						margin: "20,0,20,0",
						text: _this.STR.PrestoSectionText78,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "36px",
						gravity: "center",
						style: _this.style_Presto_Section_Header, __source: {
							fileName: _jsxFileName,
							lineNumber: 142
						}
					}),
					dom(TextView, {
						id: _this.id("Hero_Story"),
						height: "576",
						width: "match_parent",
						margin: "20,30,20,0",
						text: _this.STR.Hero_Story90,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.ROBOTOMONO_REGULAR,
						lineHeight: "32px",
						gravity: "center",
						style: _this.style_Hero_Story, __source: {
							fileName: _jsxFileName,
							lineNumber: 154
						}
					}),
					dom(ImageView, {
						id: _this.id("BHIM_Logo"),
						height: "18",
						width: "90",
						margin: "0,28,0,0",
						imageUrl: "bhimlogo87",
						style: _this.style_BHIM_Logo, __source: {
							fileName: _jsxFileName,
							lineNumber: 166
						}
					}),
					dom(TextView, {
						id: _this.id("Hero_Story_Copy"),
						height: "32",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Hero_Story_Copy91,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "32px",
						gravity: "center",
						style: _this.style_Hero_Story_Copy, __source: {
							fileName: _jsxFileName,
							lineNumber: 173
						}
					}),
					dom(ImageView, {
						id: _this.id("Juspay_Safe"),
						height: "22",
						width: "124",
						margin: "0,30,0,0",
						imageUrl: "juspaysafe88",
						style: _this.style_Juspay_Safe, __source: {
							fileName: _jsxFileName,
							lineNumber: 185
						}
					}),
					dom(TextView, {
						id: _this.id("Hero_Story_Copy_2"),
						height: "32",
						width: "match_parent",
						margin: "0,10,0,0",
						text: _this.STR.Hero_Story_Copy_292,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "32px",
						gravity: "center",
						style: _this.style_Hero_Story_Copy_2, __source: {
							fileName: _jsxFileName,
							lineNumber: 192
						}
					}),
					dom(ImageView, {
						id: _this.id("Logo"),
						height: "23",
						width: "74",
						margin: "0,31,0,0",
						imageUrl: "logo89",
						style: _this.style_Logo, __source: {
							fileName: _jsxFileName,
							lineNumber: 204
						}
					}),
					dom(TextView, {
						id: _this.id("Hero_Story_Copy_2100000000ø"),
						height: "32",
						width: "match_parent",
						margin: "0,9,0,0",
						text: _this.STR.Hero_Story_Copy_293,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.AVENIR_ROMAN,
						lineHeight: "32px",
						gravity: "center",
						style: _this.style_Hero_Story_Copy_2100000000ø, __source: {
							fileName: _jsxFileName,
							lineNumber: 211
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("WhatCourseSectionGroup"),
						height: "1006",
						width: "match_parent",
						orientation: "vertical",
						padding: "0,60,0,0",
						background: Color.A__FFFFFFFF,
						cornerRadius: "0",
						style: _this.style_WhatCourseSectionGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 224
						}
					},
					dom(TextView, {
						id: _this.id("PrestoSectionHeaderText"),
						height: "72",
						width: "320",
						margin: "20,0,0,0",
						text: _this.STR.WhatCourseText81,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_BLACK,
						lineHeight: "36px",
						gravity: "center",
						style: _this.style_PrestoSectionHeaderText, __source: {
							fileName: _jsxFileName,
							lineNumber: 233
						}
					}),
					dom(TextView, {
						id: _this.id("CurriculumHeaderText"),
						height: "33",
						width: "match_parent",
						margin: "0,50,0,0",
						text: _this.STR.CurriculumText82,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "center",
						style: _this.style_CurriculumHeaderText, __source: {
							fileName: _jsxFileName,
							lineNumber: 245
						}
					}),
					dom(ImageView, {
						id: _this.id("CurriculumIcon"),
						height: "35",
						width: "47",
						margin: "157,19,0,0",
						imageUrl: "curriculumicon90",
						style: _this.style_CurriculumIcon, __source: {
							fileName: _jsxFileName,
							lineNumber: 256
						}
					}),
					dom(TextView, {
						id: _this.id("CurriculumHelpText"),
						height: "352",
						width: "320",
						margin: "20,30,0,0",
						text: _this.STR.CurriculumHelpText83,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.ROBOTOMONO_REGULAR,
						lineHeight: "32px",
						gravity: "left",
						style: _this.style_CurriculumHelpText, __source: {
							fileName: _jsxFileName,
							lineNumber: 263
						}
					}),
					dom(TextView, {
						id: _this.id("ProjectHeaderText"),
						height: "33",
						width: "match_parent",
						margin: "0,50,0,0",
						text: _this.STR.Project31,
						textSize: FontSize.A_24,
						color: FontColor.A__FF000000,
						fontStyle: Font.AVENIR_ROMAN,
						gravity: "center",
						style: _this.style_ProjectHeaderText, __source: {
							fileName: _jsxFileName,
							lineNumber: 275
						}
					}),
					dom(ImageView, {
						id: _this.id("ProjectIcon"),
						height: "35",
						width: "35",
						margin: "163,19,0,0",
						imageUrl: "projecticon91",
						style: _this.style_ProjectIcon, __source: {
							fileName: _jsxFileName,
							lineNumber: 286
						}
					}),
					dom(TextView, {
						id: _this.id("PrjectHelpText"),
						height: "128",
						width: "320",
						margin: "20,30,0,0",
						text: _this.STR.ProjectHelpText84,
						textSize: FontSize.A_18,
						color: FontColor.A__FF3A3A3A,
						fontStyle: Font.ROBOTOMONO_REGULAR,
						lineHeight: "32px",
						gravity: "left",
						style: _this.style_PrjectHelpText, __source: {
							fileName: _jsxFileName,
							lineNumber: 293
						}
					})
				),
				dom(
					LinearLayout,
					{
						id: _this.id("FooterGroup"),
						height: "320",
						width: "match_parent",
						orientation: "vertical",
						gravity: "center_horizontal",
						padding: "20,49,20,0",
						background: Color.A__FFEE0000,
						cornerRadius: "0",
						style: _this.style_FooterGroup, __source: {
							fileName: _jsxFileName,
							lineNumber: 306
						}
					},
					dom(TextView, {
						id: _this.id("SoundsText"),
						height: "120",
						width: "match_parent",
						text: _this.STR.SoundsText94,
						textSize: FontSize.A_18,
						color: FontColor.A__FFFFFFFF,
						fontStyle: Font.ROBOTOMONO_BOLD,
						lineHeight: "40px",
						gravity: "left",
						style: _this.style_SoundsText, __source: {
							fileName: _jsxFileName,
							lineNumber: 316
						}
					}),
					dom(
						LinearLayout,
						{
							id: _this.id("LetsStartButton"),
							height: "60",
							width: "match_parent",
							orientation: "vertical",
							padding: "0,14,0,13",
							margin: "0,40,0,0",
							background: Color.A__FFFFFFFF,
							cornerRadius: "4",
							style: _this.style_LetsStartButton, __source: {
								fileName: _jsxFileName,
								lineNumber: 327
							}
						},
						dom(TextView, {
							id: _this.id("Let_s_Start"),
							height: "33",
							width: "match_parent",
							text: _this.STR.Let_s_Start95,
							textSize: FontSize.A_24,
							color: FontColor.A__FFEE0000,
							fontStyle: Font.AVENIR_HEAVY,
							gravity: "center",
							style: _this.style_Let_s_Start, __source: {
								fileName: _jsxFileName,
								lineNumber: 337
							}
						})
					)
				)
			);
			_this.containerId = _this.layout.idSet.id;
			return _this.layout.render();
		};

		_this.STR = Strings();
		_this.HINT = Accessibility();
		return _this;
	}

	return MobileHome2;
}(Controller);

;

module.exports = MobileHome2;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = __webpack_require__(0).baseView;

var MobileHome2 = function (_View) {
	_inherits(MobileHome2, _View);

	function MobileHome2(props, children, state) {
		_classCallCheck(this, MobileHome2);

		var _this = _possibleConstructorReturn(this, (MobileHome2.__proto__ || Object.getPrototypeOf(MobileHome2)).call(this, props, children, state));

		_this.shouldCacheScreen = false;

		_this.setIds(['Content']);

		_this.style_Register = {
			onClick: _this.onClickRegister.bind(_this)
		};

		_this.style_Forum = {
			onClick: _this.onClickForum.bind(_this)
		};

		_this.style_LetsStartLink = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_LetsStartButton = {
			onClick: _this.onClickLetsStart.bind(_this)
		};

		_this.style_JuspayVideo = {
			onClick: _this.onClickVideo.bind(_this)
		};
		return _this;
	}

	_createClass(MobileHome2, [{
		key: "onClickLetsStart",
		value: function onClickLetsStart() {
			var cmd = this.cmd({ id: this.idSet.Content, visibility: "gone" });
			Android.runInUI(cmd, null, "34", "UsersronakjainJuspayjuspayuniversityJusUnicontrollerpagesMobileMobileHomejs");
			document.getElementById("content").scrollTo(0, 0);

			if (window.__WIDTH <= 600) window.__duiShowScreen(null, { screen: "MobileSFP" });else window.__duiShowScreen(null, { screen: "SFP" });
		}
	}, {
		key: "onClickRegister",
		value: function onClickRegister() {
			window.open("https://form.jotform.co/73251234628858", '_blank');
		}
	}, {
		key: "onClickForum",
		value: function onClickForum() {
			window.open("https://muut.com/purescript-presto", '_blank');
		}
	}, {
		key: "onClickVideo",
		value: function onClickVideo() {
			window.open("https://www.youtube.com/watch?v=ffzzXQI_i5s&feature=youtu.be", '_blank');
		}
	}]);

	return MobileHome2;
}(View);

module.exports = MobileHome2;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {"Main":["Home","Home2","Presto","Project","SFP"],"Mobile":["MobileHome","MobileHome2","MobilePresto","MobileProject","MobileSFP"]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index_bundle.js